{
  "common": {
    "btn": {
      "create": "Create",
      "create-new": "Create New",
      "create-account": "Create account",
      "later": "Later",
      "add": "Add",
      "clone": "Clone",
      "clone-resource": "Clone",
      "renew": "Renew",
      "update": "Update",
      "confirm": "Confirm",
      "submit": "Submit",
      "sign-in": "Sign in",
      "edit": "Edit",
      "delete": "Delete",
      "new-record": "New record",
      "generate": "Generate",
      "close": "Close",
      "cancel": "Cancel",
      "manage": "Manage",
      "print": "Print",
      "download": "Download",
      "action": {
        "label": "Actions",
        "option": {
          "view": "View details",
          "edit": "Edit",
          "delete": "Delete",
          "manage": "Manage"
        }
      }
    },
    "main-header": {
      "edit-profile": "Edit profile",
      "change-pwd": "Change password",
      "sign-out": "Sign out",
      "admin-setting": "Admin settings"
    },
    "footer": {
      "privacy": "Privacy",
      "term": "Terms",
      "support": "Supports",
      "feedback": "Feedback"
    },
    "aiml-app": {
      "main-header": {
        "my-task": "My tasks",
        "my-applications": "My applications"
      },
      "sub-header1": {
        "title": "All apps"
      }
    },
    "required": "Required",
    "confirmation": "Confirmation",
    "a11y": {
      "loading": "Loading…"
    },
    "delete-message-one-item": "Delete an item of {entity_name}? This action cannot be reversed.",
    "delete-message-multiple-items": "Delete {selected_item_count} items of {entity_name}? This action cannot be reversed."
  },
  "public": {
    "sing-in": {
      "header": "Sign in to OptimalHR",
      "email": "Email",
      "password": "Password"
    },
    "register": {
      "header": "Register new tenant",
      "first-name": {
        "label": "First name",
        "description": "Your given name"
      },
      "last-name": {
        "label": "Last name",
        "description": "Your family name"
      },
      "email": {
        "label": "Email",
        "description": "Your working email address",
        "error-message-invalid-email": "This email is invalid. Please use another valid email address.",
        "error-message-email-already-exits": "This email is already used in AIML Apps. Please use another valid email address.",
        "error-message-no-email": "A valid email address is required"
      },
      "organization": {
        "label": "Organization",
        "description": "Your tenant's name. This could be the name of your business, school, nonprofit organization, etc."
      },
      "process": {
        "header": "Successfully created new tenant",
        "title": "OptimalHR is creating system resources required for your tenant's identity and isolation. This may take a moment.",
        "create-user-and-identity-directory": "Creating user and identity pools.",
        "create-policy-and-role": "Creating policies and roles.",
        "apply-policy-and-role": "Applying policies to roles.",
        "create-admin-user-and-tenant-records": "Creating admin user and other records necessary for your tenant to start using the system.",
        "message": "Your login information sent to {email_address}",
        "back": "Go to",
        "login-screen": "Login screen"
      }
    },
    "confirm-tenant": {
      "main-title": "Congratulations on your successful login!",
      "description": "Please change your password before proceeding.",
      "current-password": {
        "title": "Current password",
        "description": "The temporary password sent to your email."
      },
      "new-password": {
        "title": "New password",
        "description": "Minimum password length is 8. Required uppercase letters, lowercase letters and numbers."
      },
      "confirm-password": {
        "title": "Confirm new password",
        "description": "Repeat your new password."
      },
      "error-messaga": {
        "pwd-not-match": "Passwords do not match.",
        "pwd-required": "Current, new, and confirm passwords are required. Please enter these values.",
        "pwd-required-type": "Password must contain uppercase letters, lowercase letters, numbers and 8 characters minimum."
      }
    },
    "change-pwd": {
      "main-title": "Change password",
      "description": " ",
      "current-pwd": {
        "title": "Current password",
        "description": " "
      },
      "new-pwd": {
        "title": "New password",
        "description": "Minimum password length is 8. Required uppercase letters, lowercase letters and numbers."
      },
      "confirm-pwd": {
        "title": "Confirm new password",
        "description": "Repeat your new password."
      },
      "error-messaga": {
        "pwd-not-match": "Passwords do not match.",
        "pwd-required": "Current, new, and confirm passwords are required. Please enter these values.",
        "pwd-required-type": "Password must contain uppercase letters, lowercase letters, numbers and 8 characters minimum."
      }
    },
    "edit-profile": {
      "main-title": "Edit profile",
      "description": " ",
      "first-name": "First name",
      "last-name": "Last name"
    }
  },
  "aimlApp": {
    "my-tasks": {
      "main-header": "My tasks",
      "placeholder-search": "Search tasks by name"
    },
    "my-applications": {
      "main-header": "My applications",
      "placeholder-search": "Search apps by name",
      "all-apps": {
        "title": "All apps",
        "group-human-capital-management": "Human Capital Managment",
        "group-administration": "Administration"
      },
      "recently-visited": {
        "title": "Recently visited apps"
      }
    }
  },
  "acm": {
    "messageProvisionedResources": {
      "header": "",
      "message": ""
    },
    "user": {
      "list": {
        "main-title": "Users",
        "filter-box-placeholder": "Filter by user name, first name, last name, ...",
        "description": " ",
        "table-name": "user",
        "table-header": {
          "user-name": "User name",
          "first-name": "First name",
          "last-name": "Last name",
          "role": "Role",
          "create-at": "Created at",
          "create-by": "Created by"
        },
        "filter-key": {
          "user-name": "Filter by User name",
          "first-name": "Filter by First name",
          "last-name": "Filter by Last name",
          "role": "Filter by Role"
        }
      },
      "form": {
        "main-title-create": "Create new user",
        "main-title-edit": "Edit user",
        "description": "",
        "user-identity": {
          "title": "User identity",
          "user-name": {
            "label": "User name",
            "description": "",
            "placeholder": "Must be a valid email address"
          },
          "first-name": {
            "label": "First name",
            "description": " ",
            "placeholder": "For example, Bopha"
          },
          "last-name": {
            "label": "Last name",
            "description": "",
            "placeholder": "For example, CHAN"
          },
          "line-employee": {
            "label": "Linked employee",
            "description": "",
            "placeholder": ""
          }
        },
        "user-permission": {
          "title": "User permission",
          "system-base-role": {
            "label": "System based role",
            "tenant-user": "Tenant user",
            "tenant-admin": "Tenant admin(administers other users)",
            "description": ""
          },
          "job-base-role": {
            "label": "Job based role",
            "description": "",
            "placeholder": "Select an existing role for this user"
          },
          "policy": {
            "label": "Policy",
            "description": "",
            "placeholder": "Select existing policies defining permissions for those users"
          }
        }
      },
      "detail": {
        "main-title": "User details",
        "description": "",
        "user-identity": {
          "title": "User identity",
          "user-name": "User name",
          "first-name": "First name",
          "last-name": "Last name",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "permission": {
          "title": "User permission",
          "system-based-role": "System based role",
          "job-based-role": "Job based role",
          "policies": "Policies"
        }
      }
    },
    "policy": {
      "list": {
        "main-title": "Policies",
        "filter-box-placeholder": "Filter by policy name",
        "description": " ",
        "table-name": "policy",
        "table-header": {
          "name": "Name",
          "statements": "Statements",
          "created-at": "Created at",
          "updated-at": "Updated at"
        },
        "filter-key": {
          "name": "Filter by policy name"
        }
      },
      "form": {
        "main-title-create": "Create policy",
        "main-title-edit": "Edit policy",
        "description": "",
        "general-info": {
          "title": "General information",
          "name": {
            "label": "Name",
            "description": "",
            "placeholder": "For example, HR Assistant"
          }
        },
        "statements": {
          "title": "Statements",
          "discription": "A policy statement defines a set of permissions used to a assign to a either a Role, User or User Group. A policy can have multiple statements, e.g. Statement 1 define permissions to access resources under Directory service while Statement 2 is for Employees service",
          "statement-name": {
            "label": "Statement name",
            "description": "",
            "placeholder": "E.g. Directory Service"
          },
          "serviec-name": {
            "label": "Service name",
            "description": "",
            "placeholder": "Select the service to which you want to have access control"
          },
          "resources": {
            "label": "Resources",
            "description": "",
            "placeholder": "Select those resource(s) to which you want to have access control"
          },
          "action": {
            "label": "Actions",
            "description": "",
            "placeholder": "Select those action(operations) to include in this statement"
          },
          "effect": {
            "label": "Effect",
            "description": "Specify whether to Allow or Deny above Actions/Operations under this statement",
            "allow": "Allow",
            "deny": "Deny"
          }
        }
      },
      "detail": {
        "main-title": "Policy details",
        "description": " ",
        "general-info": {
          "title": "Gerneral information",
          "policy-type": "Policy type",
          "policy-name": "Policy name",
          "created-at": "Created at",
          "updated-at": "Updated at"
        },
        "statement": {
          "title": "Statements",
          "name": "Name",
          "service": "Service",
          "details": {
            "view-detail": "View details",
            "title": "Statement details",
            "name": "Name",
            "service": "Service",
            "effect": "Effect",
            "resources": "Resources",
            "actions": "Actions"
          }
        }
      }
    },
    "role": {
      "list": {
        "main-title": "Roles",
        "filter-box-placeholder": "Filter by role name",
        "description": " ",
        "table-name": "role",
        "table-header": {
          "name": "Name",
          "statements": "Policies",
          "created-at": "Created at",
          "updated-at": "Updated at"
        },
        "filter-key": {
          "name": "Filter by role name"
        }
      },
      "form": {
        "main-title-create": "Create role",
        "main-title-edit": "Edit role",
        "description": "",
        "general-info": {
          "title": "General information",
          "name": {
            "label": "Name",
            "description": "",
            "placeholder": "For example, HR Executive"
          }
        },
        "permissions": {
          "title": "Permissions",
          "policies": {
            "label": "Policies",
            "description": "",
            "placeholder": "Select one or more existing policies to define permissions"
          }
        }
      },
      "detail": {
        "main-title": "Role details",
        "description": " ",
        "general-info": {
          "title": "Gerneral information",
          "policy-type": "Role name",
          "policy-name": "Role type",
          "created-at": "Created at",
          "updated-at": "Updated at"
        },
        "permission": {
          "title": "Permission",
          "policies": "Policies"
        }
      }
    },
    "user-group": {
      "list": {
        "main-title": "User groups",
        "filter-box-placeholder": "Filter by group name",
        "description": " ",
        "table-name": "user group",
        "table-header": {
          "group-name": "Group name",
          "user": "User",
          "created-at": "Created at",
          "created-by": "Created by"
        },
        "filter-key": {
          "name": "Filter by group name"
        }
      },
      "form": {
        "main-title-create": "Create user group",
        "main-title-edit": "Edit user group",
        "description": "",
        "group-name": {
          "label": "Group name",
          "description": "",
          "placeholder": "For example, HR Interns"
        },
        "group-members": {
          "label": "Group members",
          "description": "",
          "placeholder": "Select existing users to become members of the group"
        },
        "group-permissions": {
          "label": "Group permissions",
          "description": "",
          "placeholder": "Select existing policies defining permissions for those users"
        }
      },
      "detail": {
        "main-title": "User group details",
        "description": " ",
        "general-info": {
          "title": "Gerneral information",
          "group-name": "Group name",
          "group-members": "Group members",
          "group-permission": "Group permission",
          "created-at": "Created at",
          "created-by": "Created by"
        }
      }
    }
  },
  "directory": {
    "messageProvisionedResources": {
      "header": "Initialize Default tenant resources",
      "message": "Clone default selection process in order to process applications you need to have a selection process. A selection process consists of steps, lined with each other, allowing you to"
    },
    "menu": {
      "dashboard": "Dashboard",
      "people": "People",
      "organizations": "Organizations",
      "data-migrations": "Data Migrations"
    },
    "people": {
      "list": {
        "main-title": "People",
        "filter-box-placeholder": "Filter by Full Name",
        "table-header": {
          "full-name": "Full Name",
          "gender": "Gender",
          "phone-number": "Phone Number",
          "email-address": "Email Address"
        },
        "filter-key": {
          "full-name": "Filter by Full Name",
          "middle-name": "Filter by Middle Name",
          "last-name": "Filter by Last Name"
        }
      },
      "delete-message": "Are you sure you want to delete this record ?",
      "form": {
        "main-title-create": "Create Individual Profile",
        "main-title-edit": "Edit Individual Profile",
        "personal-data": {
          "sub-title": "Personal data",
          "title": {
            "label": "Title",
            "description": " "
          },
          "full-name": {
            "label": "Full name",
            "description": "You can enter their family name and given name, for example SOK Sovatha"
          },
          "first-name": {
            "label": "First name",
            "description": " "
          },
          "last-name": {
            "label": "Last name",
            "description": " "
          },
          "middle-name": {
            "label": "Middle name",
            "description": " "
          },
          "gender": {
            "label": "Gender",
            "description": " ",
            "options": {
              "male": "Male",
              "female": "Female"
            }
          },
          "phone-number": {
            "label": "Phone number",
            "description": "Mobile number(s)"
          },
          "email-address": {
            "label": "Email address",
            "description": "Email address(es)"
          },
          "date-of-birth": {
            "label": "Date of birth",
            "description": " "
          },
          "country-of-birth": {
            "label": "Country of birth",
            "description": " "
          },
          "province-of-birth": {
            "label": "Province of birth",
            "description": " "
          },
          "nationality": {
            "label": "Nationality",
            "description": " "
          },
          "national-id": {
            "label": "National id",
            "description": " "
          },
          "marital-status": {
            "label": "Marital status",
            "description": " "
          },
          "profile-photo": {
            "label": "Profile Photo",
            "description": " "
          },
          "profile-summary": {
            "label": "Profile summary",
            "description": " "
          },
          "achievement": {
            "label": "Achievement",
            "description": " "
          }
        },
        "contact-info": {
          "sub-title": "Contact Information",
          "contact-type": {
            "label": "Contact Type",
            "description": " "
          },
          "contact-value": {
            "label": "Contact Value",
            "description": " "
          }
        }
      },
      "details": {
        "main-title": "Profile Details",
        "personal-data": {
          "sub-title": "Personal Data",
          "first-name": "First Name",
          "middle-name": "Middle Name",
          "last-name": "Last Name",
          "gender": "Gender",
          "date-of-birth": "Date Of Birth",
          "place-of-birth": "Place Of Birth",
          "nationality": "Nationality",
          "marital-status": "Marital Status"
        },
        "contact-info": {
          "sub-title": "Contact Information"
        }
      }
    },
    "organizations": {
      "basic-form": {
        "main-header-create": "Create organization profile",
        "main-header-edit": "Edit organization profile",
        "basic-data": {
          "title": "Basic data",
          "offical-name": "Official name",
          "short-name": "Short name",
          "nature": "Nature",
          "industry": "Industry"
        }
      }
    }
  },
  "employment": {
    "messageProvisionedResources": {
      "header": "Initialize default tenant resources",
      "message": "Clone default selection process in order to process applications you need to have a selection process. A selection process consists of steps, lined with each other, allowing you to"
    },
    "menu": {
      "dashboard": "Dashboard",
      "employer": "Employers"
    },
    "employer": {
      "executiveOversight": {
        "search": "Search by project or overseer...",
        "executiveOversightForm": {
          "title": "Assign Executive Overseer",
          "editForm": {
            "title": "Edit Oversight Assignment"
          },
          "outsourcingProject": {
            "title": "Outsourcing Project / Company",
            "description": "Select the managed company for oversight assignment",
            "search": "-- Select Project --"
          },
          "SLTMembers": {
            "title": "SLT Members",
            "description": "Select one or more Senior Leadership Team members to assign",
            "search": "Search employees..."
          }
        },
        "assignOverseer": "Assigned Overseers",
        "noAssignOverseer": "No overseers assigned",
        "alreadyAssigned": "Already assigned"
      },
      "list": {
        "main-title": "Employers",
        "filter-box-placeholder": "Filter by full name, abbreviated name, ...",
        "description": "If you manage different businesses, branches or projects, you can use employers to group their respective employees, payrolls and their other related data all under your tenant. Note that your tenant employer {organization_name}, has already been created for you by the system.",
        "table-name": "employer",
        "table-header": {
          "full-name": "Full name",
          "abbreviated-name": "Abbreviated name",
          "employee-id-format": "Employee ID format",
          "type": "Type",
          "active-employee": "Active employee"
        },
        "filter-key": {
          "full-name": "Filter by Full name",
          "abbreviated-name": "Filter by Abbreviated name",
          "type": "Filter by type"
        }
      },
      "delete-message": "Are you sure want to delete this employer?",
      "detail": {
        "main-title": "Employer details",
        "sub-title1": {
          "title": "General information",
          "full-name": "Full name",
          "abbreviated-name": "Abbreviated name",
          "employee-id-format": "Employee ID format",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "sub-title2": {
          "title": "Other info",
          "phone-number": "Phone number(s)",
          "email-address": "Email address(es)",
          "street-address": "Street address",
          "website": "Website",
          "logo": "Logo"
        }
      },
      "form": {
        "main-title-create": "Create new employer",
        "main-title-edit": "Edit employer",
        "description": "For a quick creation, you enter just the basic data first while other datails could be entered any time later.",
        "general-info": {
          "title": "General information",
          "full-name": {
            "label": "Full name",
            "description": "What is the full name of the employer entity? E.g. Angkor Brilliant Consulting."
          },
          "abbreviated-name": {
            "label": "Abbreviated name",
            "description": "What is its short name? E.g. ABC"
          },
          "employee-id-format": {
            "label": "Employee ID format",
            "description": "The placeholder of employee ID. E.g. ABC-00000"
          }
        },
        "details": {
          "title": "Other info",
          "phone-number": {
            "label": "Phone number(s)",
            "description": "One or more phone numbers"
          },
          "email-address": {
            "label": "Email address(es)",
            "description": "One or more email addresses."
          },
          "street-address": {
            "label": "Address",
            "description": "Street address."
          },
          "website": {
            "label": "Website",
            "description": "Website URL e.g www.abc-consulting.com"
          },
          "logo": {
            "label": "Logo",
            "description": "Image(.jpeg or .png)."
          }
        }
      },
      "manage": {
        "main-title": "Employer's management",
        "description": "Below are the summaries for your employer. Select one of the sections below to go inside it to administer its records in detail.",
        "app-sections": {
          "employee": {
            "title": "Employees",
            "description": "Manage employee profiles",
            "active": "Active"
          },
          "department": {
            "title": "Departments",
            "description": "Manage departments/sections",
            "active": "Active"
          },
          "job-profile": {
            "title": "Job Profiles",
            "description": "Manage job profiles",
            "active": "Active"
          }
        }
      }
    },
    "employee": {
      "list": {
        "main-title": "Employees",
        "filter-box-placeholder": "Filter by full name, job title, ...",
        "description": " ",
        "table-name": "employee",
        "table-header": {
          "employee-id": "Employee ID",
          "employee-name": "Full name",
          "employee-status": "Status",
          "job-title": "Job title",
          "department": "Department",
          "work-contacts": "Work contacts"
        },
        "filter-key": {
          "employee-id": "Filter by Employee ID",
          "employee-name": "Filter by Full name",
          "employee-status": "Filter by Status",
          "job-title": "Filter by Job title",
          "department": "Filter by Department",
          "work-email": "Filter by Work email"
        }
      },
      "delete-message": "Deleting this employee will delete all his/her related data. Are you sure you want to delete this employee?",
      "form": {
        "main-title-create": "Create new employee",
        "main-title-edit": "Edit employee",
        "description": "For a quick creation, you enter just the employee's personal and job summaries while their other details could be added any time later.",
        "personal-summary": {
          "title": "Personal summary",
          "full-name": {
            "label": "Full name",
            "description": "You can enter their family name and given name, for example SOK Sovatha"
          },
          "gender": {
            "label": "Gender",
            "description": " ",
            "male": "Male",
            "female": "Female"
          },
          "phone-number": {
            "label": "Phone number",
            "description": "Mobile number(s)"
          },
          "email-address": {
            "label": "Email",
            "description": "Email address(es)"
          }
        },
        "job-summary": {
          "title": "Job summary",
          "hire-data": {
            "label": "Hire date",
            "description": "The exact data the employee starts working. Note that this could be different from the date you create this record."
          },
          "employee-classification": {
            "label": "Employee classification",
            "description1": "Employees with fixed duration contracts (FDCs) or undetermined duration contracts (UDCs).",
            "description2": "Employees performing work temporarily, intermittently or seasonally.",
            "regular": "Regular",
            "casual": "Casual"
          }
        }
      },
      "detail": {
        "main-title": "Employee details",
        "description": "To have more accurate profile, you need to update the following sections to reflect the employee's current job. To edit data for a section, click on Edit button on the right of the section title.",
        "summaries": {
          "title": "Summaries",
          "employee-id": "Employee ID",
          "full-name": "Full name",
          "employment-status": "Employment status",
          "employee-classification": "Employee classification",
          "position": "Position",
          "department": "Department",
          "hire-date": "Hire date",
          "end-date": "End date",
          "phone-number": "Phone number"
        },
        "employment-detail": {
          "employment-detail": {
            "title": "Employment Details",
            "subsection": {
              "current-job": "Current Job",
              "compensation": "Compensation and Benefits",
              "employment-contract": "Contracts",
              "bank-info": "Bank Information",
              "family-member": "Family Members",
              "work-contact": "Contacts",
              "insurance": "Insurance"
            }
          },
          "personal-detail": {
            "title": "Personal Details",
            "subsection": {
              "bio-data": "Bio Data",
              "contact": "Contacts",
              "dependent": "Dependents",
              "parent": "Parent Information",
              "insurance": "Insurance Membership/NSSF",
              "work-permit": "Workbook/Work Permit"
            }
          },
          "employment-contract": {
            "list": {
              "main-title": "Employment contracts",
              "filter-box-placeholder": "Filter by Job Title, Type, ... ",
              "table-name": "Employment contract",
              "table-header": {
                "job-title": "Job title",
                "type": "Type",
                "status": "Status",
                "start-date": "Start date",
                "end-date": "End date"
              },
              "filter-key": {
                "job-title": "Filter by Job Title",
                "type": "Filter by Type",
                "status": "Filter by Status",
                "start-date": "Filter by Start Date",
                "end-date": "Filter by End Date"
              }
            },
            "form": {
              "main-title-create": "Create new contract",
              "main-title-edit": "Edit contract",
              "main-title-renew": "Renew contract",
              "type": {
                "label": "Type",
                "description": "FDC: Fixed Duration Contract, UDC: Undetermined Duration Contract, Select PROBATION if the contract for the employee covers just the probation period."
              },
              "employment-type": {
                "label": "Employment type",
                "description": " "
              },
              "start-date": {
                "label": "Start date",
                "description": " "
              },
              "end-date": {
                "label": "End date",
                "description": " "
              },
              "enable-reminder": "Enable reminder",
              "period": "With probation period, end date",
              "send-email-reminder": "Send email reminder at",
              "send-to": "Send to",
              "job-role": {
                "label": "Job role",
                "description": " ",
                "placeholder": "Select a job profile"
              },
              "department": {
                "label": "Department",
                "description": " ",
                "placeholder": "Select a department"
              },
              "line-manager": {
                "label": "Line manager",
                "description": " ",
                "placeholder": "Select line manager"
              },
              "basic-salary": {
                "label": "Basic salary (monthly)",
                "description": " ",
                "placeholder": " "
              },
              "upload-document": {
                "label": "Upload document",
                "description": " "
              }
            },
            "detail": {
              "main-title": "Employment contract details",
              "job": {
                "current-job": "Current Job",
                "modify": "Modify via Employment Change",
                "position": "Position",
                "department": "Department",
                "employment-type": "Employment Type",
                "contract-type": "Contract Type",
                "reports-to": "Reports To",
                "org-unit": "Org. Unit",
                "project-client": "Project / Client",
                "hire-date": "Hire Date",
                "work-location": "Work Location",
                "working-hours": "Working Hours",
                "employment-change-note": "Position, department and contract changes are governed by Employment Change — every modification creates an auditable event with effective date, reason, and approval trail.",
                "start-one": "Start one →"
              },
              "overview": {
                "sub-title": "Overview",
                "contract-type": "Contract type",
                "employment-type": "Employment type",
                "job-role": "Job role",
                "department": "Department",
                "line-manager": "Line manager",
                "start-date": "Start date",
                "end-date": "End date",
                "enable-reminder": "Enable Reminder",
                "period": "Probation period end date",
                "send-email-reminder": "Send email reminder at",
                "send-to": "Send to"
              },
              "related-events": {
                "list": {
                  "main-title": "Employment changes",
                  "table-name": "employment change",
                  "table-header": {
                    "type": "Change type",
                    "effective-date": "Effective date",
                    "description": "Description",
                    "created-date": "Created at",
                    "Created-by": "Created by"
                  }
                },
                "form": {
                  "main-title-create": "Create new employment change",
                  "main-title-edit": "Edit employment change",
                  "description": "Fill in those required and any of optional fields below to soundly reflect this change for the employee.",
                  "type": {
                    "label": "Type",
                    "description": "Select a type applicable to change"
                  },
                  "employment-type": {
                    "label": "Employment type",
                    "description": "Specify a employment type"
                  },
                  "effective-date": {
                    "label": "Effective date",
                    "description": "Specify the date from which the change takes effect."
                  },
                  "reason": {
                    "label": "Reason",
                    "description": "What is the motive for the change?"
                  },
                  "job-role": {
                    "label": "Job role",
                    "description": "If the change affects new job role, specify it one below."
                  },
                  "basic-salary": {
                    "label": "Basic salary (monthly)",
                    "description": "If the change affects new basic salary, specify it below."
                  },
                  "department": {
                    "label": "Department",
                    "description": "If the change affects new department/section, specify it below."
                  },
                  "line-manager": {
                    "label": "Line manager",
                    "description": "If the change affects new line manager, specify it below."
                  }
                },
                "detail": {
                  "main-title": "Employment change details",
                  "desciprtion": "",
                  "type": "Change type",
                  "reason": "Reason",
                  "effective-date": "Effective date",
                  "employment-type": "Employment type",
                  "job-role": "Job role",
                  "department": "Department",
                  "line-manager": "Line manager",
                  "created-at": "Created at",
                  "created-by": "Created by",
                  "updated-at": "Updated at",
                  "updated-by": "Updated by",
                  "benefits": {
                    "sub-title": "Benefits"
                  }
                }
              }
            }
          },
          "current-job": {
            "main-title": "Current job",
            "description": " ",
            "job-profile": {
              "see-detail": "See details",
              "sub-titile": "Job profile",
              "position": "Position",
              "grade": "Grade",
              "level": "Level",
              "working-hours-per-week": "Working hours per week",
              "responsibilities": "Responsibilities",
              "requirements": "Requirements",
              "job-description": "Job description"
            },
            "organizational-structure": {
              "sub-titile": "Organizational structure",
              "department": "Department",
              "number-of-subordinates": "Subordinates",
              "line-manager": "Line manager"
            },
            "employment": {
              "sub-titile": "Employment",
              "status": "Status",
              "type": "Type",
              "contract": "Contract",
              "basic-salary": "Basic salary (monthly)",
              "work-schedule": "Work schedule",
              "annual-leave-balance": "Annual leave balance"
            }
          }
        },
        "responsibilities": {
          "responsibilitiesDescription": "Describe the key duties and accountabilities of this role."
        },
        "requirements": {
          "requirementsDescription": "List required skills, experience and qualifications."
        },
        "jobGradeDescription": "Used for compensation and career progression.",
        "employmentLevelDescription": "Defines seniority and role classification.",
        "day": "Days",
        "entitlementType": {
          "title": "Entitlements",
          "entitlementType": "Entitlement Type",
          "column": {
            "daysEarned": "Days Earned",
            "notes": "Notes",
            "openingBalance": "Opening Balance",
            "carriedForward": "Carried Forward",
            "monthlyAccrual": "Monthly Accrual",
            "seniorityAccrual": "Seniority Accrual"
          }
        }
      },
      "employmentDetails": "Employment Details",
      "jobTitle": "Job Title",
      "jobGrade": "Job Grade",
      "employmentLevel": "Employment Level",
      "baseSalary": "Base Salary",
      "workingHoursPerWeek": "Working Hours per Week",
      "workLocation": "Work Location",
      "scheduleName": "Schedule Name",
      "responsibilities": "Responsibilities",
      "requirements": "Requirements",
      "reportingStructure": "Reporting Structure",
      "directManager": "Direct Manager",
      "reports": "Reports",
      "viewReports": "View Reports",
      "organizationalUnit": "Organizational Unit",
      "organizationalLayer": "Organizational Layer",
      "workingSchedule": "Working Schedule",
      "workingDays": "Working Days",
      "totalWeeklyHours": "Total Weekly Hours"
    },
    "leave": {
      "entitlementsSummary": "Leave Entitlements Summary",
      "totalEntitlement": "Total Entitlement",
      "annualLeaveTaken": "Annual Leave Taken",
      "annualLeaveBalance": "Annual Leave Balance",
      "periodSummary": "Leave Period Summary"
    },
    "job-profile": {
      "list": {
        "main-title": "Job profiles",
        "filter-box-placeholder": "Filter by position, level, grade....",
        "description": " ",
        "table-name": "Job profile",
        "table-header": {
          "position-title": "Position title",
          "level": "Level",
          "grade": "Grade",
          "min-salary": "Min salary",
          "max-salary": "Max salary",
          "working-hours": "Working hours"
        },
        "filter-key": {
          "position-title": "Filter by Position title",
          "grade": "Filter by Job grade",
          "level": "Filter by Job level",
          "min-salary": "Filter by Min salary",
          "max-salary": "Filter by Max salary",
          "working-hours": "Filter by Working hours"
        }
      },
      "form": {
        "main-title-create": "Create new job profile",
        "main-title-edit": "Edit job profile",
        "description": " ",
        "general-info": {
          "sub-title": "General information",
          "position": {
            "label": "Position",
            "description": " ",
            "placeholder": "Select a position"
          },
          "job-grade": {
            "label": "Job grade",
            "description": " ",
            "placeholder": "Select a job grade"
          },
          "job-level": {
            "label": "Job level",
            "description": " ",
            "placeholder": "Select a job level"
          },
          "min-salary": {
            "label": "Min. salary",
            "description": " ",
            "placeholder": " "
          },
          "max-salary": {
            "label": "Max. salary",
            "description": " ",
            "placeholder": " "
          },
          "base-currency": {
            "label": "Base currency",
            "description": " ",
            "placeholder": "Select a base currency"
          },
          "working-hours-per-week": {
            "label": "Working hours/per week",
            "description": " ",
            "placeholder": " "
          }
        },
        "responsibilities": {
          "sub-title": "Responsibilities"
        },
        "requirements": {
          "sub-title": "Requirements"
        },
        "required-competency": {
          "sub-title": "Required competencies",
          "description": " "
        },
        "competencies": {
          "sub-title": "Competencies"
        }
      },
      "detail": {
        "main-title": "Job profile details",
        "general-info": {
          "sub-title": "General information",
          "position-title": "Position title",
          "grade": "Grade",
          "level": "Level",
          "min-salary": "Min salary",
          "max-salary": "Max salary",
          "working-hour": "Working hour",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "responsibilities": "Responsibilities",
        "requirements": "Requirements"
      }
    },
    "department": {
      "list": {
        "main-title": "Departments",
        "filter-box-placeholder": "Filter by full name, abbreviated name, ...",
        "description": " ",
        "table-name": "department",
        "table-header": {
          "full-name": "Full name",
          "abbreviated-name": "Abbreviated name",
          "status": "Status",
          "parent-department": "Parent department"
        },
        "filter-key": {
          "full-name": "Filter by Full name",
          "abbreviated-name": "Filter by  Abbreviated name",
          "status": "Filter by Status",
          "parent-department": "Filter by Parent department"
        }
      },
      "form": {
        "main-title-create": "Create new department",
        "main-title-edit": "Edit department",
        "full-name": {
          "label": "Full name",
          "description": "Full name for the department/section",
          "placeholder": " "
        },
        "abbreviated-name": {
          "label": "Abbreviated Name",
          "description": "Select an abbreviated name for the department/section",
          "placeholder": " "
        },
        "parent-department": {
          "label": "Parent department",
          "description": "Select a parent for the department/section",
          "placeholder": "Select a parent for the department/section"
        }
      },
      "delete-message": "Are you sure want to delete this department?",
      "detail": {
        "general-info": {
          "sub-title": "General information",
          "full-name": "Full name",
          "status": "Status",
          "abbreviated-name": "Abbreviated name",
          "parent-department": "Parent department",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        }
      }
    },
    "compensation": {
      "detail": {
        "main-title": "Compensation and benefits",
        "description": "You use this section to record those compensation and benefits offered to the employee.",
        "basic-salary": {
          "sub-title": "Base salary",
          "salary": "Basic salary (monthly)"
        },
        "pay-structure": {
          "sub-title": "Pay structure",
          "pay-structure": "Linked pay structure"
        },
        "pay-structure-form": {
          "main-title": "Edit employee pay structure",
          "description": "The selected pay structure below will be assigned to the {count_employee} selected employee(s).",
          "pay-structure": {
            "label": "Pay structure",
            "description": " "
          }
        }
      }
    },
    "bank-info": {
      "main-title": "Bank information details",
      "sub-header": "Bank information",
      "full-name": "Full name",
      "short-name": "Short name",
      "account-name": "Account name",
      "account-number": "Account number",
      "form": {
        "main-title": "Edit bank information",
        "bank-full-name": "Bank full name",
        "account-name": "Account name",
        "account-number": "Account number"
      }
    },
    "family-member": {
      "main-title": "Family members",
      "spouse": "Spouse",
      "children": "Children",
      "parent": "Parents",
      "table-name-spouse": "spouse",
      "table-name-child": "child",
      "table-name-parent": "parent",
      "btn-lable-spouse": "Edit spouse",
      "btn-lable-children": "Edit children",
      "btn-lable-parent": "Edit parent",
      "table": {
        "name": "Full name",
        "gender": "Gender",
        "date-of-birth": "Date of birth",
        "dependent": "Dependent"
      },
      "form": {
        "edit-spouse": "Edit spouse",
        "edit-child": "Edit child",
        "edit-parent": "Create parent",
        "name": "Full name",
        "gender": "Gender",
        "dependent": {
          "title": "Dependent",
          "true": "True",
          "false": "False"
        }
      }
    },
    "work-contact": {
      "main-title": "Contacts",
      "description": " ",
      "list": {
        "main-title": "Work contacts",
        "description": " ",
        "table": {
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        }
      },
      "form": {
        "main-title": "Edit work contacts",
        "contact-type": "Contact type",
        "contact-value": "Contact value"
      }
    },
    "personal-detail": {
      "personal-contact": {
        "main-title": "Contacts",
        "description": " ",
        "list": {
          "title": "Personal contacts",
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        },
        "form": {
          "title": "Edit personal contact",
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        }
      },
      "emergency-contact": {
        "main-title": "Emergency contacts",
        "description": " ",
        "list": {
          "name": "Name",
          "relationship": "Relationship",
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        },
        "form": {
          "title": "Edit emergency contact",
          "name": "Name",
          "relationship": "Relationship",
          "contact-type": "Contact type",
          "contact-value": "Contact value"
        }
      }
    },
    "job-grade": {
      "mainTabelHeader": "Job Grades & Salary Bands",
      "column": {
        "grade": "Grade Level",
        "level": "Level",
        "typical-titles": "Typical Job Titles",
        "salary-range-currency": "Salary Currency",
        "salary-ranges": "Salary Band"
      },
      "filter-text": "Search by grade level, or job title…"
    }
  },
  "leave": {
    "messageProvisionedResources": {
      "header": "Initialize default tenant resources",
      "message": "Clone default selection process in order to process applications you need to have a selection process. A selection process consists of steps, lined with each other, allowing you to"
    },
    "menu": {
      "dashboard": "Dashboard",
      "leave": "Leave"
    },
    "leave-type": {
      "list": {
        "main-title": "Leave Types",
        "filter-box-placeholder": "Filter by Name, Code, ...",
        "description": "Leave types refers to the different categories or types of leave that employees can take from work. Some common types of leave are vacation leave, sick leave, personal leave or emergency leave, parental or family leave, and bereavement leave.",
        "table-header": {
          "title": "Title",
          "code": "Code",
          "availability": "Availability",
          "status": "Status"
        },
        "filter-key": {
          "title": "Filter by Title:",
          "code": "Filter by Code:"
        }
      },
      "delete-message": "Are you sure want to delete this leave type?",
      "detail": {
        "main-title": "Leave type details",
        "general": "General Information",
        "general-info": {
          "title": "Title",
          "code": "Code",
          "availability": "Availability",
          "status": "Status",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        }
      },
      "form": {
        "main-title-create": "Create leave type",
        "main-title-edit": "Edit leave type",
        "general-info": {
          "title": "Title",
          "code": "Code",
          "availability": "Availability",
          "availability-des": "ON_AVAILABLE generally applies to ANNUAL_LEAVE, ON_GRANTED generally applies to MATERNITY_LEAVE, ALWAYS generally applies to SICK_LEAVE.",
          "status": "Status",
          "on-available": "ON_AVAILABLE",
          "on-granted": "ON_GRANTED",
          "always": "ALWAYS",
          "active": "Active",
          "inactive": "Inactive"
        }
      }
    },
    "leave-request": {
      "list": {
        "main-title": "Leave Requests",
        "filter-box-placeholder": "Filter by LeaveType.Code, Status, ...",
        "description": " Leave request is an important part of workforce management, as it helps ensure that employees have access to the time off they need while also ensuring that the business can continue to operate effectively.",
        "table-header": {
          "employee-name": "Employee Name",
          "leave-type": "Leave Type",
          "from-date": "From Date",
          "to-date": "To Date",
          "status": "Status"
        },
        "table-field": {
          "employee-name": "Employee.Name",
          "leave-type": "LeaveType.Title",
          "from-date": "FromDate",
          "to-date": "ToDate",
          "status": "Status"
        },
        "filter-key": {
          "code": "Filter by LeaveType.Code:",
          "status": "Filter by Status:"
        }
      },
      "delete-message": "Are you sure want to delete this leave request?",
      "delete-applied-date-message": "Are you sure want to delete this applied date?",
      "submit-message": "Are you sure want to submit this leave request?",
      "approve-message": "Are you sure want to approve this leave request?",
      "detail": {
        "main-title": "Leave request details",
        "general": "General Information",
        "approve": "Approve",
        "reject": "Reject",
        "reason": "Reason",
        "cancel": "Cancel",
        "general-info": {
          "employee-name": "Employee name",
          "leave-type": "Leave type",
          "date": "Date",
          "reason": "Reason",
          "status": "Status",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by",
          "validated-at": "Validated at",
          "validated-by": "Validated by"
        }
      },
      "form": {
        "main-title-create": "Create Leave Request",
        "main-title-edit": "Edit Leave Request",
        "general-info": {
          "leave-type": "Leave Type",
          "title": "Title",
          "code": "Code",
          "availability": "Availability",
          "status": "Status",
          "date": "Date",
          "period-day": "Period of day",
          "whole-day": "WHOLE DAY",
          "whole-day-value": "WHOLE_DAY",
          "apply-date-create": "Create apply dates",
          "apply-date-edit": "Edit applied date",
          "morning": "MORNING",
          "afternoon": "AFTERNOON",
          "on-available": "ON_AVAILABLE",
          "on-available-des": "This generally applies to ANNUAL_LEAVE",
          "on-granted": "ON_GRANTED",
          "on-granted-des": "This generally applies to MATERNITY_LEAVE, etc.",
          "always": "ALWAYS",
          "always-des": "This generally applies to SICK_LEAVE, etc.",
          "active": "Active",
          "inactive": "Inactive",
          "leave-balance": "Remaining Leave",
          "reasons": "Reason",
          "manager": "Line Manager",
          "cc": "Line Manager CC"
        }
      }
    }
  },
  "payroll": {
    "messageProvisionedResources": {
      "header": "Initialize Default tenant resources",
      "message": "Clone default selection process in order to process applications you need to have a selection process. A selection process consists of steps, lined with each other, allowing you to"
    },
    "employer": {
      "list": {
        "main-title": "Employers",
        "element": {
          "active-employee": "Active employees",
          "pay-structure": "Pay structures",
          "created-payrolls": "Created payrolls"
        }
      },
      "details": {
        "main-title": "Employer details",
        "employees": {
          "title": "Employees",
          "active": "Active"
        },
        "payrolls": {
          "title": "Payrolls",
          "created-payrolls": "Created payrolls"
        },
        "pay-structures": {
          "title": "Payroll structures",
          "created-pay-structure": "Created payroll structures"
        }
      }
    },
    "payroll": {
      "list": {
        "main-title": "Payrolls",
        "description": "",
        "table-name": "payroll",
        "filter-box-placeholder": "Filter by pay structure name, ...",
        "table-header": {
          "pay-structure": "Pay structure name",
          "pay-period": "Pay period",
          "payroll-template": "Payroll Template",
          "staff": "Staff",
          "status": "Status"
        },
        "filter-key": {
          "pay-structure": "Filter by pay structure name"
        }
      },
      "delete-message": "Are you sure want to delete this payroll?",
      "detail": {
        "main-title": "Payroll detail",
        "general-info": {
          "title": "General Information",
          "pay-structure": "Pay structure name",
          "pay-period": "Pay period",
          "template": "Template name",
          "exchange-rate": "Exchange rates",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "process-status": {
          "title": "Process overview"
        },
        "current-step": {
          "title": "Current step",
          "step-status": "Step Status"
        },
        "step-detail": {
          "title": "Current Step details",
          "pay-structure": "Pay structure",
          "pay-period": "Pay period",
          "payroll-template": "Payroll Template",
          "exchange-rate": "Exchange rates",
          "document": "Document"
        },
        "validate-employee": {
          "result": "Results",
          "included-emloyee": "Found {value} employee(s) included in this payroll",
          "excluded-employee": "Found {value} employee(s) excluded from this payroll"
        }
      },
      "form": {
        "main-title-create": "Create new payroll",
        "main-title-edit": "Edit payroll",
        "description": "The following data are used to identify a payroll based on its Pay Structure, Pay Period and Pay Frequency under a specific Employer.",
        "pay-structure": {
          "label": "Pay structure",
          "description": "What is the pay structure of the payroll entity? E.g. Default Pay Structure."
        },
        "pay-period": {
          "label": "Pay period",
          "description": "What is its pay period? E.g. January"
        },
        "payroll-tempate": {
          "label": "Payroll template",
          "description": "What is its payroll template? E.g. First Payroll Template"
        },
        "exchange-rate": {
          "label": "Exchange rates",
          "description": "Input exchange rates (US$ : KHR) to apply in this payroll. E.g. 1$ = 4000R"
        }
      }
    },
    "employee-incomes-expense": {
      "list": {
        "main-title": "Employees' Incomes/Expenses",
        "table-name": "incomes/expenses",
        "description": " ",
        "filter-key": {
          "employee-name": "Filter by employee name",
          "employee-id": "Filter by employee id"
        },
        "label-btn": {
          "download-record-template": "Download record template (.xlsx)",
          "upload-record": "Upload records (.xlsx)",
          "new-record-manual-input": "New record (manual input)"
        }
      },
      "form": {
        "main-title-create": "Employees' income/expense",
        "employee-name": {
          "label": "Employee name",
          "description": " ",
          "placeholder": "Select the employee needed to add a component pay record"
        },
        "employee-id": {
          "label": "Employee ID",
          "description": " "
        },
        "table": {
          "pay-component": "Pay Component",
          "amount": "Amount (USD)",
          "description": "Description",
          "document": "Document"
        },
        "main-title-edit": "Edit Employees' income/expense",
        "component": {
          "label": "Component",
          "placeholder": "Select a user-input component to record income/expense"
        },
        "amount": "Amount (USD)",
        "description": "Description",
        "upload-document": "Upload document"
      }
    },
    "employee-pay-record": {
      "list": {
        "main-title": "Employee pay records",
        "table-name": "employee pay record"
      },
      "detail-history": {
        "main-title": "Pay record edit history",
        "employee": "Employee",
        "table": {
          "data-time": "Edited at",
          "edited-by": "Edited by",
          "component": "Component",
          "from": "From",
          "to": "To",
          "reason": "Reason"
        }
      }
    },
    "pay-structure": {
      "list": {
        "main-title": "Pay Structures",
        "description": "If you don't have any pay structures yet, you can create one by making an identical copy of the general template from AIML SaaS system. Click <strong> Clone </strong> button to create new one for your tenant.",
        "table-name": "pay structure",
        "filter-box-placeholder": "Filter by name, ...",
        "table-header": {
          "name": "Name",
          "employee": "Employee",
          "pay-interval": "Pay Interval",
          "pay-component": "Pay Components",
          "status": "Status"
        },
        "filter-key": {
          "name": "Filter by name"
        }
      },
      "delete-message": "Are you sure want to delete this pay structure?",
      "detail": {
        "main-title": "Pay structure details",
        "basic-info": {
          "title": "Basic Information",
          "name": "Name",
          "legal-requirement": "Legal requirement",
          "pay-method": "Pay method",
          "pay-interval": "Pay Interval",
          "pay-frequency": "Pay frequency",
          "pay-date": "Pay date",
          "pay-process": "Pay process",
          "created-at": "Created at",
          "created-by": "Created by",
          "updated-at": "Updated at",
          "updated-by": "Updated by"
        },
        "menu": {
          "pay-roll-component": "Payroll Components",
          "pay-period": "Pay Periods",
          "payroll-template": "Payroll Templates",
          "payroll-exchange-rate": "Exchange Rates"
        }
      },
      "form": {
        "main-title-create": "Create new pay structure",
        "main-title-edit": "Edit pay structure",
        "description": "",
        "legal-requirement": {
          "label": "Legal requirement",
          "description": " "
        },
        "name": {
          "label": "Name",
          "description": " "
        },
        "pay-method": {
          "label": "Pay method",
          "description": " "
        },
        "pay-interval": {
          "label": "Pay interval",
          "description": " "
        },
        "pay-frequency": {
          "label": "Pay frequency",
          "description": " "
        },
        "pay-date": {
          "label": "Pay date",
          "description": " "
        },
        "pay-process": {
          "label": "Pay process",
          "description": " "
        }
      }
    },
    "payroll-component": {
      "list": {
        "main-title": "Payroll Components",
        "table-name": "payroll component",
        "filter-box-placeholder": "",
        "table-header": {
          "title": "Title",
          "type": "Type",
          "category": "Category",
          "tax-applicability": "Tax applicability",
          "status": "Status",
          "order": "Order",
          "currency-conversion": "Currency conversion",
          "exchange-rate": "Exchange rate",
          "actions": "Actions"
        },
        "filter-key": {
          "title": "Filter by title",
          "type": "Filter by type",
          "category": "Filter by category",
          "tax-applicability": "Filter by tax applicability",
          "status": "Filter by status",
          "currency-conversion": "Filter by currency conversion",
          "exchange-rate": "Filter by exchange rate"
        }
      },
      "form": {
        "main-title-create": "Create payroll component",
        "main-title-edit": "Edit payroll component",
        "title": {
          "title": "Title",
          "placeholder": "E.g. Salary Deduction"
        },
        "group": {
          "title": "Group",
          "placeholder": "Select a group for the component"
        },
        "category": {
          "title": "Category"
        },
        "tax-applicability": {
          "title": "Tax applicability"
        },
        "code": {
          "title": "Code"
        },
        "source-of-value": {
          "title": "Source of value"
        },
        "reference": {
          "title": "Reference"
        },
        "use-as": {
          "title": "Use as"
        },
        "currency": {
          "title": "Currency"
        },
        "status": {
          "title": "Status"
        }
      }
    },
    "payroll-process": {
      "list": {
        "main-title": "Payroll Processes",
        "description": " ",
        "table-name": "payroll process",
        "filter-box-placeholder": "Filter by name, status ...",
        "table-header": {
          "name": "Name",
          "status": "Status",
          "created-at": "Created at",
          "created-by": "Created by"
        },
        "filter-key": {
          "name": "Filter by name",
          "status": "Filter by status"
        }
      },
      "delete-message": "Are you sure want to delete this payroll process?",
      "detail": {
        "main-title": "Payroll process details",
        "name": "Name",
        "status": "Status",
        "created-at": "Created at",
        "created-by": "Created by",
        "updated-at": "Updated at",
        "updated-by": "Updated by"
      },
      "form": {
        "main-title-create": "Create new payroll process",
        "main-title-edit": "Edit payroll process",
        "description": "",
        "overview": {
          "title": "Overview",
          "name": {
            "label": "Name",
            "description": " "
          },
          "status": {
            "label": "Status",
            "description": " "
          }
        }
      }
    },
    "pay-period": {
      "list": {
        "main-title": "Pay Periods",
        "description": "",
        "table-name": "pay period",
        "filter-box-placeholder": "Filter by title, status ...",
        "table-header": {
          "period-name": "Title",
          "start-date": "Start date",
          "end-date": "End date",
          "status": "Status"
        },
        "filter-key": {
          "name": "Filter by title",
          "status": "Filter by status"
        }
      },
      "delete-message": "Are you sure want to delete this pay period?",
      "detail": {
        "main-title": "Pay period details",
        "title": "Title",
        "start-date": "Start date",
        "end-date": "End date",
        "status": "Status",
        "created-at": "Created at",
        "created-by": "Created by",
        "updated-at": "Updated at",
        "updated-by": "Updated by"
      },
      "form": {
        "main-title-create": "Create new pay period",
        "main-title-edit": "Edit pay period",
        "description": "",
        "title": {
          "label": "Title",
          "description": " "
        },
        "start-date": {
          "label": "Start date",
          "description": " "
        },
        "end-date": {
          "label": "End date",
          "description": " "
        },
        "status": {
          "label": "Status",
          "description": " "
        }
      }
    },
    "payroll-template": {
      "list": {
        "main-title": "Payroll Templates",
        "description": "",
        "table-name": "payroll template",
        "filter-box-placeholder": "Filter by name, pay frequency ...",
        "table-header": {
          "name": "Name",
          "pay-frequency": "Pay frequency",
          "created-by": "Created by",
          "created-at": "Created at"
        },
        "filter-key": {
          "name": "Filter by name",
          "status": "Filter by pay frequency"
        }
      },
      "delete-message": "Are you sure want to delete this payroll template?",
      "detail": {
        "main-title": "Payroll template details",
        "overview": "Overview",
        "components": "Components",
        "name": "Name",
        "pay-frequency": "Pay frequency",
        "created-at": "Created at",
        "created-by": "Created by",
        "updated-at": "Updated at",
        "updated-by": "Updated by",
        "table": {
          "title": "Title",
          "type": "Type",
          "category": "Category",
          "tax-applicability": "Tax applicability",
          "status": "Status",
          "order": "Order"
        }
      },
      "form": {
        "main-title-create": "Create new template",
        "main-title-edit": "Edit template",
        "description": "",
        "name": {
          "label": "Name",
          "description": " "
        },
        "pay-frequency": {
          "label": "Pay frequency",
          "description": " "
        },
        "pay-component": {
          "label": "Pay component",
          "description": " "
        }
      }
    },
    "payroll-comparison": {
      "list": {
        "main-title": "Comparison",
        "btn-label": "Get Comparison"
      }
    },
    "exchange-rate": {
      "list": {
        "main-title": "Exchange Rates",
        "description": "",
        "table-name": "Exchange rate",
        "filter-box-placeholder": "Filter by title ...",
        "table-header": {
          "name": "Name",
          "default": "Default",
          "created-at": "Created at",
          "created-by": "Created by"
        },
        "filter-key": {
          "name": "Filter by name"
        }
      },
      "detail": {
        "main-title": "Exchange rate details",
        "title": "Name",
        "created-at": "Created at",
        "created-by": "Created by",
        "updated-at": "Updated at",
        "updated-by": "Updated by"
      },
      "form": {
        "main-title-create": "Create new exchange rate",
        "main-title-edit": "Edit exchange rate",
        "description": "",
        "name": {
          "label": "Name",
          "description": "The name of exchange rate, e.g. GDT for that received from General Department of Taxation, NSSF for that received from NSSF."
        },
        "default-status": {
          "label": "Default",
          "description": "When set to “true”, this exchange rate will be selected by default when used with a pay component having Currency Conversion set to “true”"
        }
      }
    }
  },
  "v2": {
    "app": {
      "name": "OptimalHR"
    },
    "ui": {
      "column-customizer": {
        "title": "Customize table",
        "subtitle": "Choose which columns to show and drag to reorder them. Required columns cannot be hidden.",
        "summary": "column selected · drag to reorder | columns selected · drag to reorder",
        "required": "Required",
        "locked": "Locked",
        "reset": "Reset to default",
        "apply": "Apply",
        "drag-hint": "Drag to reorder",
        "cannot-reorder": "Cannot reorder",
        "move-up": "Move {label} up",
        "move-down": "Move {label} down",
        "toggle-aria": "{label} — {state}",
        "shown": "shown",
        "hidden": "hidden"
      }
    },
    "shell": {
      "org-chip": {
        "switch": "Switch scope",
        "loading": "Loading scopes…",
        "empty": "No scopes available",
        "global-label": "All Scopes",
        "global-sub": "Cross-scope oversight",
        "global-short": "All Scopes",
        "companies": "Companies",
        "projects": "Projects",
        "clients": "Clients",
        "vendors": "Vendors",
        "direct": "Direct",
        "direct-suffix": "Direct",
        "clients-projects": "Clients ▸ Projects",
        "vendors-projects": "Vendors ▸ Projects",
        "oversight": "oversight",
        "own-workforce": "own workforce",
        "context-client": "Client",
        "context-vendor": "Vendor",
        "context-project": "Project",
        "context-company": "Company",
        "show-more": "Show more ({count})",
        "show-less": "Show less",
        "create-company": "Create new company"
      },
      "search": {
        "label": "Search"
      },
      "notifications": {
        "label": "Notifications"
      },
      "resume-pill": {
        "label": "Resume Payroll",
        "title": "Continue the in-progress payroll run"
      },
      "pay-subnav": {
        "center": "Payroll Center",
        "input": "Pay Input",
        "reports": "Reports",
        "templates": "Templates",
        "configurations": "Configurations"
      },
      "user-menu": {
        "profile": "Profile",
        "change-password": "Change password",
        "switch-language": "Switch language",
        "sign-out": "Sign out"
      },
      "nav": {
        "home": "Home",
        "people": "People",
        "work": "HR Ops",
        "pay": "Payroll",
        "billing": "Billing",
        "workmgmt": "Work Mgmt",
        "perform": "Performance",
        "fieldops": "Field Ops",
        "insights": "Insights",
        "moreapps": "More Apps",
        "organization": "Organization"
      }
    },
    "auth": {
      "brand-panel": {
        "tagline": "HR Operations · Cambodia",
        "hero-title": "Welcome back",
        "hero-lede": "Sign in to manage attendance, leave, overtime, travel, expenses and payroll for your team — all in one place.",
        "bullets": {
          "compliance": "Cambodian compliance built-in — NSSF, payroll tax, public holidays",
          "outsourced": "Outsourced staff & External Line Manager approval routing",
          "mobile": "Mobile self-service for your team — request & approve on the go"
        },
        "copyright": "© {year} OptimalHR · A product of Optimal P HR Strategic Partner Co., Ltd.",
        "address": "Phnom Penh, Cambodia · {email}"
      },
      "aria": {
        "locale-switcher": "Switch language"
      },
      "welcome": {
        "title": "Welcome",
        "subtitle": "Enter your workspace to continue.",
        "workspace-label": "Workspace",
        "workspace-placeholder": "optimalp",
        "workspace-hint": "Lowercase letters, numbers, and hyphens only. Provided by your HR Admin.",
        "continue": "Continue",
        "continuing": "Loading workspace…",
        "recent-label": "Recent workspaces",
        "find-prefix": "Don't know your workspace?",
        "find-link": "Find my workspace",
        "find-toast": "Contact your HR Admin for the workspace name",
        "privacy": {
          "title": "How is my workspace protected?",
          "intro": "Your workspace name is a public address — like {hostExample}. Knowing it doesn't grant access. Your account stays secure through:",
          "items": {
            "mfa": {
              "title": "Password + MFA",
              "desc": "HR Admins and Payroll roles are required to use multi-factor authentication."
            },
            "monitoring": {
              "title": "Smart monitoring",
              "desc": "Rate limits and account lockout block automated attacks; unusual sign-ins trigger an alert."
            },
            "audit": {
              "title": "Full audit log",
              "desc": "Every sign-in (success and failure) is recorded and visible to your Admin."
            },
            "hidden": {
              "title": "Private workspace mode",
              "desc": "Enterprise clients can hide their login page entirely — access via signed invite link only."
            }
          },
          "footer": "Questions? Contact {email}"
        },
        "errors": {
          "workspace-required": "Enter your workspace to continue.",
          "workspace-invalid": "Use lowercase letters, numbers, and hyphens only.",
          "workspace-not-found": "We couldn't find that workspace. Check the spelling and try again."
        }
      },
      "sign-in": {
        "switch-workspace": "← Switch workspace",
        "title-template": "Sign in to {name}",
        "subtitle": "Welcome back. Enter your details to access your account.",
        "method-email": "Email",
        "method-phone": "Phone + OTP",
        "work-email": "Work email",
        "email-placeholder": "you\\@optimal-p.com",
        "password": "Password",
        "forgot": "Forgot?",
        "remember": "Remember me for 30 days",
        "submit": "Sign in",
        "submitting": "Signing in…",
        "fine-print": "By signing in, you agree to the {terms} and {privacy}.",
        "errors": {
          "fields-required": "Email and password are required",
          "workspace-required": "Workspace ID is required",
          "workspace-not-found": "Workspace not found"
        },
        "reset-success": "Your password has been reset. Sign in with your new password."
      },
      "forgot": {
        "title": "Reset password",
        "subtitle": "Enter the work email associated with your account and we'll send you a confirmation code.",
        "send-code": "Send code",
        "sending": "Sending…",
        "back-to-sign-in": "← Back to sign in",
        "errors": {
          "email-required": "Email is required",
          "code-mismatch": "That code is incorrect. Check the email and try again.",
          "expired-code": "That code has expired. Request a new one below.",
          "limit-exceeded": "Too many attempts. Please wait a few minutes and try again.",
          "user-not-found": "We couldn't find an account for that email.",
          "invalid-password": "That password doesn't meet the requirements. Use at least 8 characters with letters, numbers and a symbol.",
          "generic": "Something went wrong. Please try again."
        },
        "work-email": "Work email",
        "contact-hint": "Still stuck? Contact your HR Admin to recover your account.",
        "strength": {
          "empty": "Strength: empty",
          "weak": "Strength: weak",
          "medium": "Strength: medium",
          "strong": "Strength: strong",
          "excellent": "Strength: excellent"
        }
      },
      "confirm-forgot": {
        "title": "Set a new password",
        "code": "Confirmation code",
        "new-password": "New password",
        "confirm-password": "Confirm password",
        "submit": "Reset password",
        "submitting": "Resetting…",
        "errors": {
          "code-required": "Confirmation code is required",
          "mismatch": "Passwords do not match",
          "weak-password": "Choose a stronger password — at least 8 characters with a mix of letters, numbers and symbols.",
          "missing-username": "Your reset session expired. Start over from the forgot-password screen.",
          "code-mismatch": "That code is incorrect. Check the email and try again.",
          "expired-code": "That code has expired. Request a new one below.",
          "limit-exceeded": "Too many attempts. Please wait a few minutes and try again.",
          "user-not-found": "We couldn't find an account for that email.",
          "invalid-password": "That password doesn't meet the requirements. Use at least 8 characters with letters, numbers and a symbol.",
          "generic": "Something went wrong. Please try again."
        },
        "subtitle": "We sent a code to {email}. Enter it below with a new password you haven't used before.",
        "start-over": "← Start over",
        "no-code": "Didn't get the code?",
        "resend": "Resend code",
        "resending": "Resending…",
        "resent": "A new code is on its way — check your inbox.",
        "success-title": "Password updated",
        "success-subtitle": "Your password has been reset. You can now sign in with your new password.",
        "success-cta": "Continue to sign in"
      },
      "force-change": {
        "title": "Set a new password",
        "subtitle": "Your account requires a new password before continuing.",
        "submit": "Continue",
        "submitting": "Saving…"
      },
      "mfa": {
        "title": "Two-step verification",
        "subtitle-sms": "Enter the 6-digit code sent to your phone.",
        "subtitle-totp": "Enter the 6-digit code from your authenticator app.",
        "code": "6-digit code",
        "submit": "Verify",
        "submitting": "Verifying…",
        "errors": {
          "code-required": "Code is required"
        }
      },
      "change-password": {
        "title": "Change password",
        "current-password": "Current password",
        "save": "Save",
        "saving": "Saving…",
        "cancel": "Cancel",
        "success-toast": "Password updated",
        "errors": {
          "fields-required": "All fields are required",
          "mismatch": "New passwords do not match"
        }
      },
      "legal-links": {
        "terms": "Terms of Service",
        "privacy": "Privacy Policy"
      }
    },
    "home": {
      "welcome-fallback": "there",
      "global": {
        "title": "All Scopes",
        "subtitle": "Consolidated view across every company, client, vendor and project.",
        "error": "Could not load the cross-scope overview.",
        "retry": "Retry",
        "empty-title": "Nothing to show yet",
        "empty-desc": "Once scopes have people and contracts, their consolidated metrics appear here.",
        "preview-note": "Preview · sample data shown below until cross-scope feeds are wired",
        "kpi": {
          "expiring": "Contracts expiring ≤30d",
          "understaffed": "Understaffed projects",
          "probation": "On probation",
          "onboarding": "Onboarding in progress",
          "headcount": "Active headcount"
        },
        "persona": {
          "clients": "Clients",
          "vendors": "Vendors",
          "projects": "{count} active projects"
        }
      },
      "hero": {
        "greeting": "Welcome back",
        "today-pill": "Today",
        "subtitle-tail": "Your dashboard for today",
        "announce": "Announce",
        "quick-add": "Quick add"
      },
      "toasts": {
        "announce": "Announce — broadcast to all employees",
        "quick-add": "Quick add — pick employee / time / leave / expense"
      },
      "alert": {
        "compliance": {
          "text": "{count} compliance item(s) due or overdue in next 7 days",
          "cta": "View compliance"
        }
      },
      "action-center": {
        "title": "Action Center",
        "subtitle": "What needs your attention now"
      },
      "action-tiles": {
        "approvals": "Approvals waiting",
        "compliance": "Compliance · 7-day",
        "payroll": "Payroll blockers",
        "issues": "Issues to resolve"
      },
      "kpi": {
        "attendance": {
          "label": "Attendance today",
          "title": "Open Attendance · Daily Snapshot",
          "detail": "{present} of {total} present",
          "vs-yesterday": "vs yesterday"
        },
        "payroll": {
          "label": "Payroll cycle",
          "title": "Open Pay · current cycle",
          "step": "Step {step}/{total}",
          "cutoff-in": "cut-off in",
          "cutoff-days": "{days} days"
        },
        "eor": {
          "label": "EOR pulse",
          "title": "Open Outsourced Workforce",
          "detail": "Outsourced staff · {projects} active projects",
          "stale": "{count} stale External LM(s)"
        },
        "compliance": {
          "label": "Compliance score",
          "title": "Open Compliance Overview"
        }
      },
      "people-card": {
        "title": "People Centric — this week",
        "count": "{count} events",
        "more": "more",
        "empty": "No notable people events this week"
      },
      "people-events": {
        "joining": "joining this week",
        "separating": "separated this week (MOL declaration due)",
        "upcoming-exit": "upcoming exit (next 30d)",
        "probation-due": "probation review due (next 30d)",
        "on-leave-today": "on leave today",
        "on-leave-static": "on extended leave (status)",
        "returning-today": "returning today"
      },
      "activity-card": {
        "title": "Recent activity",
        "count": "{count} events",
        "empty": "No recent activity",
        "open": "Open Compliance"
      },
      "payroll-card": {
        "title": "Payroll cycle",
        "cutoff": "Cut-off {date}",
        "pay-date": "Pay date {date}",
        "blockers": "{count} blocker(s)",
        "clear-before": "clear before cut-off",
        "no-blockers": "No blockers",
        "resume": "Resume Payroll"
      },
      "calendar-card": {
        "title": "This week",
        "count": "{count} events",
        "empty": "No events scheduled this week",
        "open": "Open Compliance"
      }
    },
    "shared": {
      "stub-panel": {
        "v6-tag": "v6 stub",
        "tbd-tag": "Detail design TBD"
      }
    },
    "work": {
      "title": "HR Ops",
      "subtitle": "Optimal P · Apr 2026 · HR operations",
      "tabs": {
        "attendance": "Attendance",
        "schedules": "Schedules",
        "leave": "Leave",
        "overtime": "Overtime",
        "travel": "Travel",
        "expenses": "Expenses",
        "approvals": "Approvals",
        "approvals-count": "Approvals ({count})"
      },
      "attendance": {
        "pills": {
          "snapshot": "Daily Snapshot",
          "reports": "Attendance Reports",
          "records": "Detailed Time Records",
          "geofence": "Geofence"
        },
        "snapshot": {
          "title": "Daily Snapshot",
          "active-schedules": "Active Schedule(s)",
          "clocked-in": "Clocked in",
          "not-yet-clocked-in": "Not yet clocked in",
          "clocked-out": "Clocked out",
          "not-yet-clocked-out": "Not yet clocked out",
          "on-leave": "On leave",
          "error-title": "Could not load the snapshot",
          "drawer": {
            "clocked-in": "Employees clocked in ({count})",
            "not-yet-clocked-in": "Employees not yet clocked in ({count})",
            "clocked-out": "Employees clocked out ({count})",
            "not-yet-clocked-out": "Employees not yet clocked out ({count})",
            "on-leave": "Employees on leave ({count})",
            "empty": "No employees in this bucket."
          }
        },
        "reports": {
          "scope": {
            "label": "Group by",
            "employees": "All Employees",
            "departments": "All Org. Units"
          },
          "from": "From",
          "to": "To",
          "search-label": "Search",
          "search-placeholder": "Name, ID, or org. unit",
          "count": "{count} record(s)",
          "export": "Export CSV",
          "col": {
            "name": "Full Name",
            "code": "Employee ID",
            "org-unit": "Org. Unit",
            "shift": "Shift",
            "total": "Total",
            "status": "Status"
          },
          "legend": {
            "on-time": "On Time",
            "late-in": "Late In",
            "early-out": "Early Out",
            "missed-clock-out": "Missed Clock Out",
            "absent": "Absent",
            "leave": "Leave",
            "day-off": "Day Off",
            "public-holiday": "Public Holiday"
          },
          "error-title": "Could not load the report",
          "empty-title": "No attendance records",
          "empty-desc": "No records match the current range and filters."
        },
        "records": {
          "day": "Day",
          "status": "Status",
          "clock-in": "Clock-In",
          "clock-out": "Clock-Out",
          "duration": "Duration",
          "remark": "Remark",
          "count": "{count} record(s)",
          "remarks": {
            "late-in": "Clock In Late",
            "early-out": "Clock Out Early",
            "missed-clock-out": "Missed Clock Out",
            "resolved-missed-clock-out": "Resolved Missed Clock Out",
            "absence": "Absence",
            "resolved-absence": "Resolved Absence"
          }
        },
        "geofence": {
          "title": "Geofence Report",
          "subtitle": "Audit log of all blocked geofence clock attempts.",
          "all-employees": "All employees",
          "all-zones": "All zones",
          "violators-only": "Violators only",
          "count": "{count} row(s)",
          "stat": {
            "total": "Total blocked",
            "employees": "Unique employees",
            "zones": "Unique zones",
            "alerts": "Violation alerts"
          },
          "action": {
            "clock-in": "Clock in",
            "clock-out": "Clock out"
          },
          "reason": {
            "outside": "Outside the assigned zone",
            "none": "No zone configured for this location"
          },
          "col": {
            "when": "When",
            "employee": "Employee",
            "code": "Employee ID",
            "org-unit": "Org. Unit",
            "action": "Action",
            "zone": "Work zone",
            "distance": "Distance",
            "reason": "Reason",
            "blocked": "Blocked",
            "zones": "Zones",
            "first": "First blocked",
            "last": "Last blocked"
          },
          "empty-title": "No blocked attempts",
          "empty-desc": "No geofence violations in the selected range."
        }
      },
      "schedules": {
        "pills": {
          "schedules": "Schedules",
          "holidays": "Holidays",
          "meals": "Meal Breaks"
        },
        "create": {
          "schedule": "New Schedule",
          "holiday": "New Holiday",
          "meal": "New Meal Break"
        },
        "create-toast": "{name} — wizard coming in a subsequent slice",
        "created-toast": "{name} created",
        "search": {
          "schedules": "Search by name, type, day off…",
          "holidays": "Search by name, code, year…",
          "meals": "Search by name…"
        },
        "showing": "Showing {filtered} of {total} {kind}",
        "kind": {
          "schedules": "schedules",
          "holidays": "holiday lists",
          "meals": "meal breaks"
        },
        "kpi": {
          "schedules": "Schedules",
          "employees-assigned": "Employees assigned",
          "unused-templates": "Unused templates",
          "avg-hours": "Avg hours/week",
          "holiday-lists": "Holiday lists",
          "active": "Active",
          "total-dates": "Total dates",
          "current-year": "Current year ({year})",
          "meal-breaks": "Meal breaks",
          "schedules-using-breaks": "Schedules using breaks",
          "avg-duration": "Avg duration",
          "cambodia-standard": "Cambodia standard"
        },
        "filters": {
          "all": "All",
          "all-years": "All years",
          "all-statuses": "All statuses",
          "active": "Active",
          "inactive": "Inactive"
        },
        "actions": {
          "clear-filters": "Clear filters",
          "export": "Export",
          "edit": "Edit",
          "delete": "Delete"
        },
        "schedules-table": {
          "name": "Name",
          "type": "Type",
          "weekly-day-off": "Weekly Day Off",
          "hours-week": "Hours/wk",
          "employees": "Employees",
          "edit": "Edit",
          "empty": "No schedules match these filters",
          "info": "Schedules are templates — HR assigns one when onboarding (Step 2 of the Add Person wizard). Editing here updates all assigned staff going forward.",
          "empty-none": "No schedules yet — create one to assign working weeks."
        },
        "holidays-table": {
          "name": "Name",
          "code": "Code",
          "year": "Year",
          "type": "Type",
          "dates": "Dates",
          "status": "Status",
          "edit": "Edit",
          "empty": "No holidays match these filters",
          "info": "Standard PH lists are maintained by Optimal HR. Each tenant can clone a year and customise (add/remove specific dates, regional variants). Cambodia has ~22 PH per year — annual refresh in January.",
          "empty-none": "No holiday lists yet — create one for a calendar year."
        },
        "meals-table": {
          "name": "Name",
          "start": "Start Time",
          "end": "End Time",
          "duration": "Duration",
          "schedules-using": "Schedules using",
          "edit": "Edit",
          "minutes": "{n} min",
          "empty": "No meal breaks match this search",
          "info": "Meal breaks are reusable — pick one when you create a Schedule. Most Optimal P schedules use a 60-minute lunch break (12:00–13:00). Cambodia LL doesn't strictly mandate a break, but 60 min is industry standard.",
          "empty-none": "No meal breaks yet — create one to reuse across schedules."
        },
        "drawer": {
          "close": "Close",
          "fields": {
            "type": "Type",
            "days-off": "Weekly Day Off",
            "hours-week": "Hours / week",
            "assigned": "Employees assigned",
            "public-holiday": "Public holiday list",
            "other-holidays": "Other holidays",
            "year": "Year",
            "code": "Code",
            "status": "Status",
            "dates": "Dates",
            "start": "Start",
            "end": "End",
            "duration": "Duration",
            "schedules-using": "Schedules using this break",
            "activity": "Activity",
            "weekly-hours": "Weekly hours"
          },
          "no-value": "—"
        },
        "modal": {
          "schedule": {
            "title": "Create Schedule",
            "lede": "Working week template",
            "fields": {
              "name": "Name",
              "type": "Type"
            },
            "placeholders": {
              "name": "e.g. OP_Field_Crew"
            },
            "validation": {
              "name-required": "Schedule name is required."
            }
          },
          "holiday": {
            "title": "Create Holiday list",
            "lede": "Public-holiday list for a calendar year",
            "fields": {
              "name": "Name",
              "code": "Code",
              "year": "Year"
            },
            "placeholders": {
              "name": "e.g. Standard public holiday for 2027",
              "code": "Standard / Custom-XX"
            },
            "validation": {
              "name-required": "Holiday list name is required.",
              "code-required": "Code is required.",
              "year-invalid": "Year must be a 4-digit number."
            }
          },
          "meal": {
            "title": "Create Meal Break",
            "lede": "Reusable lunch / dinner break",
            "fields": {
              "name": "Name",
              "start": "Start time",
              "end": "End time"
            },
            "placeholders": {
              "name": "e.g. OP_Field_Lunch Break"
            },
            "validation": {
              "name-required": "Meal break name is required.",
              "time-required": "Start and end time are required.",
              "time-order": "End time must be after start time."
            }
          },
          "cancel": "Cancel",
          "submit": "Create"
        },
        "error": "Couldn’t load this data.",
        "retry": "Retry",
        "deleted-toast": "{name} deleted",
        "action-failed": "Something went wrong. Please try again."
      },
      "leave": {
        "heading": "Leave",
        "views": {
          "records": "Records",
          "calendar": "Calendar",
          "usage": "Usage"
        },
        "new-request": "New Leave Request",
        "create-toast": "Leave request wizard coming in a subsequent slice",
        "kpi": {
          "pending": "Pending",
          "approved": "Approved (in range)",
          "active-today": "On leave today",
          "rejected": "Rejected"
        },
        "filters": {
          "all": "All",
          "all-orgs": "All Org Units",
          "all-types": "All types",
          "all-statuses": "All statuses",
          "pending-lm": "Pending LM",
          "approved": "Approved",
          "rejected": "Rejected",
          "clear-filters": "Clear filters",
          "include-outsourced": "Include Outsourced",
          "all-employees": "All Employees",
          "cancelled": "Cancelled",
          "unknown": "Unknown",
          "submitted": "Submitted"
        },
        "search-placeholder": "Search employee, code or reason…",
        "info-banner": "For Outsourced staff: leave is granted per Optimal HR policy; the External LM approves the request (Optimal owns the employment relationship). Direct staff route to their direct manager.",
        "labels-line": "Labels:",
        "label-fh": "FH — First Half",
        "label-sh": "SH — Second Half",
        "label-fd": "FD — Full Day",
        "open-approvals": "Open Approvals",
        "export": "Export",
        "records": {
          "title": "Leave Records",
          "showing": "Showing {filtered} of {total}",
          "click-hint": "Click any row to open leave detail",
          "empty-title": "No leave requests match",
          "empty-lede": "Adjust the filters or clear them to see the full list."
        },
        "table": {
          "request-no": "Request No.",
          "full-name": "Full Name",
          "employee-id": "Employee ID",
          "org-unit": "Org. Unit",
          "requested": "Requested",
          "leave-request-details": "Leave Request Details",
          "total": "Total",
          "approver": "Approver",
          "status": "Status",
          "type": "Type",
          "date": "Date",
          "duration": "Duration",
          "eor-chip": "EOR"
        },
        "calendar": {
          "legend-today": "Today",
          "legend-pending": "Pending LM (dashed border)",
          "legend-click-hint": "Click a leave chip to open the request detail.",
          "empty-title": "Nothing on the calendar this month",
          "empty-lede": "Adjust filters or pick a different month."
        },
        "balances": {
          "title": "Leave balances · per employee × per type",
          "subtitle": "SRS-aligned · Yearly Grant 18d AL · Seniority +1d/5yrs (Art 166) · calendar year",
          "settings": "Settings",
          "settings-toast": "Leave Settings — coming in a subsequent slice",
          "col-employee": "Employee",
          "col-org-unit": "Org. Unit",
          "col-type": "Type",
          "col-service": "Service",
          "col-annual": "Annual",
          "col-sick": "Sick",
          "col-special": "Special",
          "col-maternity": "Maternity",
          "col-paternity": "Paternity",
          "col-unpaid": "Unpaid",
          "on-demand": "on demand",
          "footnote-line1": "Reading the cells: big number = available · small line shows allocation (with seniority bonus in brackets), used, and carry-forward from previous year.",
          "footnote-line2": "Defaults shown: AL 18d/yr · Sick 14d/yr · Special 7d/yr (deducts from AL) · Maternity 90d · Paternity 7d."
        },
        "drawer": {
          "title-prefix": "Leave Request",
          "subtitle": "{type} · {total} day(s) · {status}",
          "close": "Close drawer",
          "status-pending-line": "Submitted {at} · awaiting LM",
          "status-approved-line": "Approved on {at}",
          "status-rejected-line": "Rejected on {at}",
          "request-details": "Request details",
          "field-employee": "Employee:",
          "field-org-unit": "Org. Unit:",
          "field-type": "Type:",
          "field-total": "Total:",
          "field-total-days": "{total} day(s)",
          "field-routes-to": "Routes to:",
          "external-lm": "External LM",
          "escalates-hr": "Escalates to HR",
          "field-reason": "Reason:",
          "dates-heading": "Dates ({count})",
          "history-heading": "Audit history ({count})",
          "history-empty": "No history.",
          "action-approve": "Approve",
          "action-reject": "Reject",
          "action-approve-toast": "Leave {id} approved · {total} day(s) deducted from balance",
          "action-reject-toast": "Leave {id} rejected · returned to HR/employee",
          "status-requested-line": "Requested {at}",
          "action-error": "The action could not be completed. Please try again.",
          "field-rejection": "Reason for rejection:",
          "cancelled": "cancelled {days}d",
          "by-line-manager": "by the line manager"
        },
        "export-toast": "Leave export — coming in a subsequent slice",
        "error-title": "Couldn't load leave",
        "error-lede": "The leave report could not be loaded. Check your connection and try again.",
        "retry": "Retry",
        "usage": {
          "title": "Leave usage · per employee × per type",
          "subtitle": "Net days taken in the selected range (excludes rejected · nets out cancelled)",
          "col-employee": "Employee",
          "col-org-unit": "Org. Unit",
          "col-total": "Total",
          "footnote": "Usage is derived from the leave report for the selected date range. Per-employee allocation, carry-forward and remaining balances need the per-employee balance endpoint and land in a follow-up slice."
        },
        "reject-modal": {
          "title": "Reject leave request",
          "description": "Provide a reason for rejecting this request. The employee will see this note.",
          "placeholder": "Reason for rejection…",
          "cancel": "Cancel",
          "confirm": "Reject request"
        }
      },
      "overtime": {
        "title": "Overtime",
        "subtitle": "Track OT requests and records across the pay cycle",
        "export": "Export CSV",
        "search-label": "Search",
        "search-placeholder": "Search by employee, code, org-unit or request no.",
        "kpi": {
          "all-requests": "All Requests",
          "employees": "Employees",
          "total-overtime": "Total Overtime"
        },
        "filters": {
          "all": "All",
          "scope-label": "View by",
          "scope-id-label": "Filter",
          "by-employees": "By Employees",
          "by-org-units": "By Org. Units",
          "all-employees": "All Employees",
          "all-org-units": "All Org. Units",
          "from": "From",
          "to": "To"
        },
        "status": {
          "confirmed": "Confirmed",
          "unconfirmed": "Unconfirmed",
          "absent": "Absent",
          "pending": "Pending",
          "unknown": "Unknown",
          "submitted": "Submitted",
          "approved": "Approved",
          "rejected": "Rejected"
        },
        "day-type": {
          "weekday": "Weekday",
          "public-holiday": "Public Holiday",
          "night": "Night Time",
          "day-off": "Day Off"
        },
        "table": {
          "req-no": "Request No.",
          "employee": "Employee",
          "code": "Employee ID",
          "org-unit": "Org. Unit",
          "ot-date": "OT Date",
          "time": "Time",
          "start-time": "Start Time",
          "end-time": "End Time",
          "total-hrs": "Total Hrs",
          "payment": "Payment",
          "status": "Status",
          "line-manager": "Line Manager",
          "showing": "Showing {filtered} of {total}",
          "total-payment": "Total payment"
        },
        "actions": {
          "clear-filters": "Clear filters"
        },
        "empty": {
          "title": "No overtime records match",
          "lede": "Adjust the date range or filters to see overtime records."
        },
        "error": {
          "title": "Couldn't load overtime"
        },
        "drawer": {
          "title": "Overtime Request Details",
          "close": "Close",
          "error-title": "Couldn't load the request",
          "no-periods": "No requested periods on this request.",
          "fields": {
            "req-no": "Request No.",
            "employee-code": "Employee ID",
            "org-unit": "Org. Unit",
            "status": "Status",
            "line-manager": "Line Manager",
            "reason": "Objective",
            "requested-duration": "Requested Duration"
          }
        }
      },
      "travel": {
        "title": "Travel",
        "subtitle": "Authorise trips, disburse advances, and reconcile expenses on return.",
        "new-request": "New Travel Request",
        "create-toast": "Travel request submitted",
        "columns": "Columns",
        "search-placeholder": "Search employee, code, destination, purpose…",
        "info-banner": "Plan → Authorize → Disburse → Travel → Reconcile. Completed trips flow into the Reconciliation view for settlement against actual receipts.",
        "views": {
          "requests": "Requests",
          "reconciliation": "Reconciliation"
        },
        "filters": {
          "all": "All",
          "pending": "Pending",
          "approved": "Approved",
          "in-progress": "In-Progress",
          "completed": "Completed",
          "reconciled": "Reconciled",
          "all-depts": "All departments",
          "all-destinations": "All destinations"
        },
        "kpi": {
          "pending-requests": "Pending requests",
          "trips-this-month": "Trips this month",
          "advance-outstanding": "Advance outstanding",
          "reconciliation-pending": "Reconciliation pending"
        },
        "table": {
          "id": "ID",
          "code": "Code",
          "employee": "Employee",
          "destination": "Destination",
          "dates": "Dates",
          "departure": "Departure",
          "return": "Return",
          "purpose": "Purpose",
          "cost": "Cost",
          "estimate": "Estimate",
          "advance": "Advance",
          "exp-rpt": "Exp Rpt",
          "status": "Status",
          "actions": "Actions",
          "actual-dates": "Actual dates",
          "estimated": "Estimated",
          "actual": "Actual",
          "variance": "Variance",
          "submitted-date": "Submitted",
          "row-actions": "Row actions",
          "showing": "Showing {filtered} of {total}",
          "click-hint": "Click any row to open trip detail"
        },
        "actions": {
          "view": "View",
          "approve": "Approve",
          "reject": "Reject",
          "mark-departed": "Mark Departed",
          "approve-reconciliation": "Approve Reconciliation",
          "request-more-docs": "Request More Docs",
          "clear-filters": "Clear filters",
          "approve-toast": "Travel request {code} approved",
          "reject-toast": "Travel request {code} rejected",
          "mark-departed-toast": "Travel request {code} marked as departed",
          "approve-recon-toast": "Reconciliation {code} approved",
          "request-docs-toast": "Document request sent for {code}"
        },
        "empty": {
          "title": "No travel requests",
          "lede": "Try adjusting filters or clearing the active filter set."
        },
        "drawer": {
          "close": "Close drawer",
          "no-attachments": "No attachments uploaded.",
          "no-itinerary": "No itinerary segments recorded.",
          "fields": {
            "code": "Travel code",
            "kind": "Trip kind",
            "destination": "Destination",
            "country": "Country",
            "departure": "Departure",
            "return": "Return",
            "purpose": "Purpose",
            "estimated-cost": "Estimated cost",
            "actual-cost": "Actual cost",
            "advance": "Advance",
            "approver": "Approver",
            "status": "Status",
            "submitted-date": "Submitted",
            "decided-date": "Decided",
            "itinerary": "Itinerary",
            "cost-breakdown": "Cost breakdown",
            "attachments": "Attachments",
            "timeline": "Status timeline"
          },
          "itinerary": {
            "leg": "Leg",
            "date": "Date",
            "from": "From",
            "to": "To",
            "mode": "Mode",
            "reference": "Reference"
          },
          "cost": {
            "category": "Category",
            "estimated": "Estimated",
            "actual": "Actual"
          }
        },
        "modal": {
          "title": "New Travel Request",
          "lede": "Capture the trip plan; advance disbursement happens after approval.",
          "cancel": "Cancel",
          "submit": "Submit",
          "fields": {
            "employee": "Employee",
            "destination": "Destination",
            "departure-date": "Departure date",
            "return-date": "Return date",
            "purpose": "Purpose",
            "estimated-cost": "Estimated cost",
            "advance": "Advance amount"
          },
          "placeholders": {
            "employee": "Employee name",
            "destination": "City",
            "purpose": "Why is this trip needed?",
            "amount": "0.00"
          },
          "validation": {
            "employee-required": "Employee name is required.",
            "destination-required": "Destination is required.",
            "departure-required": "Departure date is required.",
            "return-required": "Return date is required.",
            "return-after-departure": "Return date must be on or after the departure date.",
            "cost-invalid": "Estimated cost must be a positive number.",
            "purpose-required": "Purpose is required."
          }
        },
        "reconciliation": {
          "info-banner": "Each row shows the variance between estimate and actual receipts. Approve to settle the advance; flag missing docs to send the employee a request."
        }
      },
      "expenses": {
        "heading": "Expense Claims",
        "new-claim": "New Claim",
        "settings": "Settings",
        "create-toast": "Expense claim wizard coming in a subsequent slice",
        "settings-toast": "Expense settings — Phase B",
        "info-banner-title": "Two flows.",
        "info-banner": "Advance: request advance → LM approves → Finance disburses → employee spends → submits clearance with receipts → Finance verifies → balance settled (recovered from or paid out to employee). Reimbursement: employee pays out of pocket → submits receipts → LM approves → Finance reimburses via payroll/cash/bank. Both can be tagged to a Project and optionally linked to a Travel request (TRV-xxxx).",
        "search-placeholder": "Filter by employee name…",
        "kind": {
          "all": "Both kinds",
          "advance-only": "Advance only",
          "reimbursement-only": "Reimbursement only"
        },
        "include-outsourced": "Include Outsourced",
        "showing": "Showing {filtered} of {total}",
        "outsourced-suffix": "Outsourced",
        "filters": {
          "all": "All",
          "needs-action": "⚑ Needs Action",
          "pending": "Pending",
          "approved": "Approved",
          "disbursed": "Disbursed",
          "returned": "Returned",
          "clearance-submitted": "Clr. Submitted",
          "clearance-overdue": "Clr. Overdue",
          "reimbursed": "Reimbursed",
          "settled": "Settled",
          "issue": "Issue",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "kpi": {
          "needs-action": "Needs your action",
          "needs-action-sub": "{overdue} overdue · {issue} issue",
          "pending-approval": "Pending approval",
          "pending-approval-sub": "Awaiting LM review",
          "advance-outstanding": "Advance outstanding",
          "advance-outstanding-sub": "Paid but not yet cleared",
          "reimbursement-pending": "Reimbursement pending",
          "reimbursement-pending-sub": "Approved or awaiting approval"
        },
        "table": {
          "id": "ID",
          "employee": "Employee",
          "kind": "Kind",
          "purpose": "Purpose / Project",
          "date": "Date",
          "requested": "Requested",
          "paid-out": "Paid Out",
          "actual": "Actual",
          "status": "Status",
          "internal": "Internal",
          "linked": "linked {id}",
          "days-overdue": "{days} days overdue",
          "kind-advance": "Advance",
          "kind-reimbursement": "Reimb.",
          "kind-travel-clearance": "Travel-Clr."
        },
        "status": {
          "Pending": "Pending",
          "Approved": "Approved",
          "Disbursed": "Disbursed",
          "Returned": "Returned",
          "Clearance Submitted": "Clearance Submitted",
          "Clearance Overdue": "Clearance Overdue",
          "Reimbursed": "Reimbursed",
          "Settled": "Settled",
          "Rejected": "Rejected",
          "Cancelled": "Cancelled",
          "Issue to Resolve": "Issue to Resolve"
        },
        "issue": {
          "lost-receipt": "Lost receipt",
          "over-budget": "Over budget",
          "duplicate": "Possible duplicate",
          "category-wrong": "Category misclassified"
        },
        "empty": "No claims matching this filter.",
        "drawer": {
          "title": "Expense Claim",
          "subtitle": "{id} · {employee} ({code}) · {purpose}",
          "section-status": "Status",
          "section-overview": "Overview",
          "section-lines": "Line items",
          "section-audit": "Activity",
          "field-employee": "Employee",
          "field-approver": "Approver",
          "field-kind": "Kind",
          "field-project": "Project",
          "field-linked": "Linked travel",
          "field-date": "Submission date",
          "field-requested-advance": "Requested advance",
          "field-disbursed": "Disbursed",
          "field-actual": "Actual (from receipts)",
          "field-net": "Net balance",
          "field-reimbursement-requested": "Reimbursement requested",
          "field-reimbursement-paid": "Reimbursement paid",
          "net-owed": "owed",
          "net-due": "due",
          "lines-total": "Lines total",
          "lines-empty": "No line items yet (advance not yet cleared).",
          "line-receipt": "Receipt",
          "line-amount": "Amount",
          "line-category": "Category",
          "line-description": "Description",
          "line-date": "Date",
          "close": "Close",
          "approve": "Approve",
          "reject": "Reject",
          "settle": "Settle",
          "approve-toast": "Approved {id} ({amount})",
          "reject-toast": "Rejected {id}",
          "settle-toast": "Settle flow — Phase B"
        }
      },
      "approvals": {
        "heading": {
          "oversight": "Approvals — HR Oversight",
          "my-queue": "My Queue",
          "my-queue-acting-as": "My Queue (acting as {approver})"
        },
        "subtitle": {
          "oversight": "Company-wide view across all approvers. Chase, override, or step into a queue.",
          "my-queue": "Items routed to {approver} for direct approval. Click any row for full detail.",
          "you": "you"
        },
        "views": {
          "oversight": "Oversight",
          "my-queue": "My Queue"
        },
        "kinds": {
          "all": "All",
          "attendance": "Attendance",
          "leave": "Leave",
          "overtime": "OT",
          "travel": "Travel",
          "expense": "Expense"
        },
        "kpi": {
          "total-pending": "Total pending",
          "total-pending-sub": "Across {approvers} approver(s)",
          "aging-over": "Aging > 5 days",
          "aging-over-sub": "{aging} more in 3–5d window · {fresh} fresh (≤2d)",
          "blocks-payroll": "Blocking payroll",
          "blocks-payroll-sub": "Attendance + OT — must clear before cut-off",
          "external-lms": "External LMs",
          "external-lms-sub": "Client-side approvers with pending items"
        },
        "approver-kinds": {
          "direct": "Internal LM",
          "external": "External LM",
          "self": "Self-approval"
        },
        "approver-chip": {
          "external": "External"
        },
        "by-approver": {
          "title": "Pending by approver ({count})",
          "subtitle": "Sorted by oldest pending. Chase reminds the LM; Act As lets you handle their queue.",
          "col-approver": "Approver",
          "col-count": "Count",
          "col-avg-age": "Avg Age",
          "col-oldest": "Oldest",
          "col-kinds": "Kinds",
          "col-actions": "Actions",
          "empty": "No pending items"
        },
        "all-pending": {
          "title": "All pending items ({count})",
          "subtitle": "Click a row to view the full request. Use Override only when an LM is unreachable and the deadline is at risk.",
          "col-id": "ID",
          "col-kind": "Kind",
          "col-employee": "Employee",
          "col-summary": "Summary",
          "col-amount": "Amount",
          "col-approver": "Approver",
          "col-age": "Age",
          "col-actions": "Actions",
          "empty": "No pending items"
        },
        "my-queue": {
          "col-submitted": "Submitted",
          "empty": "No pending items routed to you.",
          "empty-acting-as": "This approver has no pending items."
        },
        "actions": {
          "chase": "Chase",
          "chase-toast": "Reminder queued for {approver}",
          "act-as": "Act As",
          "act-as-toast": "Acting as {approver} — view shows their queue",
          "view": "View",
          "override": "Override ✓",
          "override-title": "HR override-approve with reason",
          "override-toast": "HR override-approve recorded for {id}",
          "approve": "Approve",
          "reject": "Reject"
        },
        "acting-as": {
          "banner": "Acting as {approver} — viewing their personal queue. Approve/Reject actions here are logged as HR-on-behalf.",
          "exit": "Exit Act-As"
        },
        "persona-note": "HR roles default to Oversight; LMs default to My Queue. Use the toggle at top-right to switch. HR can also Act As any approver from Oversight to clear their backlog (e.g., LM on leave).",
        "drawer": {
          "title-prefix": "Request",
          "subtitle": "{kind} · submitted {submitted} · {age}d ago",
          "status-pending": "Pending LM",
          "status-pending-line": "Submitted {at} · awaiting LM ({age}d old)",
          "request-details": "Request details",
          "field-employee": "Employee:",
          "field-org-unit": "Org. Unit:",
          "field-kind": "Type:",
          "field-amount": "Amount:",
          "field-summary": "Summary:",
          "field-meta": "Notes:",
          "field-routes-to": "Routes to:",
          "external-lm": "External LM",
          "history-heading": "Audit history ({count})",
          "history-empty": "No history.",
          "action-approve": "Approve",
          "action-reject": "Reject",
          "action-approve-toast": "Approved {id}",
          "action-reject-toast": "Rejected {id}",
          "close": "Close"
        }
      },
      "subtitle-suffix": "Apr 2026 · HR operations"
    },
    "workmgmt": {
      "title": "Work Management",
      "subtitle": "{scope} · {active} active work items · {critical} critical",
      "tabs": {
        "dashboard": "Dashboard",
        "mywork": "My Work",
        "teamwork": "Team Work",
        "queues": "Work Queues",
        "recurring": "Recurring Work",
        "reviews": "Reviews",
        "reports": "Reports"
      },
      "dashboard": {
        "heading": "Operational overview",
        "heading-sub": "{review} awaiting review · {overdue} overdue · {critical} critical · {active} active",
        "request-work": "Request work",
        "new-work": "New work item",
        "create-toast": "New work-item wizard coming in a subsequent slice",
        "request-toast": "Request-work form coming in a subsequent slice",
        "banner-lead": "Work Management",
        "banner-body": "orchestrates operational execution. Approvals stay in their source modules (Leave / OT / Travel / Expense). Reviewers may rate completed work — rating is optional and feeds Contribution Score for Performance Management.",
        "view-all": "View all",
        "kpi": {
          "my-open": "My open work",
          "my-open-meta": "In progress + open",
          "awaiting-review": "Awaiting review",
          "awaiting-review-meta": "Submitted, with reviewer",
          "overdue": "Overdue",
          "overdue-meta": "Needs attention",
          "contribution": "My contribution score",
          "contribution-meta": "Quarterly rolling score",
          "vs-prev": "vs prev 90d",
          "no-rated": "No rated work yet"
        },
        "table": {
          "work-item": "Work item",
          "type": "Type",
          "status": "Status",
          "priority": "Priority",
          "assignee": "Assignee",
          "due": "Due"
        },
        "awaiting": {
          "heading": "Awaiting my review",
          "sub": "{pending} pending · {active} in progress",
          "empty": "No work items awaiting your review."
        },
        "workload": {
          "heading": "Team workload",
          "sub": "Active work per person",
          "view-team": "View team",
          "active": "{n} active",
          "overdue": "{n} overdue",
          "empty": "No team members in scope."
        },
        "contributors": {
          "heading": "Top contributors (90 days)",
          "sub": "Ranked by Contribution Score",
          "all-scores": "All scores",
          "rated": "{n} rated",
          "empty": "No rated work yet."
        },
        "activity": {
          "heading": "Workspace activity",
          "sub": "Last 30 days",
          "active": "Active work",
          "completed": "Completed (30d)",
          "overdue": "Overdue",
          "avg-score": "Avg contribution score"
        },
        "recent": {
          "heading": "My recent work",
          "sub": "Open + in progress + awaiting review",
          "empty": "No recent work in your queue."
        },
        "drawer": {
          "assignee": "Assignee",
          "reviewer": "Reviewer",
          "assigner": "Assigner",
          "due": "Due",
          "dept": "Department",
          "linked-module": "Linked module",
          "rating": "Contribution rating",
          "review-comment": "Reviewer comment",
          "close": "Close"
        }
      },
      "mywork": {
        "heading": "My Work",
        "heading-sub": "{total} total",
        "self-work": "Self work",
        "create-toast": "Self-work creation form coming in a subsequent slice",
        "kpi": {
          "open": "Open",
          "progress": "In progress",
          "review": "Review",
          "overdue": "Overdue"
        },
        "filters": {
          "search-placeholder": "Search by title or ID…",
          "all-statuses": "All statuses",
          "status-open": "Open",
          "status-progress": "In progress",
          "status-review": "Review",
          "status-done": "Done",
          "all-types": "All work types",
          "type-adhoc": "Ad-hoc",
          "type-recurring": "Recurring",
          "all-priorities": "All priorities",
          "priority-high": "High",
          "priority-med": "Medium",
          "priority-low": "Low"
        },
        "stub": {
          "title": "My work items",
          "lede": "Personal task board grouped by status with overdue badges, recurring instances, and contribution-rating callbacks. The grid view + drawer-based task detail land in a subsequent slice; data shape mirrors the proto's `wmRenderTaskList()` helper."
        }
      },
      "teamwork": {
        "heading": "Team Work",
        "heading-sub": "Work you review · {total} total",
        "heading-sub-admin": "All workspace work · {total} total",
        "assign-work": "Assign work",
        "create-toast": "Assign-work form coming in a subsequent slice",
        "result-count": "{n} work items",
        "kpi": {
          "open": "Open",
          "progress": "In progress",
          "review": "Review",
          "overdue": "Overdue"
        },
        "filters": {
          "search-placeholder": "Search…",
          "all-statuses": "All statuses",
          "all-types": "All work types",
          "all-assignees": "All assignees"
        },
        "table": {
          "work-item": "Work item",
          "type": "Type",
          "status": "Status",
          "priority": "Priority",
          "assignee": "Assignee",
          "due": "Due"
        },
        "empty": {
          "title": "No work items match",
          "lede": "Loosen a filter or clear the search to see more work."
        },
        "drawer": {
          "close": "Close drawer",
          "dept": "Dept · {dept}",
          "description": "Description",
          "assignee": "Assignee",
          "reviewer": "Reviewer",
          "assigner": "Assigned by",
          "due": "Due",
          "start": "Start",
          "linked": "Linked to",
          "tags": "Tags"
        }
      },
      "queues": {
        "heading": "Work Queues",
        "heading-sub": "Optimal P · {total} active work items across queues",
        "banner-lead": "Work Queues",
        "banner-body": "group active work by operational area for monitoring at a glance. The Critical Queue surfaces overdue and at-risk items needing immediate attention.",
        "view-all": "View all in queue",
        "all-clear": "All clear in this queue",
        "card-aria": "Open {name} detail",
        "counts": {
          "active": "Active",
          "at-risk": "At Risk",
          "overdue": "Overdue"
        },
        "cards": {
          "payroll": {
            "name": "Payroll Queue",
            "desc": "Payroll operations & follow-ups"
          },
          "hrops": {
            "name": "HR Ops Queue",
            "desc": "HR operations, onboarding, employee changes"
          },
          "compliance": {
            "name": "Compliance Queue",
            "desc": "Statutory declarations, audits, permits"
          },
          "fieldops": {
            "name": "Field Ops Queue",
            "desc": "Site inspections, field execution"
          },
          "critical": {
            "name": "Critical Queue",
            "desc": "Urgent attention required (overdue, at-risk, critical)"
          }
        },
        "drawer": {
          "sub": "{n} active",
          "empty": "No active work in this queue.",
          "close": "Close drawer",
          "cols": {
            "work-item": "Work item",
            "status": "Status",
            "assignee": "Assignee",
            "due": "Due"
          }
        }
      },
      "recurring": {
        "heading": "Recurring Work",
        "heading-sub": "Auto-generated on a schedule from operational templates · {total} active",
        "new-template": "New template",
        "create-toast": "Template editor coming in a subsequent slice",
        "banner": "Templates generate operational work on a schedule (e.g., monthly NSSF declaration, weekly site inspection). Editor for checklists, reviewer rules, and SLA defaults lands in a subsequent slice.",
        "result-count": "{n} work items",
        "kpi": {
          "open": "Open",
          "progress": "In progress",
          "review": "Review",
          "overdue": "Overdue"
        },
        "filters": {
          "search-placeholder": "Search…",
          "all-statuses": "All statuses",
          "all-priorities": "All priorities",
          "all-assignees": "All assignees"
        },
        "table": {
          "work-item": "Work item",
          "type": "Type",
          "status": "Status",
          "priority": "Priority",
          "assignee": "Assignee",
          "due": "Due"
        },
        "empty": {
          "title": "No recurring work matches",
          "lede": "Loosen a filter or clear the search to see more recurring work."
        },
        "drawer": {
          "close": "Close drawer",
          "dept": "Dept · {dept}",
          "description": "Description",
          "assignee": "Assignee",
          "reviewer": "Reviewer",
          "assigner": "Assigned by",
          "due": "Due",
          "start": "Start",
          "linked": "Linked to",
          "tags": "Tags"
        }
      },
      "reviews": {
        "heading": "Reviews",
        "heading-sub": "{pending} awaiting your review",
        "export-evidence": "Export evidence pack",
        "export-toast": "Performance evidence pack — coming with Performance module",
        "banner-lead": "Contribution review:",
        "banner-body": "When a reviewer rates a work item (4 dimensions × 1–5 stars), each gets a score. Scores aggregate by employee over 90 days, weighted by impact (high × 2.0, medium × 1.5, low × 1.0). Rating is optional — accepting without rating is fine for low-stakes work.",
        "empty": "No work items here.",
        "system": "System",
        "unknown": "Unknown",
        "contrib": {
          "label": "My contribution score · last 90 days",
          "meta": "Based on {count} rated work items · {arrow} {delta} vs previous period"
        },
        "pills": {
          "pending": "Pending review ({n})",
          "received": "Ratings received ({n})",
          "given": "Ratings given ({n})"
        },
        "cols": {
          "work-item": "Work item",
          "type": "Type",
          "status": "Status",
          "priority": "Priority",
          "assignee": "Assignee",
          "due": "Due",
          "score": "Score",
          "q": "Q",
          "time": "Time",
          "init": "Init",
          "coll": "Coll",
          "badge": "Badge",
          "rated": "Rated"
        },
        "status": {
          "open": "Open",
          "progress": "In Progress",
          "review": "Awaiting Review",
          "done": "Completed",
          "revision": "Needs Revision",
          "overdue": "Overdue",
          "cancelled": "Cancelled"
        },
        "type": {
          "assigned": "Assigned",
          "request": "Work Request",
          "self": "Self Work",
          "recurring": "Recurring",
          "system": "System"
        },
        "priority": {
          "low": "Low",
          "normal": "Normal",
          "high": "High",
          "urgent": "Urgent"
        },
        "impact": {
          "low": "Low",
          "medium": "Medium",
          "high": "High"
        },
        "sla": {
          "warning": "At Risk",
          "critical": "Critical",
          "breached": "Overdue"
        },
        "aging": {
          "overdue": "{n}d overdue",
          "today": "Due today",
          "tomorrow": "Due tomorrow",
          "in-days": "Due in {n}d"
        },
        "rel": {
          "in-days": "in {n}d",
          "today": "today",
          "days-ago": "{n}d ago",
          "weeks-ago": "{n}w ago",
          "months-ago": "{n}mo ago",
          "years-ago": "{n}y ago"
        },
        "dim": {
          "quality": {
            "label": "Quality",
            "help": "Met the standard?"
          },
          "timeliness": {
            "label": "Timeliness",
            "help": "On time?"
          },
          "initiative": {
            "label": "Initiative",
            "help": "Took ownership?"
          },
          "collab": {
            "label": "Collaboration",
            "help": "Worked well with others?"
          }
        },
        "badge": {
          "helpful": "Helpful",
          "fast": "Fast Response",
          "reliable": "Reliable",
          "accurate": "Accurate",
          "solver": "Problem Solver",
          "collab": "Collaborative",
          "proactive": "Proactive",
          "above": "Above & Beyond"
        },
        "aside": {
          "dim-heading": "My dimension breakdown",
          "dim-sub": "Average per dimension",
          "top-heading": "Top contributors",
          "top-sub": "Ranked by Contribution Score",
          "rated-count": "{n} rated",
          "you-tag": "You"
        },
        "drawer": {
          "close": "Close drawer",
          "assigned-by": "Assigned by {name}",
          "due": "Due {date}",
          "description": "Description",
          "assignee": "Assignee",
          "reviewer": "Reviewer",
          "start": "Started",
          "due-label": "Due",
          "linked-module": "Linked module",
          "linked-record": "Linked record",
          "impact-label": "{level} impact",
          "rating-heading": "Rating",
          "overall-label": "Overall score",
          "overall-meta": "Rated by {name} · {when}",
          "badge-label": "Badge",
          "no-rating": "Not rated yet — rating is optional and can be added when accepting the work."
        }
      },
      "reports": {
        "heading": "Reports",
        "heading-sub": "Operational analytics across modules",
        "toast-open": "Open {name} report",
        "tiles": {
          "throughput": {
            "label": "Throughput",
            "desc": "Completed work-items per period · by team / queue / individual."
          },
          "cycle-time": {
            "label": "Cycle Time",
            "desc": "Mean / median time from open → done, broken down by status transitions."
          },
          "sla": {
            "label": "SLA Adherence",
            "desc": "% within SLA, miss reasons, recurring offenders."
          },
          "workload": {
            "label": "Workload Distribution",
            "desc": "Per-assignee load balance with overload / starve detection."
          }
        }
      }
    },
    "perform": {
      "title": "Performance",
      "subtitle": "Continuous Performance · Workforce Intelligence · evidence-driven · governed by HR & LM",
      "persona": {
        "current": "Current view",
        "demo-label": "Demo · switch persona",
        "admin": {
          "label": "HR Admin / HR Director",
          "note": "Governance · templates · cycles · calibration · fairness oversight · audit"
        },
        "lm": {
          "label": "Line Manager",
          "note": "Coaching · KPI alignment · evidence validation · manager review"
        },
        "employee": {
          "label": "Employee",
          "note": "Self-development · propose KPIs · log progress · acknowledge"
        }
      },
      "tabs": {
        "dashboard": "Dashboard",
        "cycles": "Cycles",
        "templates": "Templates",
        "competency": "Competency Library",
        "goals": "Goals & KPI",
        "reviews": "Reviews",
        "calibration": "Calibration",
        "devplans": "Development Plans",
        "reports": "Reports",
        "settings": "Settings"
      },
      "dashboard": {
        "title": "HR Admin Dashboard",
        "view-mode": "View",
        "view-standard": "Standard",
        "view-executive": "Executive",
        "exec-view-toast": "Executive view — coming in a follow-up slice",
        "cycle-sub": "{cycle} · {stage} stage · {participants} eligible employees",
        "banner": "{cycle} · {stage} stage · {selfPct}% self-reviews submitted · {mgrPct}% manager reviews submitted · Manager Review deadline {deadline}",
        "action": {
          "settings": "Settings",
          "open-cycle": "Open active cycle"
        },
        "attention": {
          "title": "Attention required",
          "open-cycle": "Open cycle →",
          "overdue-rev": {
            "title": "14 manager reviews past deadline",
            "sub": "H1 2026 · escalation due to dept heads",
            "cta": "Resolve"
          },
          "calib-stalled": {
            "title": "Calibration session stalled at Step 2 of 4",
            "sub": "HR + Finance calibration · 5 days idle",
            "cta": "Reopen"
          },
          "risk-flagged": {
            "title": "3 employees flagged High risk for the cycle",
            "sub": "Below-expectations + missed 1:1s in last 60 days",
            "cta": "Triage"
          },
          "feedback-gap": {
            "title": "Feedback coverage at 38% — target 70%",
            "sub": "Most-missing: Engineering pod B · Customer Success",
            "cta": "Nudge"
          }
        },
        "kpi": {
          "section": "KPI overview",
          "active-cycles": {
            "label": "Active review cycles",
            "meta": "H1 2026 · Manager Review stage"
          },
          "pending-evals": {
            "label": "Pending evaluations",
            "meta": "Awaiting manager review · due 25 May"
          },
          "overdue-mgr": {
            "label": "Overdue manager reviews",
            "meta": "Past cycle deadline · escalation due"
          },
          "calibration-pending": {
            "label": "Calibration pending",
            "meta": "HR + Finance ready to calibrate"
          },
          "completed": {
            "label": "Completed reviews",
            "meta": "41% of cycle complete"
          },
          "below-expect": {
            "label": "Below expectations",
            "meta": "Employees needing support"
          },
          "top-performers": {
            "label": "Top performers",
            "meta": "Outstanding + Exceeds"
          },
          "dev-pending": {
            "label": "Dev plans pending",
            "meta": "Awaiting your approval"
          }
        },
        "stub": {
          "title": "Below-the-fold dashboard sections",
          "lede": "Variance heatmap · risk index · distribution chart · cycle progress timeline · top-5 most-late managers. Ports incrementally in P19+."
        },
        "watchlist": {
          "title": "Performance Risk Index",
          "formula": "Composite of attendance · OT · SLA · delayed goals · calibration variance · engagement",
          "hint": "High-priority individuals · {n} on the watchlist · click row to open the risk profile",
          "bucket": {
            "low-sub": "Performing well · no flags",
            "med-sub": "1–2 signals · watch list",
            "high-sub": "3+ signals · intervention needed",
            "critical-sub": "Immediate intervention"
          },
          "tier": {
            "low": "Low",
            "med": "Medium",
            "high": "High",
            "critical": "Critical"
          },
          "col": {
            "employee": "Employee",
            "dept": "Dept",
            "signals": "Risk signals",
            "score": "Score",
            "tier": "Tier",
            "actions": "Actions"
          },
          "action": {
            "open": "Open full detail",
            "coaching": "Create coaching plan",
            "schedule": "Schedule 1:1",
            "coaching-toast": "Coaching plan for {name} — coming in a follow-up slice",
            "schedule-toast": "Schedule 1:1 with {name} — coming in a follow-up slice"
          },
          "drawer": {
            "title": "Risk profile · {name}",
            "subtitle": "Risk score {score}/100 · {tier}",
            "close": "Close",
            "devplans": "Open dev plans",
            "banner": {
              "critical": "composite risk score · immediate intervention recommended",
              "high": "composite risk score · intervention recommended within 2 weeks",
              "med": "composite risk score · watch list · check in monthly",
              "low": "composite risk score · low priority"
            },
            "why-title": "Why this score · weighted breakdown",
            "composite": "Composite risk = {points} points (signals) ≈ {score}/100 (normalised)",
            "col": {
              "signal": "Signal",
              "weight": "Weight",
              "source": "Data source"
            },
            "scale": "Scale: {scale}. Signals refresh nightly from connected modules · last refresh: this morning 04:00.",
            "context": "Employee context",
            "kv": {
              "role": "Role",
              "dept": "Department",
              "manager": "Manager",
              "score": "Current risk score"
            },
            "actions-title": "Recommended actions",
            "actions": {
              "schedule-1on1": "Schedule 1:1 with manager within 7 days",
              "review-devplan": "Review development plan · adjust if needed",
              "reduce-workload": "Reduce workload / OT if applicable",
              "coaching-engagement": "Consider coaching engagement or wellness check-in",
              "monitor-weekly": "Monitor signals weekly",
              "recheck-cycle": "Re-check at next cycle",
              "add-watchlist": "Add to manager's watch list",
              "maintain": "Maintain current trajectory",
              "reevaluate": "Re-evaluate quarterly"
            },
            "copilot-title": "AI Copilot actions"
          }
        }
      },
      "lm": {
        "tabs": {
          "my-perf": "My Performance",
          "my-goals": "My Goals",
          "my-review": "My Review",
          "my-feedback": "Feedback Received",
          "my-dev": "Development & History",
          "team-reviews": "My Team Reviews",
          "team-goals": "Team Goals",
          "feedback-given": "Feedback Given",
          "team-snapshot": "Team Snapshot"
        },
        "stubs": {
          "my-perf": {
            "title": "My Performance",
            "lede": "Personal performance dashboard — current cycle progress, rating preview, manager evidence, KPI attainment. Port lands in Phase B."
          },
          "my-goals": {
            "title": "My Goals",
            "lede": "Your goal lifecycle (Active · Proposal · Draft · Closed), cascade to team goals, KPI progress, milestones. Port lands in Phase B."
          },
          "my-review": {
            "title": "My Review",
            "lede": "Self-review form (current cycle) + manager review preview + acknowledge after release. Port lands in Phase B."
          },
          "my-feedback": {
            "title": "Feedback Received",
            "lede": "Feedback from your manager, peers, and skip-level. Filterable by tag, period, sentiment. Port lands in Phase B."
          },
          "my-dev": {
            "title": "Development & History",
            "lede": "Your active development plan, completed cycles, rating history, training completed. Port lands in Phase B."
          },
          "team-reviews": {
            "title": "Team Reviews",
            "lede": "Per-direct-report review state · evidence trail · manager review form · approve & submit. Port lands in Phase B."
          },
          "team-goals": {
            "title": "Team Goals",
            "lede": "Filtered cascade view of your direct reports' goals · pending approvals · KPI thresholds. Port lands in Phase B."
          },
          "feedback-given": {
            "title": "Feedback Given",
            "lede": "Feedback log of what you sent to your team. Drafts, scheduled, and historical. Port lands in Phase B."
          },
          "team-snapshot": {
            "title": "Team Snapshot",
            "lede": "One-glance team health — review completion, rating distribution preview, attendance/eng signals from HR Ops. Port lands in Phase B."
          }
        }
      },
      "ee": {
        "tabs": {
          "my-perf": "My Performance",
          "my-goals": "My Goals",
          "my-review": "My Review",
          "my-feedback": "Feedback Received",
          "my-dev": "Development & History"
        },
        "stubs": {
          "my-perf": {
            "title": "My Performance",
            "lede": "Personal performance dashboard — current cycle progress, rating preview, manager evidence, KPI attainment. Port lands in Phase B."
          },
          "my-goals": {
            "title": "My Goals",
            "lede": "Your goal lifecycle (Active · Proposal · Draft · Closed), KPI progress, milestones. Port lands in Phase B."
          },
          "my-review": {
            "title": "My Review",
            "lede": "Self-review form (current cycle) + manager review preview + acknowledge after release. Port lands in Phase B."
          },
          "my-feedback": {
            "title": "Feedback Received",
            "lede": "Feedback from your manager, peers, and skip-level. Filterable by tag, period, sentiment. Port lands in Phase B."
          },
          "my-dev": {
            "title": "Development & History",
            "lede": "Your active development plan, completed cycles, rating history, training completed. Port lands in Phase B."
          }
        }
      },
      "cycles": {
        "title": "Review cycles",
        "subtitle": "All review cycles · {total} total · {active} active",
        "templates-btn": "Templates",
        "create": "Create cycle",
        "banner-strong": "{templates} evaluation templates",
        "banner-rest": "available · used by {usage} employees across all cycles",
        "confirm-close": "Close this cycle? All non-final reviews will be archived.",
        "col": {
          "cycle": "Cycle",
          "period": "Period",
          "status": "Status",
          "stage": "Stage",
          "progress": "Progress",
          "participants": "Participants",
          "actions": "Actions"
        },
        "cell": {
          "self-mgr": "{self} self · {mgr} mgr",
          "overall": "{pct}% overall"
        },
        "action": {
          "view": "View",
          "edit": "Edit"
        },
        "timeline": {
          "setup": "Setup",
          "self": "Self-Review",
          "mgr": "Manager Review",
          "calib": "Calibration",
          "close": "Closed"
        },
        "drawer": {
          "close": "Close",
          "close-cta": "Close",
          "close-cycle": "Close cycle",
          "edit-timeline": "Edit timeline",
          "sub": "{period} · {count} eligible employees · Status: {status}",
          "id": "Cycle ID",
          "type": "Type",
          "template": "Template",
          "mixed": "Mixed (per role family)",
          "current-stage": "Current stage",
          "self-reviews": "Self-reviews",
          "mgr-reviews": "Manager reviews",
          "calibrated": "Calibrated",
          "submitted": "{done}/{total} submitted",
          "timeline": "Timeline"
        },
        "toast": {
          "closed": "Cycle closed · {name}"
        },
        "wizard": {
          "rail-title": "Setup steps",
          "cancel": "Cancel",
          "back": "Back",
          "next": "Next",
          "save-draft": "Save draft",
          "save-changes": "Save changes",
          "create-launch": "Create & launch",
          "title": {
            "create": "Create new review cycle",
            "edit": "Edit cycle — {name}",
            "unnamed": "unnamed",
            "sub": "Step {n} of {total} · {label}"
          },
          "step": {
            "setup": {
              "label": "Setup",
              "desc": "Cycle name, type, and overall period."
            },
            "eligibility": {
              "label": "Eligibility",
              "desc": "Who is included in this cycle."
            },
            "template": {
              "label": "Template",
              "desc": "Which evaluation template applies."
            },
            "calibration": {
              "label": "Calibration",
              "desc": "Calibration window and rules."
            },
            "notify": {
              "label": "Notifications",
              "desc": "Who is notified and when."
            },
            "review": {
              "label": "Review & Create",
              "desc": "Final check before launch."
            }
          },
          "setup": {
            "name": "Cycle name",
            "name-ph": "e.g. H2 2026 Performance Review",
            "type": "Cycle type",
            "start": "Period start",
            "end": "Period end",
            "self-deadline": "Self-review deadline",
            "mgr-deadline": "Manager-review deadline",
            "period-label": "Period"
          },
          "type": {
            "half-yearly": "Half-yearly",
            "quarterly": "Quarterly",
            "annual": "Annual",
            "project-based": "Project-based",
            "probation": "Probation",
            "mid-cycle": "Mid-cycle"
          },
          "elig": {
            "dept": "Department",
            "dept-all": "All departments",
            "emp-type": "Employment type",
            "emp-all": "All (Direct + Outsourced)",
            "emp-direct": "Direct staff only",
            "emp-outsourced": "Outsourced only",
            "emp-external": "External (client) — typically excluded",
            "emp-hint": "External employees usually skip performance review (managed by client).",
            "manager": "Manager (optional · narrow to one manager's team)",
            "manager-all": "All managers",
            "live-preview": "Eligible employees · live preview",
            "empty": "No employees match. Loosen filters.",
            "sample": "Computed live from active employees + filters."
          },
          "tpl": {
            "pick": "Pick an evaluation template",
            "meta": "{comps} components · {usage} in use"
          },
          "calib": {
            "required": "Calibration required?",
            "yes": "Yes (recommended) — ratings discussed before final lock",
            "no": "No — manager rating is final",
            "deadline": "Calibration deadline",
            "window": "Calibration window (days)",
            "w7": "1 week",
            "w14": "2 weeks (typical)",
            "w21": "3 weeks",
            "w30": "1 month",
            "info": "During calibration, HR + managers discuss outliers and variance. Ratings are locked at the end of this window.",
            "skip": "Skipping calibration is not recommended — manager-rating variance won't be checked."
          },
          "notify": {
            "launch": "Send launch announcement",
            "launch-hint": "Email all eligible employees when the cycle opens.",
            "r7": "7-day deadline reminder",
            "r7-hint": "Auto-reminder one week before each deadline.",
            "r1": "1-day deadline reminder",
            "r1-hint": "Final reminder 24 hours before each deadline.",
            "mgr": "Manager nudges",
            "mgr-hint": "Daily digest to managers showing pending reviews.",
            "exec": "Executive summary",
            "exec-hint": "Weekly summary to HR Director and CEO during the cycle.",
            "welcome": "Welcome message to participants (optional)",
            "welcome-ph": "Optional message included in launch email."
          },
          "review": {
            "ready": "Ready to launch. Review the summary below and confirm.",
            "missing": "Cycle is missing required information ({bits}). Go back to fix.",
            "no-name": "name",
            "no-elig": "no eligible employees",
            "eligible": "Eligible count",
            "selected": "Selected",
            "yes": "Yes",
            "no": "No",
            "on": "On",
            "off": "Off"
          },
          "toast": {
            "missing": "Cannot launch — fix the missing info on the Review step.",
            "saved": "Cycle saved · {name}",
            "launched": "Cycle \"{name}\" created and launched ({count} participants).",
            "draft": "Cycle \"{name}\" saved as draft."
          }
        }
      },
      "templates": {
        "title": "Evaluation Templates",
        "subtitle": "{count} templates · used by {employees} employees in current cycle",
        "create": "New template",
        "create-toast": "Template editor — coming in a follow-up slice",
        "open-toast": "Template detail drawer — coming in a follow-up slice",
        "usage": "Used by {n} employees",
        "usage-suffix": "{n} in use",
        "weight-distribution": "Component weight distribution",
        "components-head": "Components ({n})",
        "more": "+{n} more",
        "open-cta": "Click to view / edit →",
        "versions": "no versions | {n} version | {n} versions",
        "cycles": "no cycles | {n} cycle | {n} cycles",
        "version": {
          "active": "active",
          "archived": "archived"
        },
        "items": {
          "tpl-mgmt": {
            "name": "Strategic / Management",
            "roles": "Department Heads · Senior Managers · Directors",
            "owner": "HR Director"
          },
          "tpl-ops": {
            "name": "Operational / Back-Office",
            "roles": "Finance · HR · IT · Operations · Admin",
            "owner": "Operations Director"
          },
          "tpl-sales": {
            "name": "Sales",
            "roles": "Sales Reps · Field Sales · Sales Supervisors",
            "owner": "Sales Director"
          },
          "tpl-tech": {
            "name": "Engineering / Tech",
            "roles": "Engineers · Designers · Data",
            "owner": ""
          }
        }
      },
      "competency": {
        "title": "Competency Library",
        "subtitle": "{total} competencies · {system} system default · {tenant} tenant custom · reusable across reviews, development plans, succession & job profiles",
        "import": "Import",
        "export": "Export",
        "new": "New competency",
        "result-count": "Showing {n} of {total}",
        "action": {
          "import-toast": "Import CSV / XLSX — coming in a follow-up slice",
          "export-toast": "Export filtered list — coming in a follow-up slice",
          "new-toast": "Competency editor — coming in a follow-up slice",
          "add-category-toast": "Add category — coming in a follow-up slice",
          "bulk-archive-toast": "Archive {n} selected — coming in a follow-up slice",
          "row-edit-toast": "Edit {name} — coming in a follow-up slice",
          "row-clone-toast": "Clone {name} to tenant library — coming in a follow-up slice",
          "row-archive-toast": "Archive {name} — coming in a follow-up slice",
          "row-delete-toast": "Delete {name} — coming in a follow-up slice",
          "view": "View",
          "edit": "Edit",
          "clone": "Clone to edit",
          "archive": "Archive",
          "delete": "Delete"
        },
        "summary": {
          "total": "Total competencies",
          "total-sub": "{system} system · {tenant} tenant",
          "categories": "Active categories",
          "categories-sub": "of {total} available",
          "templates": "Templates using",
          "templates-sub": "of {total} templates link a competency",
          "draft": "Draft competencies",
          "draft-sub": "{archived} archived total"
        },
        "sidebar": {
          "title": "Categories",
          "all": "All competencies",
          "add": "Add a new category",
          "expand": "Expand sidebar",
          "collapse": "Collapse sidebar",
          "hint": "Tip · click + above to add a tenant-specific category."
        },
        "filter": {
          "search-placeholder": "Search by name or description…",
          "search-aria": "Search competencies",
          "advanced": "Show advanced settings",
          "source": {
            "label": "Source",
            "all": "All sources"
          },
          "type": {
            "label": "Type",
            "all": "All types"
          },
          "status": {
            "label": "Status",
            "all": "All statuses"
          }
        },
        "view": {
          "label": "View toggle",
          "cards": "Cards view",
          "table": "Table view"
        },
        "bulk": {
          "aria": "Bulk actions",
          "selected": "competency selected | competencies selected",
          "archive": "Archive",
          "clear": "Clear"
        },
        "source": {
          "system": "System default",
          "tenant": "Tenant custom"
        },
        "status": {
          "active": "Active",
          "draft": "Draft",
          "archived": "Archived"
        },
        "card": {
          "templates": "template | templates",
          "versions": "version | versions",
          "owner": "Governance owner",
          "updated": "Last updated"
        },
        "table": {
          "select-all": "Select all rows",
          "name": "Competency name",
          "category": "Category",
          "type": "Type",
          "levels": "Levels",
          "templates": "Linked templates",
          "templates-suffix": "template | templates",
          "status": "Status",
          "updated": "Last updated",
          "version": "Version",
          "actions": "Actions"
        },
        "empty": {
          "archived": {
            "title": "No archived competencies",
            "body": "Archived competencies appear here. None of your tenant competencies have been archived yet.",
            "cta": "Show active competencies"
          },
          "category": {
            "title": "Nothing in {label} yet",
            "body": "No competencies are tagged with this category. Create one or browse all categories from the sidebar.",
            "cta": "All competencies"
          },
          "search": {
            "title": "No results for \"{q}\"",
            "body": "Try a shorter term or check the spelling. Search looks at name and description.",
            "cta": "Clear search"
          },
          "filter": {
            "title": "No competencies match the current filter combination",
            "body": "Try clearing one or more filters to widen the result set.",
            "cta": "Clear all filters"
          }
        },
        "drawer": {
          "close": "Close drawer",
          "close-cta": "Close",
          "system-readonly": "System default (read-only)",
          "system-banner": {
            "title": "System Default",
            "body": "provided by Optimal HR as a starter. Read-only — to customise, clone to your tenant library."
          },
          "description": "Description",
          "no-desc": "No description.",
          "category": "Category",
          "type": "Competency type",
          "source-k": "Library source",
          "status": "Status",
          "owner": "Governance owner",
          "scale": "Proficiency scale",
          "version": "Active version",
          "cloned-from": "Cloned from",
          "levels": "Proficiency levels ({n})",
          "usage": "Usage mapping",
          "usage-templates": "Templates ({n})",
          "usage-departments": "Departments",
          "no-templates": "Not yet linked to any template — safe to delete",
          "all-depts": "All departments",
          "history": "Version history ({n})",
          "clone": "Clone to Tenant Library",
          "duplicate": "Duplicate",
          "archive": "Archive",
          "edit": "Edit"
        }
      },
      "goals": {
        "title": "Goals & OKRs",
        "subtitle": "Hybrid SMART + OKR · {total} goals ({smart} SMART · {okr} OKR) · {aligned} cascaded",
        "cascade": "Cascade corporate",
        "cascade-toast": "Corporate cascade drawer — coming in a follow-up slice",
        "create": "New goal",
        "create-toast": "Create goal drawer — coming in a follow-up slice",
        "checkin-toast": "Check-in drawer for {id} — coming in a follow-up slice",
        "edit-toast": "Edit drawer for {id} — coming in a follow-up slice",
        "adjust-toast": "Mid-cycle adjust drawer for {id} — coming in a follow-up slice",
        "complete": "complete",
        "result-count": "{n} goals match",
        "kpi": {
          "active": "Active goals",
          "active-sub": "{smart} SMART · {okr} OKR",
          "on-track": "On-track or achieved",
          "on-track-sub": "{achieved} achieved",
          "at-risk": "At risk or off-track",
          "at-risk-sub": "{low} low confidence",
          "avg-progress": "Avg. progress",
          "avg-progress-sub": "across all goals",
          "alignment": "Alignment coverage",
          "alignment-sub": "{aligned} cascaded"
        },
        "filter": {
          "type": {
            "label": "Type",
            "all": "All types",
            "smart": "SMART KPI only",
            "okr": "OKR only"
          },
          "status": {
            "label": "Status",
            "all": "All statuses"
          },
          "dept": {
            "label": "Dept",
            "all": "All depts"
          }
        },
        "status": {
          "not_started": "Not started",
          "on_track": "On track",
          "at_risk": "At risk",
          "off_track": "Off track",
          "achieved": "Achieved",
          "missed": "Missed"
        },
        "type-desc": {
          "smart": "Specific, Measurable, Achievable, Relevant, Time-bound. Weighted contribution to evaluation.",
          "okr": "Objective + 3-5 Key Results. Aspirational scoring (0.0-1.0 per KR, averaged)."
        },
        "col": {
          "goal": "Goal",
          "type": "Type",
          "owner": "Owner",
          "lifecycle": "Lifecycle",
          "source": "Source",
          "weight": "Weight",
          "progress": "Progress",
          "status": "Status",
          "confidence": "Confidence",
          "last-checkin": "Last check-in",
          "actions": "Actions"
        },
        "action": {
          "view": "View",
          "checkin": "Log check-in",
          "edit": "Edit",
          "adjust": "Mid-cycle adjust"
        },
        "empty": {
          "title": "No goals match your filters",
          "sub": "Try clearing one of the filters above.",
          "clear": "Clear filters"
        },
        "drawer": {
          "close": "Close drawer",
          "close-cta": "Close",
          "lifecycle": "Lifecycle",
          "step": "step {n}/10",
          "progress": "Progress",
          "status": "Status",
          "confidence": "Confidence",
          "weight": "Weight",
          "owner": "Owner",
          "source": "Source",
          "parent": "parent",
          "cycle": "Cycle",
          "last-checkin": "Last check-in",
          "alignment": "Alignment",
          "description": "Description"
        }
      },
      "reviews": {
        "title": "Review Pipeline",
        "subtitle": "H1 2026 cycle · org-wide manager review status · {total} reviews across {managers} managers · {pct}% submitted or beyond",
        "nudge": "Nudge pending managers",
        "nudge-toast": "Bulk reminder sent to all pending managers (demo)",
        "go-calibration": "Go to calibration",
        "state": {
          "not_started": "Not started",
          "self_in_progress": "Self draft",
          "self_submitted": "Self submitted",
          "manager_in_progress": "Manager review",
          "manager_submitted": "Manager submitted",
          "pending_calibration": "Pending calibration",
          "calibrated": "Calibrated",
          "acknowledged": "Acknowledged"
        },
        "filter": {
          "all": "All states",
          "pending": "Pending (manager not yet submitted)",
          "submitted": "Manager submitted",
          "complete": "Calibrated / Acknowledged"
        },
        "mgr": {
          "summary": "{dept} · {total} direct reports · {submitted} submitted",
          "submitted-pct": "{pct}% submitted",
          "nudge-toast": "Reminder sent to {name} (demo)",
          "expand": "Expand {name}",
          "collapse": "Collapse {name}",
          "nudge-aria": "Nudge {name}"
        },
        "row": {
          "employee": "Employee",
          "self-submitted": "Self submitted",
          "manager-submitted": "Manager submitted",
          "state": "State",
          "rating-self": "Self rating",
          "rating-manager": "Manager rating",
          "open": "Open",
          "open-aria": "Open review workspace for {name}",
          "open-toast": "Review workspace for {name} — coming in a follow-up slice"
        },
        "empty-filter": "No managers match this filter."
      },
      "calibration": {
        "title": "Calibration Workshop",
        "subtitle-pill": "H1 2026 · {pending} pending sign-off",
        "subtitle": "Performance × Potential · drag employees between cells or use the ⋮ menu · sign off to lock ratings and transition reviews to {calibrated}",
        "calibrated-bold": "Calibrated",
        "export-csv": "Export CSV",
        "export-pdf": "Export PDF",
        "sign-off-lock-n": "Sign off & lock ({count})",
        "sign-off-lock": "Sign off & lock ratings",
        "nudge": "Nudge flagged managers",
        "open": "Open session",
        "open-toast": "Calibration session UI — coming in a follow-up slice",
        "export-csv-toast": "Calibration CSV exported (demo)",
        "export-pdf-toast": "Calibration PDF exported (demo)",
        "sign-off-toast": "Sign-off & lock — coming in a follow-up slice",
        "nudge-toast": "Reminder sent to managers with variance flags (demo)",
        "axis": {
          "perf-low": "← Lower performance",
          "perf-solid": "Solid performance",
          "perf-high": "Higher performance →",
          "pot-high": "↑ Higher potential",
          "pot-solid": "Solid potential",
          "pot-low": "↓ Limited potential"
        },
        "cell": {
          "empty": "— empty —",
          "1A": "Diamond in the Rough",
          "2A": "Future Star",
          "3A": "Star",
          "1B": "Inconsistent Player",
          "2B": "Core Player",
          "3B": "Key Contributor",
          "1C": "Concern",
          "2C": "Solid Performer",
          "3C": "Specialist",
          "1A-desc": "Strong potential but performance not yet there. Coach hard.",
          "2A-desc": "Solid performance with high potential. One step from Star.",
          "3A-desc": "High performance and high potential. Top talent.",
          "1B-desc": "Solid potential, low performance. Investigate.",
          "2B-desc": "Reliable solid contributor. The backbone.",
          "3B-desc": "High performer in current role. Solid potential.",
          "1C-desc": "Low performance and limited potential. Difficult.",
          "2C-desc": "Meets bar reliably. Limited room to grow.",
          "3C-desc": "High performance, niche expert. Limited mobility."
        },
        "legend": {
          "variance": "Self ≠ Manager rating (variance)",
          "promo": "Promotion recommended",
          "menu": "Click for move menu"
        },
        "card-menu": {
          "title": "Move \"{name}\" to",
          "current": "(current)",
          "detail": "Calibration detail (notes · history)",
          "open-workspace": "Open review workspace"
        },
        "side": {
          "session": {
            "title": "Session overview",
            "in-matrix": "In matrix",
            "pending": "Pending sign-off",
            "locked": "Already locked",
            "variance": "Variance flags"
          },
          "dist": {
            "title": "Distribution health",
            "sub": "Target vs Actual",
            "lede": "Black tick marks the target. Wide variance = forced distribution drift.",
            "foot": "Target = recommended forced distribution. ±8% is within healthy range; beyond that, calibration drift is likely."
          },
          "variance": {
            "title": "Variance resolution",
            "flagged": "{count} flagged",
            "empty": "No managers exceed the ±0.50 variance threshold. Distribution is healthy.",
            "over": "Over-rates",
            "under": "Under-rates",
            "row": "{dir} by {amount} (avg {avg} vs org 3.55) · {n} reviews submitted"
          },
          "lock": {
            "title": "Sign-off lock",
            "body": "When you sign off, the rating_manager becomes the final rating for all pending reviews, the template version used is frozen, and employees are notified to acknowledge. Future template edits will not retroactively change these reviews."
          }
        },
        "footer": {
          "summary": "{reviews-bold} ready for sign-off · {flags-bold} to resolve · once locked, ratings are final",
          "reviews-one": "1 review",
          "reviews-other": "{count} reviews",
          "flags-one": "1 variance flag",
          "flags-other": "{count} variance flags"
        }
      },
      "devplans": {
        "title": "Development Plans",
        "subtitle": "{total} active plans · {pending} pending approval · {approved} approved",
        "push": "Push approved to L&D",
        "push-toast": "L&D module integration coming · push to L&D will activate when L&D is built",
        "bulk": "Bulk approve",
        "bulk-toast": "Bulk approve workflow (demo)",
        "approve-toast": "Plan {id} approved (demo)",
        "lnd-toast": "Sent to L&D module (demo · L&D not yet built)",
        "col": {
          "id": "Plan ID",
          "employee": "Employee",
          "dept": "Dept",
          "area": "Growth area",
          "action": "Recommended action",
          "status": "Status",
          "owner": "Owner",
          "actions": "Actions"
        },
        "action": {
          "view": "View",
          "approve": "Approve",
          "lnd": "L&D"
        },
        "status": {
          "Active": "Active",
          "In review": "In review",
          "Approved": "Approved",
          "Pending": "Pending"
        },
        "drawer": {
          "title": "{id} — {emp}",
          "sub": "{dept} · plan owner: {owner} · status: {status}",
          "close-label": "Close drawer",
          "employee": "Employee",
          "department": "Department",
          "area": "Growth area",
          "action": "Recommended action",
          "owner": "Owner (LM)",
          "status": "Status",
          "milestones": "Milestones (demo)",
          "milestone-1": "Q2 2026 · Complete foundational training course (4 weeks)",
          "milestone-2": "Q3 2026 · First check-in with HR Director · review measurable signs of improvement",
          "milestone-3": "Q4 2026 · Mid-year evaluation reassessment · adjust plan if needed",
          "lnd-linkage": "L&D linkage",
          "lnd-body": "When this plan is approved and pushed to L&D, the recommended courses become enrolment items for the employee in the L&D module. Completion data flows back into the Performance evidence base for next cycle.",
          "close-cta": "Close",
          "send-cta": "Send to L&D",
          "send-toast": "Sent to L&D (demo)",
          "approve-cta": "Approve plan",
          "approve-toast": "Plan approved (demo)"
        }
      },
      "reports": {
        "title": "Reports & Analytics",
        "subtitle": "{count} standard reports · click any card for a preview",
        "custom": "Custom report",
        "custom-toast": "Custom report builder — enterprise capabilities",
        "export": "Export all",
        "export-toast": "Export all to Excel (demo)",
        "preview": "Preview →",
        "preview-toast": "Report drawer — coming in a follow-up slice",
        "items": {
          "R1": {
            "title": "Performance Summary Report",
            "desc": "Org-wide rating distribution, cycle progress, completion rate, average scores by template.",
            "period": "Auto-refresh from current cycle"
          },
          "R2": {
            "title": "Rating Distribution Report",
            "desc": "Bell-curve by department · manager · grade. Year-over-year shift. Detect grading drift.",
            "period": "Latest closed cycle"
          },
          "R3": {
            "title": "Department Performance Report",
            "desc": "Rank departments by average rating, KPI achievement, goal completion, attendance score.",
            "period": "Current cycle"
          },
          "R4": {
            "title": "Calibration Summary",
            "desc": "Pre vs post calibration shifts, adjustments by HR, departments with most variance.",
            "period": "After calibration closes"
          },
          "R5": {
            "title": "Top Talent Report",
            "desc": "Employees rated Outstanding for 2+ consecutive cycles. Promotion candidates with succession data.",
            "period": "Rolling 3 cycles"
          },
          "R6": {
            "title": "Low Performer Tracking",
            "desc": "Below-expectation employees, root cause, development plan status, time-to-improve, exit risk score.",
            "period": "Rolling 2 cycles"
          },
          "R7": {
            "title": "Development Plan Tracking",
            "desc": "All active plans, completion %, training assigned, follow-up date, manager comments.",
            "period": "Cycle to date"
          }
        }
      },
      "settings": {
        "title": "Performance module settings",
        "subtitle": "Configure rating scale · workflow · reminders · approval · integration toggles",
        "edit": "Edit",
        "restore": "Restore defaults",
        "save": "Save all",
        "restore-toast": "Restore defaults (demo)",
        "save-toast": "Settings saved (demo)",
        "edit-toast": "Editor drawer — coming in a follow-up slice",
        "toggle-toast": "Toggled (demo) — persists in a follow-up slice",
        "groups": {
          "workflow": "Rating & Workflow",
          "calibration": "Calibration",
          "reminders": "Reminders & Notifications",
          "integrations": "Integrations"
        },
        "items": {
          "rating-scale": {
            "title": "Rating scale",
            "desc": "Levels used across all evaluation forms",
            "value": "5-level (Outstanding → Unsatisfactory)"
          },
          "cycle-cadence": {
            "title": "Default cycle cadence",
            "desc": "How often new performance cycles open",
            "value": "Half-yearly (H1 / H2)"
          },
          "self-review": {
            "title": "Require self-review",
            "desc": "Employees must submit before manager opens",
            "value": "On"
          },
          "peer-360": {
            "title": "Enable 360 feedback",
            "desc": "Optional peer/subordinate feedback",
            "value": "Off"
          },
          "calib-required": {
            "title": "Calibration required",
            "desc": "HR calibration before final rating is locked",
            "value": "On"
          },
          "forced-dist": {
            "title": "Forced distribution",
            "desc": "Cap % of Outstanding/Exceeds per department",
            "value": "Off (recommended)"
          },
          "calib-quorum": {
            "title": "Calibration quorum",
            "desc": "Min participants for a department to calibrate",
            "value": "5 employees"
          },
          "reminder-self": {
            "title": "Self-review reminders",
            "desc": "Email/in-app reminders before deadline",
            "value": "7 days · 2 days · same day"
          },
          "reminder-mgr": {
            "title": "Manager review reminders",
            "desc": "Sent to LMs with pending reviews",
            "value": "5 days · 1 day · daily after due"
          },
          "escalate-overdue": {
            "title": "Escalate overdue reviews",
            "desc": "Notify next manager up after deadline",
            "value": "+3 days"
          },
          "pull-wm": {
            "title": "Pull from Work Mgmt",
            "desc": "Auto-attach operational evidence to forms",
            "value": "On"
          },
          "pull-hrops": {
            "title": "Pull from HR Ops",
            "desc": "Attendance, leave, OT context in forms",
            "value": "On"
          },
          "push-payroll": {
            "title": "Push reward to Payroll",
            "desc": "Send approved bonus/increment to Payroll",
            "value": "On (advisory; Payroll Admin confirms)"
          },
          "push-lnd": {
            "title": "Push to L&D",
            "desc": "Send approved dev plans/training to L&D",
            "value": "Off (L&D module not yet active)"
          }
        }
      },
      "subtitle-suffix": "performance"
    },
    "billing": {
      "title": "Billing",
      "subtitle": "Optimal P · provider recharge",
      "period-label": "Billing period",
      "no-access": "You do not have access to Billing.",
      "not-recharged": "not recharged",
      "reconciled": "Reconciled",
      "direct-notice": "Direct workforce is internal company cost and is {strong}. Switch to a Client or Project scope to view recharge.",
      "dashboard-empty": "No recharge runs for this scope + period yet.",
      "runs-direct-notice": "Direct workforce is internal company cost and is {strong}.",
      "runs-empty": "No recharge runs for this scope + period.",
      "recon-direct-notice": "Direct workforce is not recharged — nothing to reconcile.",
      "tabs": {
        "dashboard": "Dashboard",
        "runs": "Recharge Runs",
        "recon": "Reconciliation"
      },
      "kpi": {
        "total-recharge": "Total Recharge",
        "cost-base": "Cost Base",
        "margin-fee": "Margin / Fee",
        "runs": "Recharge Runs",
        "employees-billed": "Employees Billed",
        "reconciled": "Reconciled",
        "with-variance": "With Variance",
        "period": "Period"
      },
      "runs": {
        "col-run-id": "Run ID",
        "col-client-project": "Client › Project",
        "col-method": "Method",
        "col-emp": "Emp",
        "col-cost-base": "Cost Base",
        "col-margin": "Margin",
        "col-total": "Total Recharge",
        "col-recon": "Reconciliation"
      },
      "recon": {
        "runs-reconciled": "Runs Reconciled",
        "total-variance": "Total Variance",
        "col-run": "Run",
        "col-project": "Project",
        "col-payroll-cost": "PayrollRun Cost",
        "col-billed-base": "Billed Base",
        "col-variance": "Variance",
        "col-status": "Status"
      },
      "detail": {
        "back": "Back",
        "back-to-runs": "Back to Runs",
        "not-found": "Run not found.",
        "service-fee": "Service Fee",
        "pass-through": "Pass-Through",
        "margin": "Margin",
        "lines-heading": "Recharge lines",
        "no-lines": "No recharge lines.",
        "col-employee": "Employee",
        "col-cost": "Cost",
        "col-fee": "Fee",
        "col-pass-through": "Pass-Through",
        "col-line-total": "Line Total",
        "recon-heading": "Reconciliation",
        "payroll-employer-cost": "PayrollRun employerCost",
        "billed-cost-base": "Billed cost base",
        "variance": "Variance",
        "sources-heading": "Source PayrollRuns",
        "sources-note": "RechargeRun originates from PayrollRun · ADV excluded from cost · FIN = full-month cost.",
        "advance-excluded": "advance (excluded from cost)",
        "cost-amount": "{amount} cost"
      }
    },
    "insights": {
      "title": "Insights",
      "subtitle": "Reports & Analytics · across all modules",
      "toast-open": "Open {name}",
      "tiles": {
        "headcount": {
          "title": "Headcount",
          "desc": "Direct · Outsourced · External"
        },
        "turnover": {
          "title": "Turnover",
          "desc": "Voluntary, involuntary, per project"
        },
        "attendance": {
          "title": "Attendance",
          "desc": "Present, late, absent, OT"
        },
        "payroll-cost": {
          "title": "Payroll cost",
          "desc": "Gross, net, taxes, allowances"
        },
        "project-profitability": {
          "title": "Project profitability",
          "desc": "Bill rate vs cost, margin"
        },
        "compliance": {
          "title": "Compliance",
          "desc": "Contracts expiring, NSSF, TOS filings"
        }
      }
    },
    "moreapps": {
      "title": "More Apps",
      "subtitle": "Ecosystem launcher · workforce platform expansion",
      "section-live": "Available now",
      "section-future": "Coming to the platform",
      "tag-live": "Live",
      "tag-soon": "Soon",
      "title-open": "Open {name}",
      "toasts": {
        "coming-soon": "{name} — coming soon"
      },
      "live": {
        "stock": {
          "label": "Stock Mgmt",
          "desc": "FMCG inventory · multi-warehouse · batch/expiry · replenishment"
        },
        "lnd": {
          "label": "L&D",
          "desc": "Learning & Development · courses · capability matrix · certifications"
        },
        "admin": {
          "label": "Admin",
          "desc": "Tenant configuration · users · roles · master data · policies · platform"
        }
      },
      "future": {
        "recruitment": "Recruitment",
        "benefits": "Benefits",
        "ai-assistant": "AI Assistant",
        "survey": "Survey",
        "asset-mgmt": "Asset Mgmt",
        "compliance-center": "Compliance Center"
      }
    },
    "fieldops": {
      "title": "Field Ops",
      "subtitle": "FMCG · Retail · Distribution — visible only when tenant has FMCG clients",
      "tabs": {
        "stock": "Stock Management",
        "fieldforce": "Field Force"
      },
      "stub": {
        "title": "Field Ops — proposed module",
        "lede": "Vertical-specific tools for tenants with consumer-facing brand clients (Unilever, Heineken, BAT, Samsung, AIA): Stock Management (SKU catalog, multi-warehouse, batch+expiry, replenishment), Field Force Management (route planning, GPS check-in, order capture, strike rate analytics — React Native extension to existing ESS app)."
      }
    },
    "admin-settings": {
      "title": "Admin",
      "subtitle": "Tenant configuration · master data · policies · platform",
      "toast-open": "Open {name}",
      "title-open": "Open {name}",
      "groups": {
        "company": {
          "label": "Company",
          "tiles": {
            "profile": {
              "title": "Company Profile",
              "desc": "Tenant overview · Locations · Policies"
            },
            "users-roles": {
              "title": "Users & Roles",
              "desc": "Permissions matrix"
            },
            "modules": {
              "title": "Modules",
              "desc": "Enable/disable per tenant"
            }
          }
        },
        "setup": {
          "label": "Setup · master data",
          "tiles": {
            "employment-types": {
              "title": "Employment Types",
              "desc": "Full-time, Part-time, Intern, Casual"
            },
            "contract-types": {
              "title": "Contract Types",
              "desc": "UDC, FDC, Consultant, Probation"
            },
            "cost-centers": {
              "title": "Cost Centers",
              "desc": "Financial allocation across modules"
            },
            "approval-workflows": {
              "title": "Approval Workflows",
              "desc": "Routing rules cross-module"
            }
          }
        },
        "policies": {
          "label": "Policies"
        },
        "platform": {
          "label": "Platform",
          "tiles": {
            "localization": {
              "title": "Localization",
              "desc": "English + Khmer · date format · time zones"
            },
            "audit-log": {
              "title": "Audit Log",
              "desc": "Every change tracked"
            },
            "data-privacy": {
              "title": "Data & Privacy",
              "desc": "Retention, PDPA, export, deletion"
            }
          }
        }
      },
      "workspace": {
        "title": "Workspace & Tenant Settings",
        "desc": "Business type · billing · address · subscription · contacts"
      }
    },
    "admin-policies": {
      "title": "Policies",
      "subtitle": "Review and tailor this company's HR module policies and settings. Changes take effect across the relevant workflows.",
      "back": "Back to Admin",
      "back-to-cards": "Back to Policies",
      "areas": {
        "attendance": {
          "title": "Attendance",
          "desc": "Clock rules, grace periods, breaks and location enforcement"
        },
        "employment": {
          "title": "Employment",
          "desc": "FDC and UDC notice periods and contract reminders"
        },
        "leave": {
          "title": "Leave",
          "desc": "Leave accrual, entitlements and request rules"
        },
        "schedule": {
          "title": "Schedule",
          "desc": "Working-hours, shift and labour-law settings"
        },
        "localization": {
          "title": "Localization",
          "desc": "Locale, currency and regional formatting"
        }
      },
      "groups": {
        "attendance": {
          "clock-settings": "Clock Settings",
          "overtime-grace": "Overtime & Grace Periods",
          "breaks-reminders": "Breaks & Reminders",
          "location-enforcement": "Location Enforcement"
        },
        "employment": {
          "fdc": "Fixed-Duration Contract (FDC)",
          "udc": "Undetermined-Duration Contract (UDC)"
        },
        "other": "Other"
      },
      "row": {
        "value": "Value:",
        "edit-value": "Edit {name}",
        "errors": {
          "min": "Value must be at least {min}.",
          "max": "Value must be at most {max}.",
          "required": "A value is required."
        }
      },
      "error": {
        "title": "Couldn't load policies",
        "desc": "Something went wrong loading this company's policies. Try again."
      },
      "no-company": {
        "title": "No active company",
        "desc": "Select a company from the switcher to manage its policies."
      },
      "empty": {
        "title": "No configurable settings",
        "desc": "This area has no configurable policies or settings yet."
      },
      "unknown": {
        "title": "Unknown policy area",
        "desc": "That policy area doesn't exist. Pick one of the available areas."
      }
    },
    "pay": {
      "configurations": {
        "title": "Configurations",
        "subtitle": "Tenant-level payroll catalog · calc rules · statutory rates",
        "banner-lead": "Backend integration in progress.",
        "banner-body": "Each tile below opens a placeholder until its corresponding configuration endpoint ships. Existing payroll runs continue to use the values currently configured server-side.",
        "toast-coming-soon": "{name} — backend integration coming in a subsequent slice",
        "groups": {
          "catalog": {
            "label": "Catalog"
          },
          "rules": {
            "label": "Rules & rates"
          }
        },
        "tiles": {
          "pay-components": {
            "title": "Pay Components",
            "desc": "Allowance / deduction definitions · earning vs deduction · tax + NSSF flags"
          },
          "pay-groups": {
            "title": "Pay Groups",
            "desc": "Bundled component sets that apply to a population (HQ Staff, Site Crew, Outsourced)"
          },
          "pay-cycles": {
            "title": "Pay Cycles",
            "desc": "Monthly · bi-monthly · weekly · custom · per-cycle cut-off + pay-date offsets"
          },
          "calc-rules": {
            "title": "Calculation Rules",
            "desc": "OT multipliers, daily-rate formula, rounding, workweek, default currency, First-Payroll offset"
          },
          "nssf-rates": {
            "title": "NSSF Rates",
            "desc": "4 schemes (Pension · Occupational · Health · Voluntary) with effective-dated rate bands"
          },
          "tax-brackets": {
            "title": "Tax Brackets",
            "desc": "TOS (Tax on Salary) progressive brackets + resident / non-resident exemptions"
          }
        }
      },
      "center": {
        "title": "Payroll Center",
        "subtitle-upcoming": "Prepare upcoming payroll runs before cut-off and pay date",
        "subtitle-in-progress": "Continue processing an active payroll run (work-in-progress)",
        "subtitle-completed": "Review approved and locked payroll results",
        "subtitle-error": "Couldn't load payroll schedule",
        "error": "Couldn't load payroll schedule — {message}",
        "untitled": "Untitled payroll",
        "selected-placeholder": "Detail view for the selected payroll lands in a follow-up phase.",
        "off-cycle": {
          "button": "Off-Cycle Payroll",
          "toast": "Off-cycle launch coming in Wave 2.9 — selected: {type}",
          "types": {
            "bonus": "Bonus",
            "incentive": "Incentive",
            "adjustment": "Adjustment",
            "final-pay": "Final Pay",
            "special": "Special Payroll"
          }
        },
        "filters": {
          "all": "All",
          "upcoming": "Upcoming",
          "in-progress": "In progress",
          "off-cycle": "Off-cycle",
          "completed": "Completed"
        },
        "schedule": {
          "title": "Schedule",
          "subtitle": "Browse payroll runs across statuses",
          "scroll-left": "Scroll schedule left",
          "scroll-right": "Scroll schedule right"
        },
        "status": {
          "upcoming": "Upcoming",
          "in-progress": "In progress",
          "off-cycle": "Off-cycle",
          "completed": "Completed"
        },
        "card": {
          "period": "Period: {start} – {end}"
        },
        "empty": {
          "title": "No payroll runs match this filter",
          "description": "Adjust the filter chips above or generate a new payroll schedule."
        }
      },
      "detail": {
        "back": "Back to Payroll Center",
        "meta": "Pay period {start} – {end} · {cycle} cycle · Run ID {runId} · Generated {generatedAt}",
        "badges": {
          "locked": "Approved & Locked",
          "approved": "Approved {date} by {actor}",
          "paid": "Paid {date}",
          "employees": "{count} employees",
          "off-cycle": "Off-Cycle: {type}"
        },
        "totals": {
          "title": "Run Totals",
          "headcount-paid": {
            "label": "Total HC Paid",
            "help": "Headcount that received payment"
          },
          "gross": {
            "label": "Total Gross Pay",
            "help": "Basic + OT + bonuses + incentives + paid leave"
          },
          "deductions": {
            "label": "Total Deductions",
            "help": "Tax (TOS) + NSSF + unpaid leave + advance offset + others"
          },
          "net": {
            "label": "Total Net Pay",
            "help": "Final settlement paid to {count} employees"
          }
        },
        "earnings": {
          "title": "Earnings",
          "total": "Total Gross"
        },
        "deductions": {
          "title": "Deductions",
          "total": "Total Deductions"
        },
        "employees": {
          "title": "Employee Detail ({count} employees)",
          "columns": {
            "employee": "Employee",
            "dept": "Dept",
            "pay-method": "Pay Method",
            "bank": "Bank",
            "gross": "Gross",
            "tax": "Tax",
            "nssf": "NSSF",
            "other": "Other",
            "net": "Net"
          }
        },
        "compliance": {
          "title": "Compliance"
        },
        "audit": {
          "title": "Audit Trail"
        }
      },
      "run": {
        "untitled": "Payroll run",
        "save-exit": "Save & Exit",
        "save-exit-hint": "Run stays In-Progress · resume any time",
        "identity": {
          "run-id": "Run",
          "pay-date": "Pay Date:",
          "pay-period": "Pay Period:",
          "period": "{start} – {end}"
        },
        "step-title": "Step {n} — {label}",
        "steps": {
          "eligibility": "Employee Eligibility",
          "pay-inputs": "Pay Inputs Review",
          "calculation": "Calculation & Review",
          "approval": "Review & Approval",
          "payment-distribution": "Payment & Distribution"
        },
        "summary-strip": {
          "in-this-run": "In this run",
          "eligible": "eligible",
          "excluded": "excluded",
          "warnings": "warning(s)"
        },
        "stepper": {
          "locked-tooltip": "Complete the previous step first"
        },
        "warning-banner": {
          "title": "{count} employee profile warning(s) — non-blocking",
          "subtitle": "Resolve before Step 5 (Payment) so bank export and NSSF report come out clean.",
          "show": "Show details",
          "hide": "Hide details"
        },
        "placeholder": {
          "loading": "Loading run summary…",
          "error": "Couldn't load run summary — {message}",
          "step-coming": "Step content lands in Wave 2.3+ (per-step views)."
        },
        "step1": {
          "loading": "Loading eligibility summary…",
          "error": "Couldn't load eligibility summary — {message}",
          "kpi": {
            "total": {
              "label": "Total Employees",
              "help": "Reviewed in this run"
            },
            "ready": {
              "label": "Eligible & Ready",
              "help": "Will be paid in this run"
            },
            "action": {
              "label": "Action Required",
              "help": "Blocker(s) to resolve before Step 2"
            },
            "excluded": {
              "label": "Ineligible / Excluded",
              "help": "Held back from this run"
            }
          },
          "blockers": {
            "title": "Action items ({count})"
          },
          "list": {
            "title": {
              "total": "All employees in this run",
              "ready": "Eligible employees",
              "action": "Employees requiring action",
              "excluded": "Excluded employees"
            },
            "count": "{count} in list",
            "loading": "Loading employees…",
            "error": "Couldn't load employees — try refreshing",
            "empty": "No employees match this filter",
            "columns": {
              "code": "Code",
              "name": "Name",
              "dept": "Department",
              "reason": "Reason / Blocker",
              "actions": "Actions"
            },
            "actions": {
              "move": "Move"
            }
          },
          "gate-banner": {
            "text": "action-required item(s) must be resolved before Step 2 unlocks."
          },
          "confirm": {
            "error": "Confirm failed — {message}"
          },
          "actions": {
            "back": "Back to Payroll Center",
            "confirm": "Confirm & Continue"
          },
          "move-modal": {
            "title": "Move Employee",
            "employee": "Employee",
            "from": "Current Bucket",
            "to": "Move To",
            "select-bucket": "Select a bucket…",
            "reason": "Reason",
            "reason-placeholder": "Required when moving to/from Excluded",
            "submit": "Move Employee"
          }
        },
        "step2": {
          "loading": "Loading pay-input dashboard…",
          "error": "Couldn't load pay-input dashboard — {message}",
          "kpi": {
            "records": {
              "label": "Validated Records",
              "help": "Pay-input rows in this run"
            },
            "employees": {
              "label": "Employees Affected",
              "help": "Eligible employees in this run"
            },
            "issues": {
              "label": "Issues Found",
              "detail": "{blockers} blocker(s) · {warnings} warning(s)"
            },
            "components": {
              "label": "Pay Components",
              "help": "Active on this run"
            }
          },
          "components": {
            "title": "Pay Components",
            "empty": "No pay components are active on this run."
          },
          "component-card": {
            "records": "Records",
            "blockers": "Blockers",
            "warnings": "Warnings",
            "open": "Open in Pay Input"
          },
          "component-status": {
            "not-started": "Not started",
            "partial": "Partial",
            "complete": "Complete",
            "blocked": "Blocked"
          },
          "issues": {
            "title": "Issues to resolve ({blockers} blocker(s) · {warnings} warning(s))"
          },
          "passthrough": {
            "title": "No pay input applies to this run",
            "body": "First Payroll runs as a fixed 50% basic salary advance. Pay-input components (OT, Allowance, Bonus, Incentive, Seniority, Back Pay, Leave, Adjustments) are scheduled for the Second Payroll at the end of the month, when full earnings are known. Nothing to validate here — review the message and confirm to continue.",
            "hint": "If a particular component must be included on this run (rare), push it explicitly from Pay Input Center before confirming.",
            "open-pic": "Open Pay Input",
            "kpi": {
              "components": "Components Pushed",
              "components-sub": "none on this run",
              "records": "Validated Records",
              "records-sub": "no input components",
              "issues": "Issues Found",
              "issues-sub": "nothing to validate"
            },
            "ack": "Step 2 is a <strong>pass-through</strong> for this run — no pay-input review is required. Click <strong>Confirm & Continue</strong> below to advance to Step 3 (Calculation)."
          },
          "gate-banner": {
            "title": "{count} blocker(s) prevent Step 3 unlock"
          },
          "confirm": {
            "error": "Confirm failed — {message}"
          },
          "actions": {
            "back": "Back",
            "issues-center": "Cross-component view",
            "confirm": "Confirm & Continue"
          },
          "issues-center": {
            "supra": "Pay Input",
            "title": "Issues Center",
            "subtitle": "All warnings and blockers across components. Blockers must be resolved before validation.",
            "kpi": {
              "total": "Total Issues",
              "blockers": "Blockers",
              "warnings": "Warnings"
            },
            "cols": {
              "severity": "Severity",
              "component": "Component",
              "code": "Code",
              "message": "Message",
              "employees": "Employees"
            },
            "blocker": "Blocker",
            "warning": "Warning",
            "empty": "No issues found."
          }
        },
        "step3": {
          "loading": "Loading calculation comparison…",
          "error": "Couldn't load calculation comparison — {message}",
          "empty": {
            "title": "Calculation pending",
            "body": "No payroll calculation has been run yet for this period. Click Calculate to compute the snapshot and unlock review."
          },
          "no-prior": {
            "title": "First payroll for this cycle",
            "body": "No prior period to compare against — variance totals are blank. Run the calculation, then move on to review."
          },
          "compare": {
            "title": "Comparison Gate",
            "subtitle": "Variance against the prior period (threshold ±{threshold}% on gross). Rows exceeding the threshold are flagged for review.",
            "gross": "Gross Δ",
            "net": "Net Δ",
            "tos": "TOS Δ",
            "nssf": "NSSF Δ"
          },
          "variance": {
            "title": "{count} employee(s) exceed the ±{threshold}% gross threshold",
            "body": "Variance flags are warnings — review them before submitting for approval. Re-calculate to refresh the comparison after correcting inputs."
          },
          "rows": {
            "title": "Per-employee comparison",
            "count": "{count} employee(s)",
            "columns": {
              "employee": "Employee",
              "gross": "Gross Δ",
              "net": "Net Δ",
              "tos": "TOS Δ",
              "nssf": "NSSF Δ",
              "flag": "Flag"
            },
            "flag": {
              "exceeds": "Exceeds threshold"
            }
          },
          "actions": {
            "back": "Back",
            "calculate": "Calculate",
            "recalculate": "Re-calculate",
            "calculating": "Calculating…",
            "confirm": "Confirm & Continue",
            "confirming": "Submitting…"
          },
          "calc": {
            "error": "Calculation failed — {message}"
          },
          "submit": {
            "error": "Couldn't submit for approval — {message}"
          },
          "breakdown": {
            "empty": {
              "body": "Select an employee row to see the breakdown."
            },
            "stale": {
              "title": "Breakdown not loaded",
              "body": "Per-employee breakdowns load from the most recent Calculate response — re-run Calculate to refresh them."
            },
            "totals": {
              "gross": "Gross",
              "net": "Net"
            },
            "section": {
              "components": "Earnings components",
              "deductions": "Deductions",
              "overtime": "Overtime",
              "seniority": "Seniority",
              "empty": "No lines."
            },
            "overtime": {
              "hourlyRate": "Hourly rate",
              "workingDays": "Working days",
              "hoursPerDay": "Hours per day"
            },
            "seniority": {
              "ineligible": "Not eligible",
              "daysAwarded": "Days awarded",
              "taxable": "Taxable",
              "nonTaxable": "Non-taxable"
            }
          }
        },
        "step4": {
          "loading": "Loading approval summary…",
          "error": "Couldn't load approval summary — {message}",
          "kpi": {
            "pending": {
              "label": "Pending Review",
              "help": "Awaiting an approval decision"
            },
            "approved": {
              "label": "Approved",
              "help": "Cleared to proceed to payment"
            },
            "needs-review": {
              "label": "Needs Review",
              "help": "Deferred decisions + flagged exceptions"
            },
            "returned": {
              "label": "Returned",
              "help": "Returned for correction — Step 2 reopened"
            }
          },
          "run-strip": {
            "total": "{count} employee(s) in this run",
            "exceptions": "{count} flagged exception(s)",
            "template": "Template"
          },
          "list": {
            "title": {
              "pending": "Employees awaiting a decision",
              "approved": "Approved employees",
              "needsReview": "Deferred / flagged employees",
              "returned": "Returned for correction"
            },
            "count": "{count} in list",
            "empty": "No employees match this filter",
            "exception-badge": "Exception",
            "columns": {
              "employee": "Employee",
              "gross": "Gross",
              "tos": "TOS",
              "nssf": "NSSF",
              "net": "Net",
              "decision": "Decision",
              "reason": "Reason"
            }
          },
          "decision": {
            "pending": "Pending",
            "approved": "Approved",
            "deferred": "Deferred",
            "returned": "Returned"
          },
          "locked": {
            "title": "Step 4 is locked",
            "subtitle": "Every employee has been approved and the run snapshot is immutable. Step 5 (Payment) is now active."
          },
          "gate-banner": {
            "text": "{pending} pending · {deferred} deferred · {returned} returned. Every employee must be approved before Step 5 can unlock."
          },
          "actions": {
            "back": "Back",
            "decide-hint": "Approve & Continue unlocks once every employee has a decision recorded.",
            "confirm": "Approve & Continue",
            "confirming": "Confirming…"
          },
          "confirm": {
            "error": "Couldn't confirm approval — {message}"
          },
          "decide": {
            "empty": {
              "body": "Select an employee row to record a decision."
            },
            "current": "Current",
            "choose": "Choose a decision",
            "actions": {
              "approve": "Approve",
              "defer": "Defer",
              "return": "Return",
              "submit": "Save decision",
              "submitting": "Saving…",
              "cancel": "Cancel"
            },
            "reason": {
              "label": "Reason",
              "placeholder": "Add a short note for the audit trail…",
              "required-marker": "(required)",
              "optional-marker": "(optional)",
              "required-error": "A reason is required when returning for correction."
            },
            "error": "Couldn't save the decision — {message}",
            "rewound": {
              "title": "Run rewound to Step 2",
              "body": "The Maker can now correct the underlying input and re-submit. Step 4 will reopen once Step 2 is re-confirmed."
            }
          }
        },
        "step5": {
          "loading": "Loading Step 5 (payment, payslips, reports)…",
          "error": "Couldn't load Step 5 — {message}",
          "kpi": {
            "employees": "Employees to Pay",
            "total-net": "Total Net Pay",
            "pending": "Pending Settlement",
            "settled": "Settled",
            "distributed": "Payslips Distributed"
          },
          "held-banner": {
            "title": "{count} employee(s) on payment hold",
            "body": "Held payments are listed inside the Manual / Exception card. Resolve in Wave 2.8c — release, defer, or cancel & adjust."
          },
          "payment": {
            "title": "Payment Pipeline",
            "subtitle": "Per-bank batches advance independently. Click Generate to produce a bank file or Resolve below to clear an exception.",
            "loading": "Loading payment summary…",
            "error": "Couldn't load payment summary — {message}",
            "empty": "No payment data yet — Step 4 must approve the run first."
          },
          "bank-groups": {
            "aba": "ABA",
            "acleda": "ACLEDA",
            "wing": "Wing",
            "exception": "Manual / Exception"
          },
          "bank-card": {
            "employees": "Employees",
            "amount": "Total Amount",
            "generated": "File Generated",
            "manual": "Manual handling",
            "excel": "Excel template",
            "generate": "Generate File",
            "regenerate": "Re-generate",
            "generating": "Generating…",
            "error": "Couldn't generate the {bank} file — {message}",
            "placeholder-hint": "Manual / Exception resolves via the list below."
          },
          "exception-list": {
            "title": "{count} exception(s) need manual resolution",
            "hint": "Click Resolve to record an outcome (cash / cheque / transfer / update / hold / pending).",
            "resolve": "Resolve",
            "columns": {
              "employee": "Employee",
              "net": "Net",
              "reason": "Reason",
              "actions": "Actions"
            }
          },
          "manual": {
            "empty": {
              "body": "Select an exception row to record a manual outcome."
            },
            "headline": {
              "gross": "Gross",
              "net": "Net"
            },
            "reason-label": "Why this needs manual handling",
            "reasons": {
              "missing-template": "No bank template configured for this employee.",
              "missing-account": "No active account number on file.",
              "unsupported-bank": "Routed to a bank with no payroll integration."
            },
            "choose": "Choose an outcome",
            "outcomes": {
              "cash": "Cash",
              "cheque": "Cheque",
              "transfer": "Transfer",
              "update": "Update bank",
              "hold": "Hold",
              "pending": "Mark pending"
            },
            "reference": {
              "label": "Reference",
              "placeholder": "Receipt # / cheque # / transfer ID / new account #…",
              "required-marker": "(required)",
              "optional-marker": "(optional)",
              "required-error": "Reference is required for this outcome."
            },
            "newbank": {
              "label": "Route to",
              "placeholder": "Select a bank…",
              "required-marker": "(required)",
              "required-error": "Pick the new bank for this employee."
            },
            "note": {
              "label": "Note",
              "placeholder": "Audit-trail comment for this disposition…",
              "optional-marker": "(optional)"
            },
            "error": "Couldn't save the manual outcome — {message}",
            "actions": {
              "submit": "Save outcome",
              "submitting": "Saving…",
              "cancel": "Cancel"
            }
          },
          "payslips": {
            "title": "Payslips",
            "subtitle": "Generate and distribute the locked Step 3 snapshot.",
            "loading": "Loading payslip summary…",
            "error": "Couldn't load payslip summary — {message}",
            "empty": "No payslips yet — confirm payment to unlock payslip generation.",
            "manage": "Manage payslips",
            "kpi": {
              "total": "Total",
              "ready": "Ready to Generate",
              "generated": "Generated",
              "on-hold": "On Hold",
              "distributed": "Distributed"
            }
          },
          "reports": {
            "title": "Final Payroll Reports",
            "subtitle": "Locked snapshot — exportable for filing and archive.",
            "loading": "Loading…",
            "row-ready": "{rows} row(s) ready",
            "row-error": "Error — {message}",
            "row-empty": "Not generated yet",
            "generate": "Preview & Download",
            "placeholder-hint": "Generate / Download lands in Wave 2.8b.",
            "summary": {
              "label": "Summary Report",
              "help": "Aggregate totals by cost center"
            },
            "detail": {
              "label": "Detail Report",
              "help": "Per-employee register"
            },
            "tos": {
              "label": "Tax (TOS) Report",
              "help": "GDT-compliant filing"
            },
            "nssf": {
              "label": "NSSF Report",
              "help": "4-scheme contributions"
            }
          },
          "close": {
            "ready": {
              "title": "Run is ready to close",
              "hint": "Payment confirmed and every payslip distributed. Locking the run is the final step."
            },
            "blocked": {
              "title": "Run cannot be closed yet",
              "hint": "Payment: {payment} · Payslips: {payslips}"
            },
            "done": "ready",
            "pending": "in progress",
            "button": "Close Run",
            "closing": "Closing…",
            "closed": "Run closed",
            "success": "Run closed. Reports + payslips are locked.",
            "success-idempotent": "Run was already closed.",
            "error": "Couldn't close the run — {message}"
          },
          "page": {
            "title": "Step 5 (façade) — Payment, Payslips, Reports, Close",
            "heading": "Step 5 — Payment & Payslips",
            "back": "Back to Run"
          }
        }
      },
      "input-center": {
        "back": "Back to Payroll Center",
        "title": "Pay Input Center",
        "subtitle": "Review and edit pay-input rows across periods. Locked periods are read-only.",
        "period-label": "Pay Period",
        "component-label": "Component",
        "no-periods": "No periods available",
        "no-components": "No components available",
        "pick-prompt": "Pick a Pay Period and a Component to view entries.",
        "loading": "Loading entries…",
        "error": "Couldn't load entries — {message}",
        "empty": "No pay-input rows for this period × component yet.",
        "lock": {
          "unlocked": "Editable",
          "locked-by-run": "Locked by run",
          "past-period": "Past period · read-only"
        },
        "columns": {
          "employee": "Employee",
          "period": "Period",
          "amount": "Amount",
          "status": "Status",
          "reason": "Reason",
          "actions": "Actions"
        },
        "actions": {
          "edit": "Edit"
        },
        "drawer": {
          "title": "Edit pay-input row",
          "employee": "Employee",
          "component": "Component",
          "period": "Period",
          "amount": "Amount",
          "reason": "Reason",
          "save": "Save changes",
          "saving": "Saving…",
          "delete": "Delete row",
          "save-success": "Pay-input row saved",
          "delete-success": "Pay-input row deleted"
        },
        "run-context": {
          "heading": "Correcting for {id}",
          "subtitle": "Period locked to this run. Make corrections, then return to the run.",
          "return": "Return to Run"
        },
        "subtypes": {
          "all": "All"
        },
        "issues-center": {
          "btn": "Issues Center"
        },
        "header-actions": {
          "settings": "Settings",
          "add-entry": "Add Entry",
          "verify": "Verify"
        },
        "workspace": {
          "group-label": "System Job · Fed from attendance",
          "title": "Overtime (OT)",
          "period-badge": "Period: 26 Jan – 25 Feb 2026",
          "cutoff-badge": "Cut-off: 11 Feb 2026"
        },
        "health": {
          "total-records": "Total Records",
          "validated-suffix": "validated",
          "validated-amount": "Validated Amount",
          "employees-suffix": "employees",
          "warnings": "Warnings",
          "warnings-sub": "non-blocking",
          "blockers": "Blockers",
          "blockers-sub": "resolve before calc",
          "progress": "Validation progress",
          "resolve-banner": "Resolve {count} blockers in Overtime (OT) before calculation can run.",
          "resolve-cta": "Open Overtime (OT) →"
        },
        "kpis": {
          "records": "Records",
          "total-amount": "Total Amount",
          "employees": "Employees",
          "warnings": "Warnings",
          "blockers": "Blockers"
        },
        "sidebar": {
          "title": "Components",
          "count-suffix": "total",
          "sort-urgency": "Sort: Urgency",
          "sort-group": "Sort: Group",
          "sort-name": "Sort: Name",
          "add-component": "Add component"
        },
        "filters": {
          "search-placeholder": "Search employee, memo, reference…",
          "all": "All",
          "valid": "Valid",
          "warning": "Warning",
          "blocker": "Blocker",
          "paid": "Paid",
          "source-all": "All Sources",
          "source-attendance": "Attendance",
          "source-import": "Import",
          "source-manual": "Manual",
          "source-system": "System / API"
        },
        "ot-columns": {
          "employee": "Employee",
          "ot-date": "OT Date",
          "time": "Time",
          "claimed": "Claimed (h)",
          "computed": "Computed (h)",
          "amount": "Amount",
          "ot-type": "OT Type",
          "source": "Source",
          "status": "Status"
        },
        "ot-status": {
          "valid": "Valid",
          "warning": "Warning",
          "blocker": "Blocker"
        },
        "toast": {
          "preview-only": "Coming in follow-up release"
        },
        "bulk-import": {
          "btn": "Batch Import",
          "title": "Batch Import — {component}",
          "description": "Upload a CSV file with pay-input rows for this component.",
          "file-label": "Upload File",
          "click-upload": "Click to upload",
          "file-hint": "CSV up to 10 MB",
          "note-label": "Batch Note",
          "note-placeholder": "e.g., Q4 incentive batch — late approval",
          "no-rows": "No data rows found in the uploaded file.",
          "missing-columns": "CSV must contain at least Employee Code and Amount columns.",
          "rows": "rows",
          "cancel": "Cancel",
          "confirm": "Import",
          "importing": "Importing…",
          "success": "{count} rows imported successfully.",
          "partial-success": "{accepted} rows imported, {rejected} rejected."
        },
        "validate": {
          "btn": "Validate All",
          "validating": "Validating…",
          "success": "Validation completed.",
          "error": "Validation failed — {message}"
        }
      },
      "reportsCenter": {
        "back": "Back to Payroll Center",
        "title": "Reports",
        "subtitle": "Generated reports for completed payroll runs — preview, download PDF, or export Excel.",
        "empty": "No completed payrolls yet. Reports appear here once a run is closed.",
        "empty-filtered": "No reports match your filters. Try clearing the search or year filter.",
        "error": "Couldn't load the gallery — {message}",
        "cycle": "Cycle",
        "header": {
          "year-all": "All years",
          "export-all": "Export All (ZIP)",
          "export-all-toast": "Bundling reports — the ZIP archive will download once every report is ready.",
          "search-placeholder": "Search by run ID, period, or approver…"
        },
        "tabs": {
          "summary": "Payroll Summary",
          "detail": "Payroll Detail",
          "tos": "Tax (TOS) Report",
          "nssf": "NSSF Report"
        },
        "year-chips": {
          "all": "All"
        },
        "group": {
          "runs-one": "{count} run",
          "runs-other": "{count} runs",
          "totals": "Total: {net} across {hc} employee-records"
        },
        "columns": {
          "run": "Run",
          "type": "Type",
          "pay-period": "Pay Period",
          "pay-date": "Pay Date",
          "employees": "Employees",
          "net-pay": "Net Pay",
          "status": "Status",
          "approver": "Approver",
          "actions": "Actions"
        },
        "row": {
          "type-regular": "Regular",
          "type-off-cycle": "Off-cycle",
          "type-final-pay": "Final Pay",
          "type-bonus": "Bonus",
          "type-adjustment": "Adjustment",
          "view": "View {label}",
          "download-pdf": "Download PDF",
          "download-excel": "Download Excel",
          "completed": "Completed"
        },
        "kpis": {
          "total": "Total cells",
          "reports": "Reports",
          "reports-sub": "completed runs",
          "total-hc": "Total HC Paid",
          "total-hc-sub": "employee-records",
          "total-net": "Total Net Paid",
          "total-net-sub": "filtered period",
          "total-gross": "Total Gross Paid",
          "total-gross-sub": "before deductions",
          "total-tax": "Total Tax (TOS)",
          "total-tax-sub": "filed in period",
          "avg-tax": "Avg Tax / Run",
          "avg-tax-sub": "running average",
          "total-nssf": "Total NSSF (Employee)",
          "total-nssf-sub": "pension 2%",
          "avg-nssf": "Avg NSSF / Run",
          "avg-nssf-sub": "running average",
          "headcount-filed": "Headcount Filed",
          "headcount-filed-sub": "employee-records"
        },
        "filters": {
          "status": "Status",
          "type": "Report type",
          "cycle": "Cycle",
          "cyclePlaceholder": "e.g., Cycle:abc123",
          "payroll": "Payroll",
          "payrollPlaceholder": "e.g., Payroll:abc123",
          "all": "All",
          "clear": "Clear filters"
        },
        "statuses": {
          "idle": "Idle",
          "generating": "Generating…",
          "ready": "Ready",
          "failed": "Failed"
        },
        "types": {
          "summary": "Payroll Summary",
          "detail": "Payroll Detail",
          "tos": "Tax (TOS) Report",
          "nssf": "NSSF Report"
        },
        "cell": {
          "generatedAt": "Generated",
          "regeneratedAt": "Regenerated",
          "rowCount": "Rows",
          "notGenerated": "Not generated yet"
        },
        "actions": {
          "generate": "Generate",
          "generating": "Generating…",
          "regenerate": "Re-generate",
          "regenerating": "Re-generating…",
          "download": "Download",
          "downloading": "Opening…",
          "error": "Action failed — {message}"
        },
        "locked": {
          "badge": "Run closed"
        }
      },
      "offCycle": {
        "back": "Back to Payroll Center",
        "title": "Off-cycle Payroll",
        "subtitle": "Run a one-off payroll outside the regular cycle — final pay, bonus, back pay, incentive, or adjustment. Each off-cycle run is driven by a wizard draft.",
        "loading": "Loading off-cycle drafts…",
        "error": "Couldn't load off-cycle drafts — {message}",
        "empty": {
          "title": "No off-cycle drafts yet",
          "subtitle": "Start a new off-cycle run to create your first draft. Drafts persist for 7 days."
        },
        "start-new": {
          "btn": "Start new off-cycle run",
          "submitting": "Creating draft…",
          "error": "Couldn't create the draft — {message}"
        },
        "filter": {
          "label": "Status"
        },
        "status": {
          "all": "All",
          "DRAFT": "Draft",
          "COMMITTED": "Committed",
          "ABANDONED": "Abandoned"
        },
        "type": {
          "FINAL_PAY": "Final Pay",
          "BONUS": "Bonus",
          "BACK_PAY": "Back Pay",
          "ADVANCE": "Advance",
          "INCENTIVE": "Incentive",
          "ADJUSTMENT": "Adjustment",
          "SPECIAL": "Special Payroll",
          "unspecified": "Type not set"
        },
        "bucket": {
          "EXCLUDED": "Excluded employees",
          "LEAVER": "Leavers",
          "unspecified": "Default bucket"
        },
        "row": {
          "pay-date": "Pay date · {date}",
          "employee-count": "{count} employee(s)",
          "updated": "Updated {at}",
          "open": "Open"
        },
        "wizard": {
          "back": "Back to off-cycle list",
          "loading": "Loading draft…",
          "error": "Couldn't load the draft — {message}",
          "not-found": "Draft not found or expired. Off-cycle drafts persist for 7 days.",
          "area": {
            "type": {
              "title": "1. Type",
              "type-label": "Off-cycle type",
              "name-label": "Run name"
            },
            "employees": {
              "title": "2. Employees",
              "count-label": "Selected employees",
              "bucket-label": "Source bucket"
            },
            "amounts": {
              "title": "3. Amounts",
              "empty": "No pay components have been added yet.",
              "line-count": "{count} per-employee line(s)"
            },
            "dates": {
              "title": "4. Dates & rates",
              "cycle-label": "Parent cycle",
              "pay-date-label": "Pay date",
              "tos-rate-label": "Tax (TOS) exchange rate",
              "nssf-rate-label": "NSSF Pension exchange rate"
            },
            "review": {
              "title": "5. Review",
              "pending": "Review payload is not available yet.",
              "valid": "Validation passed",
              "invalid": "Validation issues found",
              "template": "Resolved template: {code}",
              "totals-title": "Totals by component",
              "grand-total": "Grand total"
            }
          },
          "edit": {
            "action": "Edit",
            "save": "Save changes",
            "saving": "Saving…",
            "cancel": "Cancel",
            "empty": "Pick an area to edit.",
            "error": "Couldn't save the area — {message}",
            "employees": {
              "placeholder": "Employee:e1\nEmployee:e2",
              "hint": "One employee ID per line (or comma-separated)."
            },
            "amounts": {
              "json-label": "Components (JSON)",
              "hint": "Array of components, each with ComponentCode + Items[{ EmployeeId, Amount, Reason? }]. A per-employee table editor lands in a later polish slice.",
              "json-error": "Invalid JSON — {message}"
            },
            "dates": {
              "cycle-placeholder": "Cycle:abc123"
            }
          },
          "commit": {
            "action": "Commit draft",
            "submitting": "Committing…",
            "error": "Couldn't commit the draft — {message}",
            "success": "Draft committed. Opening payroll {payrollId}…"
          },
          "abandon": {
            "action": "Discard draft"
          }
        }
      },
      "templates": {
        "back": "Back to Payroll Center",
        "title": "Templates",
        "subtitle": "Reusable payroll configurations for regular cycles, off-cycle runs, and special payrolls.",
        "loading": "Loading templates…",
        "error": "Couldn't load templates — {message}",
        "empty": "No templates have been created for this employer yet.",
        "untitled": "Untitled template",
        "default-badge": "Default",
        "code": {
          "1ST_PAY": "First Payroll",
          "2ND_PAY": "Second Payroll",
          "FINAL_PAY": "Final Payroll"
        },
        "versions": {
          "btn": "Version history",
          "heading": "Version History",
          "loading": "Loading versions…",
          "error": "Couldn't load versions — {message}",
          "empty": "No version history available.",
          "version-label": "Version {n}",
          "latest": "Latest",
          "attributes": "{n} attributes"
        },
        "clone": {
          "btn": "Clone",
          "title": "Clone Template",
          "description": "Create a new template based on an existing one.",
          "name-label": "New template name",
          "default-name": "{name} (Copy)",
          "name-required": "Template name is required.",
          "cancel": "Cancel",
          "confirm": "Clone",
          "cloning": "Cloning…",
          "success": "Template \"{name}\" created successfully."
        },
        "import": {
          "btn": "Import",
          "coming-soon": "Template import is on the roadmap — coming in a follow-up release."
        },
        "new": {
          "btn": "New Template",
          "coming-soon": "Template authoring is on the roadmap — coming in a follow-up release."
        },
        "use": {
          "btn": "Use",
          "coming-soon": "Start a run from a template via Payroll Center → Start Payroll. Direct launch from this card is on the roadmap."
        },
        "computation": {
          "title": "Computation Rules",
          "subtitle": "Global payroll calculation settings (applied across templates)",
          "edit": "Edit",
          "ot-weekday-label": "OT Multiplier (Weekday)",
          "ot-weekday-value": "1.5× basic hourly",
          "ot-weekend-label": "OT Multiplier (Weekend / Holiday)",
          "ot-weekend-value": "2.0× basic hourly",
          "daily-rate-label": "Daily Rate Formula",
          "daily-rate-value": "Basic ÷ 22 working days · Hourly: Basic ÷ 198 (22 d × 9 h)",
          "workweek-label": "Workweek",
          "workweek-value": "5 days × 9 hours = 45 hours / week",
          "rounding-label": "Rounding",
          "rounding-value": "2 decimals, half-up",
          "currency-label": "Default Currency",
          "currency-value": "USD (KHR for TOS filing)",
          "first-payroll-offset-label": "First Payroll Offset",
          "first-payroll-offset-value": "Tax & NSSF applied on 2nd payroll only"
        }
      },
      "payslip": {
        "unnamed": "Unnamed employee",
        "list": {
          "back": "Back to run",
          "title": "Payslips",
          "subtitle": "Per-employee payslips for this payroll run.",
          "loading": "Loading payslips…",
          "error": "Couldn't load payslips — {message}",
          "empty": "No payslips for this run yet.",
          "filtered-empty": "No payslips match the current filters."
        },
        "view": {
          "back": "Back to payslip list",
          "title": "Payslip",
          "subtitle": "Frozen snapshot of the locked Step 3 calculation.",
          "loading": "Loading payslip…",
          "error": "Couldn't load payslip — {message}",
          "empty": "Payslip not available for this employee."
        },
        "kpi": {
          "total": "Total",
          "ready": "Ready to Generate",
          "generated": "Generated",
          "on-hold": "On Hold",
          "distributed": "Distributed"
        },
        "lock": {
          "locked": "Run locked",
          "unlocked": "Run unlocked"
        },
        "filter": {
          "all": "All statuses",
          "search-label": "Search by name or code",
          "search-placeholder": "Search by employee name or code…"
        },
        "status": {
          "ready-to-generate": "Ready to generate",
          "generated": "Generated",
          "on-hold": "On hold",
          "distributed": "Distributed"
        },
        "hold-reason": {
          "MISSING_DELIVERY_METHOD": "Missing delivery method",
          "MISSING_EMAIL": "Missing email address",
          "PORTAL_NOT_ACTIVATED": "Employee portal not activated"
        },
        "delivery": {
          "MANUAL_DOWNLOAD": "Manual download",
          "EMAIL": "Email",
          "PORTAL": "Employee portal"
        },
        "cols": {
          "employee": "Employee",
          "status": "Status",
          "gross": "Gross",
          "net": "Net",
          "delivery": "Delivery",
          "actions": "Actions",
          "item": "Item",
          "amount": "Amount"
        },
        "actions": {
          "view": "View"
        },
        "doc": {
          "title": "Payslip",
          "tagline": "Official statement of monthly compensation",
          "run-id": "Run ID: {id}"
        },
        "meta": {
          "employee-name": "Employee Name",
          "employee-id": "Employee ID",
          "template": "Payroll Type",
          "pay-method": "Payment Method",
          "delivery-contact": "Delivery Contact"
        },
        "summary": {
          "gross": "Gross Pay",
          "deductions": "Total Deductions",
          "net": "Net Pay"
        },
        "section": {
          "earnings": "Earnings",
          "deductions": "Deductions",
          "empty-earnings": "No earnings recorded for this payslip.",
          "empty-deductions": "No deductions recorded for this payslip."
        },
        "totals": {
          "earnings": "Total Earnings",
          "deductions": "Total Deductions"
        },
        "hold-banner": {
          "title": "Payslip on hold",
          "hint": "Resolve the hold before generating or distributing this payslip."
        },
        "note": {
          "label": "Important Note",
          "body": "This is a system-generated payslip. No signature is required. The figures shown are a frozen snapshot of the locked Step 3 calculation.",
          "generated-at": "Generated: {date}",
          "file": "File: {name}"
        },
        "distribute": {
          "action": "Distribute",
          "title": "Distribute payslips",
          "body": "Send the generated payslips through one delivery channel. Rows on hold or not yet generated are skipped automatically.",
          "method-label": "Delivery channel",
          "methods": {
            "manual": "Manual download",
            "manual-hint": "Mark all generated payslips as distributed; the actor downloads the files locally.",
            "email": "Email",
            "email-hint": "Send each payslip to the employee's registered email address.",
            "portal": "Self-service portal",
            "portal-hint": "Publish each payslip to the employee's self-service portal."
          },
          "submit": "Distribute now",
          "submitting": "Distributing…",
          "cancel": "Cancel",
          "success": "Distributed {count} payslip(s).",
          "skipped": "{count} row(s) skipped (on hold, wrong delivery method, or not generated).",
          "error": "Couldn't distribute the payslips — {message}"
        },
        "hold-resolve": {
          "action": "Resolve hold",
          "empty": "Open an on-hold payslip to resolve it.",
          "reason-title": "Hold reason",
          "method-label": "Pick a delivery method",
          "methods": {
            "manual": "Manual download",
            "email": "Email",
            "portal": "Self-service portal"
          },
          "email-label": "Employee email",
          "email-placeholder": "Enter the employee's email address",
          "email-required-error": "An email address is required for EMAIL delivery.",
          "portal-label": "Activate the employee's self-service portal",
          "portal-hint": "Required for PORTAL delivery so the employee can sign in.",
          "portal-required-error": "Activation is required for PORTAL delivery.",
          "required-marker": "(required)",
          "submit": "Resolve hold",
          "submitting": "Resolving…",
          "cancel": "Cancel",
          "error": "Couldn't resolve the hold — {message}"
        }
      }
    },
    "people": {
      "title": "People",
      "subtitle": "{total} employees",
      "page-subtitle": "{direct} internal · {outsourced} outsourced",
      "tab-coming-soon": "Coming in a follow-up slice",
      "tabs": {
        "directory": "Directory",
        "outsourced": "Outsourced Workforce",
        "clients": "Clients",
        "external": "External Approvers",
        "emp-records": "Employment Records",
        "sites": "Sites",
        "org-units": "Org Units",
        "org-chart": "Org Chart",
        "workforce-plan": "Workforce Plan",
        "positions": "Positions",
        "onboarding": "Onboarding",
        "offboarding": "Offboarding",
        "compliance": "Compliance",
        "configuration": "Configuration"
      },
      "clients": {
        "subtitle": "Outsourcing customers · group projects · external approvers",
        "add-client": "Add Client",
        "search-placeholder": "Search clients, contacts, industry…",
        "status-unknown": "Unknown",
        "yes": "Yes",
        "no": "No",
        "banner": {
          "title": "Clients",
          "lead": "A client groups one or more outsourcing projects (e.g. Unilever → APSARA · NAO). Projects carry the employees; external approvers are scoped to the client."
        },
        "filters": {
          "all": "All",
          "active": "Active",
          "archived": "Archived",
          "all-platform": "All platforms",
          "on-platform": "On platform",
          "off-platform": "Off platform",
          "label-status": "Status",
          "label-platform": "Platform",
          "label-search": "Search"
        },
        "actions": {
          "clear-filters": "Clear filters",
          "cancel": "Cancel",
          "create": "Create client",
          "save": "Save changes"
        },
        "table": {
          "name": "Client",
          "industry": "Industry",
          "contact": "Primary contact",
          "platform": "Platform",
          "status": "Status",
          "on-platform-tag": "On platform",
          "showing": "Showing {filtered} of {total} clients",
          "click-hint": "Click a row to open the client profile"
        },
        "empty": {
          "title": "No clients match the current filters."
        },
        "error": "Failed to load clients.",
        "error-403": "You don't have access to this client list.",
        "retry": "Retry",
        "fields": {
          "name": "Display name",
          "name-placeholder": "e.g. Unilever",
          "legal-name": "Legal name",
          "industry": "Industry",
          "on-platform": "Client is also on OptimalHR (cross-tenant)",
          "counterparty": "Counterparty tenant",
          "primary-contact": "Primary contact",
          "contact-name": "Contact name",
          "contact-email": "Contact email",
          "contact-phone": "Contact phone",
          "email-invalid": "Enter a valid email address.",
          "address": "Address",
          "notes": "Notes"
        },
        "engagement": {
          "provider-managed": "Provider-managed",
          "vendor-lite": "Vendor lite",
          "service": "Service",
          "unknown": "Unknown"
        },
        "create": {
          "title": "Add client",
          "subtitle": "Create a new outsourcing customer."
        },
        "edit": {
          "title": "Edit client"
        },
        "profile": {
          "back": "Back to Clients",
          "edit": "Edit",
          "error": "Failed to load this client.",
          "sections": {
            "profile": "Profile",
            "projects": "Projects",
            "approvers": "External Approvers",
            "staff": "Staff"
          }
        },
        "projects": {
          "add": "Add Project",
          "edit": "Edit",
          "create-title": "Add project",
          "edit-title": "Edit project",
          "empty": "No projects under this client yet.",
          "error": "Failed to load projects.",
          "contract-count": "{n} contracts",
          "fields": {
            "name": "Project name",
            "engagement": "Engagement type",
            "org-full": "Organisation full name",
            "org-short": "Organisation short name",
            "id-format": "Employee ID format",
            "id-format-hint": "Optional pattern for auto-generated employee codes."
          }
        },
        "approvers": {
          "placeholder": "External approvers for this client are managed in the External Approvers tab.",
          "go-to-tab": "Open External Approvers",
          "error": "Couldn’t load approvers.",
          "empty": "No external approvers for this client yet.",
          "count": "{active} active approvers · {covered}/{total} projects covered"
        },
        "staff": {
          "placeholder": "Staff roster by client is coming in a later slice. For now, see contract counts under each project."
        },
        "toasts": {
          "created": "Client \"{name}\" created.",
          "create-failed": "Could not create the client. Try again.",
          "saved": "Client saved.",
          "save-failed": "Could not save the client. Try again.",
          "project-created": "Project \"{name}\" created.",
          "project-saved": "Project saved.",
          "project-failed": "Could not save the project. Try again."
        }
      },
      "emp-records": {
        "title": "Employment Records",
        "subtitle": "Offers · Contracts · Employment Actions · Compensation · Benefits — single hub for the employee's employment story",
        "actions": {
          "new-record": "New Record",
          "view": "View",
          "clear-filters": "Clear filters",
          "cancel": "Cancel",
          "close": "Close",
          "edit": "Edit"
        },
        "sub-tabs": {
          "offers": "Offers",
          "contracts": "Contracts",
          "actions": "Employment Actions",
          "compensation": "Compensation",
          "benefits": "Benefits"
        },
        "dispatch": {
          "title": "Create employment record",
          "lede": "Pick the record type you want to create — we'll route the rest.",
          "form-title": "New {kind}",
          "form-lede": "Fill in the basics — the team will be notified once you submit.",
          "back": "Back",
          "cancel": "Cancel",
          "submit": "Create",
          "created-toast": "{kind} draft created for {employee}",
          "fields": {
            "employee": "Employee or candidate",
            "detail": "Notes / detail"
          },
          "placeholders": {
            "employee": "Search by name or employee code…",
            "detail": "Add context — effective date, amount, terms, etc."
          },
          "errors": {
            "no-kind": "Please pick a record type first.",
            "employee-required": "Employee or candidate is required."
          },
          "offer": {
            "title": "Offer",
            "desc": "Draft an offer letter for a candidate."
          },
          "contract": {
            "title": "Contract",
            "desc": "Issue a new employment contract."
          },
          "action": {
            "title": "Employment Action",
            "desc": "Promotion, transfer, salary or allowance change."
          },
          "benefit": {
            "title": "Benefit",
            "desc": "Enrol an employee into a benefit programme."
          },
          "compensation": {
            "title": "Compensation Event",
            "desc": "Record a salary, bonus, or allowance change."
          }
        },
        "offers": {
          "banner": "Offer Letters are pre-contract employment offers issued to candidates before Add Person. Lifecycle: Draft → Issued → Accepted (or Declined / Withdrawn / Expired). After issue but before acceptance, edits create a new version (Revise & Re-issue). On Accept, downstream creation of Person + Contract + Compensation is wired in CT-4.",
          "search-placeholder": "Candidate, position, offer ID…",
          "showing": "Showing {filtered} of {total}",
          "footer-note": "{shown} of {total} offers shown · Per-offer override always allowed — packages from the Allowance & Benefits library are starting points, not constraints.",
          "new-offer": "New Offer",
          "filters": {
            "status": "Status",
            "workforce": "Workforce",
            "search": "Search"
          },
          "status-filter": {
            "open": "Open (Draft + Issued)",
            "all": "All statuses"
          },
          "statuses": {
            "Draft": "Draft",
            "Issued": "Issued",
            "Distributed": "Distributed",
            "Accepted": "Accepted",
            "Declined": "Declined",
            "Withdrawn": "Withdrawn",
            "Expired": "Expired"
          },
          "workforce": {
            "all": "All",
            "direct": "Direct",
            "outsourced": "Outsourced"
          },
          "kpi": {
            "all": "All",
            "draft": "Draft",
            "issued-not-sent": "Issued · not sent",
            "distributed": "Distributed · awaiting response",
            "accepted": "Accepted",
            "declined": "Declined"
          },
          "cols": {
            "code": "Offer ID",
            "candidate": "Candidate",
            "position": "Position",
            "scope": "Scope",
            "salary": "Salary",
            "type-on-accept": "Type → on Accept",
            "issued": "Issued",
            "status": "Status",
            "actions": "Actions"
          },
          "scope": {
            "direct": "Direct",
            "outsourced": "Outsourced"
          },
          "drawer": {
            "candidate-email": "Email",
            "candidate-phone": "Phone",
            "scope": "Scope",
            "position": "Position",
            "job-grade": "Job grade",
            "contract-type": "Contract type on accept",
            "salary": "Gross salary (monthly)",
            "start": "Proposed start",
            "valid-until": "Valid until",
            "end": "Proposed end",
            "probation-end": "Probation ends",
            "allowances": "Allowances",
            "notes": "Internal notes",
            "issued": "Issued",
            "distributed": "Distributed",
            "accepted": "Accepted",
            "declined-reason": "Decline reason"
          },
          "empty": {
            "title": "No offers match",
            "lede": "Try clearing a filter or adjusting your search."
          },
          "form": {
            "new-title": "New Offer Letter",
            "new-sub": "Draft · pick position, package will auto-fill",
            "no-name": "(no name)",
            "no-position": "(no position)",
            "close": "Close",
            "view-mode": "View mode.",
            "edit": "Edit",
            "chain": "Version {version} · revised offer chain.",
            "candidate": "Candidate",
            "latin-name": "Latin Name *",
            "khmer-name": "Khmer Name",
            "email": "Email",
            "phone": "Phone",
            "position-contract": "Position & Contract Type",
            "workforce-type": "Workforce Type *",
            "job-grade": "Job Grade *",
            "grade-hint": "(filters vacancies below)",
            "client": "Client",
            "project": "Project",
            "select": "— select —",
            "any-project": "— Any project —",
            "position": "Position *",
            "position-hint": "(from Vacancy list)",
            "select-position": "— Select a vacant position{grade} —",
            "position-other": "— Other (free-text, no vacancy) —",
            "position-other-ph": "Free-text position title (e.g. for a new role not yet in vacancy list)",
            "no-vacancies": "No vacant positions at {grade} for this workforce. Switch grade or pick Other (free-text).",
            "selected": "Selected",
            "contract-type": "Contract Type on Accept *",
            "start-date": "Proposed Start Date *",
            "valid-until": "Offer Valid Until *",
            "end-date": "Proposed End Date *",
            "fdc-max": "(max 24 months per LL)",
            "prob-end": "(= probation end)",
            "fdc-warn": "FDC max is 24 months per Cambodia LL ({months} months specified)",
            "include-probation": "Include probation period",
            "probation-end-date": "Probation End Date *",
            "probation": "Probation",
            "probation-ends": "Yes · ends {date}",
            "no": "No",
            "compensation": "Compensation Package",
            "override": "· per-offer override",
            "template": "· template: {ref}",
            "gross-salary": "Gross Salary (Monthly) *",
            "gross-salary-short": "Gross Salary",
            "salary-ph": "e.g. 1500",
            "salary-band-warn": "Outside {code} band (${min}-${max})",
            "allowance-package": "Allowance Package",
            "allowance-package-hint": "(choose a template or pick Custom to define your own)",
            "choose-template": "— Choose template or Custom —",
            "custom": "Custom (define manually)",
            "no-allowance-template": "No matching template — pick Custom and add lines below.",
            "allowance": "Allowance",
            "monthly": "Monthly",
            "no-allowances": "No allowances",
            "add-one": "add one",
            "total-allowances": "Total allowances + base",
            "add-allowance": "Add allowance line",
            "remove": "Remove",
            "benefits": "Benefits",
            "benefits-package": "Benefits Package",
            "benefits-package-hint": "(choose a template or pick Custom)",
            "no-benefits-template": "No matching template — pick Custom.",
            "pick-benefits": "Pick a template above or switch to",
            "no-benefits": "No benefits defined.",
            "note-optional": "Note (optional)",
            "conditions-notes": "Conditions & Notes",
            "conditions": "Conditions before joining",
            "conditions-hint": "(one per line — things candidate must satisfy before start date)",
            "conditions-ll": "Cambodia LL compulsory: medical clearance from Labor Department doctor. Other conditions (background check, references) are company policy.",
            "no-conditions": "No conditions specified.",
            "internal-notes": "Internal Notes",
            "notes-hint": "(not visible on offer letter)",
            "notes-label": "Notes",
            "letter-preview": "Letter Preview",
            "download-pdf": "Download as PDF",
            "all-filled": "All required fields filled",
            "cancel": "Cancel",
            "cancel-edit": "Cancel edit",
            "save-draft": "Save Draft",
            "save-issue": "Save & Issue",
            "status": "Status",
            "toast-draft": "Offer {id} saved as Draft",
            "toast-issued": "Offer {id} issued"
          }
        },
        "contracts": {
          "banner": "Contracts hold the agreed legal terms of employment. Each type drives its own lifecycle: Probation converts to FDC/UDC via a new contract · FDC extends or converts to UDC · UDC changes go through Employment Change (the contract persists) · any contract can be Terminated. Click a row to view its full chain history.",
          "search-placeholder": "Search by code, employee, position, or type…",
          "showing": "Showing {filtered} of {total}",
          "footer-note": "{shown} of {total} contracts shown · Lifecycle actions (Convert · Extend · Issue Employment Change · Terminate) are available in the detail drawer when contract status is Active",
          "kpi": {
            "active": "Active contracts",
            "expiring-30": "Expiring ≤30 days",
            "expiring-31-60": "Expiring 31-60 days",
            "probation-ending-30": "Probation ending ≤30d",
            "unsigned": "Unsigned"
          },
          "filters": {
            "status": "Status",
            "type": "Contract Type",
            "workforce": "Workforce",
            "client": "Client",
            "search": "Search"
          },
          "status-opts": {
            "active": "Active only",
            "all": "All statuses",
            "Active": "Active",
            "history": "History (Superseded/Expired/Terminated)",
            "pending": "Pending Signature"
          },
          "type-opts": {
            "all": "All types"
          },
          "workforce": {
            "all": "All",
            "direct": "Direct",
            "outsourced": "Outsourced"
          },
          "client-opts": {
            "all": "All clients"
          },
          "cols": {
            "code": "Contract ID",
            "employee": "Employee",
            "type": "Type",
            "position": "Position",
            "scope": "Scope",
            "start": "Start",
            "end": "End",
            "status": "Status",
            "actions": "Actions"
          },
          "scope": {
            "direct": "Direct",
            "outsourced": "Outsourced"
          },
          "exp-chip": {
            "le30": "≤30d",
            "le60": "≤60d",
            "expired": "Expired"
          },
          "empty": {
            "no-match": "No contracts match the current filters.",
            "title": "No contracts match",
            "lede": "Try clearing a filter or adjusting your search."
          },
          "detail": {
            "close": "Close",
            "close-btn": "Close",
            "no-position": "No position",
            "header": "Header",
            "employee": "Employee",
            "position": "Position",
            "type": "Type",
            "status": "Status",
            "scope": "Scope",
            "reports-to": "Reports To",
            "start": "Start Date",
            "end": "End Date",
            "indefinite": "Indefinite",
            "probation-end": "Probation End",
            "notice-period": "Notice Period",
            "work-location": "Working Location",
            "working-hours": "Working Hours",
            "remuneration": "Remuneration",
            "remuneration-note": "(initial values from contract · live values in Compensation)",
            "gross-salary": "Gross Salary",
            "pay-frequency": "Pay Frequency",
            "pay-method": "Pay Method",
            "extensions": "Extensions ({count})",
            "ext-addendum": "Addendum",
            "ext-old-end": "Old End",
            "ext-new-end": "New End",
            "ext-signed": "Signed",
            "ext-reason": "Reason",
            "amendments": "Amendments / Employment Changes ({count})",
            "amd-eff": "eff. {date}",
            "amd-reason": "Reason: {reason}",
            "amd-by": "by {by}",
            "chain": "Contract Chain ({count})",
            "chain-viewing": "← viewing",
            "chain-open": "open",
            "signed-copy": "Signed Copy",
            "signed-by": "Signed by:",
            "document": "Document:",
            "not-attached": "Not attached",
            "not-signed": "Contract not yet signed.",
            "footer-id": "Contract",
            "action-convert": "Convert to UDC…",
            "action-extend": "Extend…",
            "action-amend": "Issue Employment Change…",
            "action-terminate": "Terminate…",
            "action-stub": "{action} — coming soon. Contracts are created from accepted offers in this build."
          },
          "chips": {
            "all": "All",
            "active": "Active",
            "probation": "Probation",
            "expiring": "Expiring ≤30d",
            "unsigned": "Unsigned",
            "expired": "Expired"
          },
          "drawer": {
            "position": "Position",
            "employee-code": "Employee Code",
            "start": "Start",
            "end": "End",
            "notes": "Notes"
          }
        },
        "actions-tab": {
          "title": "Employment Actions",
          "subtitle": "Cross-employee operational workspace · Phase 1 recording · status derived from effective date · no approval queue",
          "new-action": "New Employment Action",
          "search-placeholder": "Search by code, employee, type, or detail…",
          "showing": "Showing {filtered} of {total}",
          "banner-title": "Phase 1 · Recording only.",
          "banner-lede": "HR records EAs that were approved offline (memo / letter / LM sign-off). Status: Scheduled (future effective date) → Effective (today / past). Approval workflow comes in Phase 2.",
          "phase2": "Phase 2",
          "kpi": {
            "all-eas": "All EAs",
            "scheduled": "Scheduled",
            "effective-this-week": "Effective this week",
            "by-detected-label": "By Detected Label",
            "cancelled": "Cancelled",
            "cancelled-delta": "{n} cancelled",
            "future-dated": "future-dated",
            "last-7-days": "in the last 7 days",
            "retained": "retained for audit"
          },
          "filters": {
            "all-types": "All action types",
            "all-labels": "All detected labels",
            "all-statuses": "All statuses"
          },
          "status": {
            "scheduled": "Scheduled",
            "effective": "Effective",
            "cancelled": "Cancelled"
          },
          "cols": {
            "effective": "Effective Date",
            "employee": "Employee",
            "type": "Action Type",
            "detail": "Detail",
            "detected-label": "Detected Label",
            "status": "Status",
            "comp": "Comp",
            "actions": "Actions",
            "code": "Code"
          },
          "empty": {
            "title": "No employment actions match",
            "lede": "Try clearing a filter or adjusting your search.",
            "lede-none": "Click New Employment Action to record the first one."
          },
          "modal": {
            "aria": "Employment Action",
            "title": "New Employment Action",
            "step1": "Step 1 of 3 · choose the Employment Event Classification",
            "step2": "Step 2 of 3 · choose the employee this classification applies to",
            "step3": "Step 3 of 3 · fill in the form · Phase 1 recording",
            "what-change": "What kind of change?",
            "what-change-lede": "Pick the business classification first. Each classification has its own form. Next you'll pick the employee, then fill in the form.",
            "classification": "Classification",
            "change-classification": "Change classification",
            "pick-employee": "Pick Employee",
            "employee": "Employee",
            "employee-search": "Search by ID · name · position · department…",
            "employee-hint": "Excludes inactive employees. Click a row to continue to the {label} form.",
            "employee-empty": "No active employees match your search.",
            "upcoming": "{label} — Upcoming Feature · planned for a later phase",
            "upcoming-tag": "⏸ UPCOMING FEATURE",
            "detail-title": "Detail",
            "recorded": "Recorded {date}",
            "toast-saved": "{label} recorded · status: {status}"
          },
          "form": {
            "effective-date": "Effective Date",
            "effective-hint": "Back-date window: {days} days · Today (demo): {today}",
            "reason": "Reason",
            "reason-placeholder": "Why is this change being recorded?",
            "document": "Document Reference",
            "document-placeholder": "Filename or reference (e.g. PromotionLetter-2026-014.pdf · filed in personnel file)",
            "dropzone": "Drag & drop or browse to attach the offline memo / letter",
            "offline-label": "Offline approval completed",
            "offline-desc": "LM / HR / Employee have agreed and signed off offline (memo, letter, or verbal). Tick when the paper trail is in place.",
            "offline-notes": "Notes — e.g. Approved by LM Sopheap, memo signed 2026-06-28",
            "companion-label": "Companion: also record a Salary Adjustment",
            "companion-desc": "Position Assignment often carries a salary change. Records two distinct entries (one Employment Action + one Compensation Event) sharing this effective date and reason.",
            "base-salary": "Base Salary",
            "new-base-salary": "New Base Salary",
            "routing-template": "Routing template (stored, not executed)",
            "position-placeholder": "Pick a target Position…",
            "position-search": "Search Title · Department · Site · Grade…",
            "position-empty": "No assignable Positions match · all matching seats are currently occupied.",
            "vacant": "Vacant",
            "manager-placeholder": "Pick a manager…",
            "pick": "Pick…",
            "value": "value",
            "detected-action": "Detected Action (derived from delta)",
            "delta-attribute": "Attribute",
            "delta-current": "Current",
            "delta-target": "Target",
            "no-change": " (No Change)",
            "ready": "Ready to save · status will be {status}",
            "missing": "{n} required field(s) missing or invalid",
            "cancel": "Cancel",
            "save": "Save Record"
          },
          "detail": {
            "record-id": "Record ID",
            "employee": "Employee",
            "effective": "Effective Date",
            "status": "Status",
            "detected": "Detected Action",
            "document": "Document ref",
            "offline": "Offline approval",
            "offline-yes": "Completed",
            "offline-no": "Not marked completed",
            "change-summary": "Change Summary",
            "position-delta": "Position Delta (at record)",
            "routing": "Approval Routing Reference",
            "routing-template": "Routing template (stored, not executed)",
            "cancel-record": "Cancel Record",
            "close": "Close"
          },
          "chips": {
            "all": "All",
            "pending": "Pending",
            "approved": "Approved",
            "effective": "Effective"
          },
          "drawer": {
            "effective": "Effective Date",
            "approver": "Approver",
            "detail": "Detail"
          }
        },
        "benefits": {
          "title": "Benefits",
          "subtitle": "Cross-employee enrollment workspace · {employees} employees · {entries} catalog entries · monthly cost rollup",
          "new-benefit": "New Benefit",
          "bulk-enroll": "Bulk Enroll",
          "edit-catalog": "Edit catalog",
          "search-placeholder": "Search by benefit, provider, kind…",
          "showing": "Showing {filtered} of {total}",
          "footer-note": "New Benefit adds a catalog entry company-wide · Bulk Enroll enrolls many eligible employees at once · click the pencil on any row to edit. For individual enrollment, go to the employee's Profile → Benefits.",
          "kpi": {
            "active-enrollments": "Active enrollments",
            "employees-enrolled": "Employees enrolled",
            "monthly-cost-employer": "Monthly cost (employer)",
            "renewing-90": "Renewing ≤90 days",
            "across-all": "across all benefits",
            "coverage": "{pct}% coverage",
            "annualized": "USD {amount} annualized",
            "action-needed": "action needed",
            "all-clear": "all clear"
          },
          "chips": {
            "all": "All",
            "active": "Active",
            "renewing": "Renewing",
            "ended": "Ended"
          },
          "cols": {
            "benefit": "Benefit",
            "enrolled": "Enrolled",
            "eligible": "Eligible",
            "takeup": "Take-up",
            "monthly-cost": "Monthly Cost",
            "renewal": "Renewal",
            "actions": "Actions"
          },
          "kinds": {
            "Insurance": "Insurance",
            "Statutory": "Statutory",
            "Wellness": "Wellness",
            "Allowance In-kind": "Allowance In-kind",
            "Other": "Other"
          },
          "statuses": {
            "Active": "Active",
            "Renewing": "Renewing",
            "Ended": "Ended"
          },
          "workforce": {
            "Direct": "Direct",
            "Outsourced": "Outsourced"
          },
          "eligibility-types": {
            "all": "All employees",
            "grade": "Grade-based (minimum)",
            "workforce_type": "Workforce type (Direct / Outsourced)",
            "tenure": "Tenure (minimum months)",
            "department": "Specific Department"
          },
          "catalog": {
            "new-title": "New Benefit",
            "edit-title": "Edit Benefit",
            "subtitle": "Master catalog entry",
            "kind": "Kind",
            "status": "Status",
            "name": "Benefit Name",
            "name-ph": "e.g., Infinity Group Health · Plan A",
            "provider": "Provider",
            "provider-ph": "e.g., Infinity General Insurance",
            "scheme": "Scheme / Coverage Tier",
            "scheme-ph": "e.g., Accident + Health",
            "coverage": "Coverage Items (comma-separated)",
            "coverage-ph": "e.g., Health, Hospitalization, OPD",
            "eligibility": "Eligibility",
            "min-grade": "Min Grade Number",
            "workforce-type": "Workforce Type",
            "min-months": "Min Months",
            "department": "Department",
            "department-ph": "e.g., Sales",
            "label": "Label",
            "cost-employee": "Cost / employee / mo (USD)",
            "cost-family": "Cost / family / mo (USD)",
            "renewal": "Next Renewal",
            "policy-pattern": "Policy ID Pattern",
            "policy-pattern-opt": "(optional · use {code} placeholder)",
            "policy-pattern-ph": "e.g., P/01/GPA/24/{code}",
            "create": "Create Benefit",
            "save-changes": "Save Changes",
            "toast-created": "Created {name}",
            "toast-updated": "Updated {name}"
          },
          "bulk": {
            "title": "Bulk Enroll in Benefit",
            "step1": "Step 1 · Pick the benefit to bulk-enroll",
            "step1-eyebrow": "Step 1 · pick benefit",
            "step2": "Step 2 · Pick employees to enroll",
            "selected-benefit": "SELECTED BENEFIT",
            "selected-count": "{count} selected",
            "currently-enrolled": "{count} currently enrolled",
            "eligible-not-enrolled": "{count} eligible · not enrolled",
            "pick-different": "← Pick a different benefit",
            "select-all": "Select all",
            "clear": "Clear",
            "all-enrolled": "All eligible employees are already enrolled.",
            "submit": "Enroll {count} employee(s)",
            "toast": "{count} employee(s) enrolled in {name}"
          },
          "drawer": {
            "provider": "Provider",
            "eligibility": "Eligibility",
            "cost-per-employee": "Cost per Employee",
            "renewal": "Renewal",
            "description": "Description"
          },
          "empty": {
            "title": "No benefits match",
            "lede": "Try clearing a filter or adjusting your search."
          }
        },
        "compensation": {
          "title": "Compensation Center",
          "subtitle": "Components · packages · assignments · events · reports — workforce-wide · Phase 1 record-only",
          "tabs": {
            "overview": "Overview",
            "components": "Components",
            "packages": "Packages",
            "assignments": "Assignments",
            "events": "Events",
            "reports": "Reports"
          },
          "phase-banner": {
            "title": "Phase 1 · Record-only.",
            "body": "Compensation Events save directly to the Compensation Timeline and Contract Salary Adjustment history. Approvals happen offline. The workflow engine lands in Phase 2."
          },
          "kpi": {
            "active-employees": "Active Employees",
            "total-monthly-comp": "Total Monthly Comp",
            "components": "Components",
            "packages": "Packages",
            "salary-adj-ytd": "Salary Adj {year}",
            "bonuses-ytd": "Bonuses {year}",
            "in-scope": "in scope",
            "recurring-wide": "recurring package · workforce-wide",
            "active-catalog": "active in catalog",
            "pkg-breakdown": "{allowance} allowance · {benefits} benefits",
            "recorded": "recorded",
            "total": "total"
          },
          "actions": {
            "manage-components": "Manage Components",
            "manage-components-desc": "Add or edit Pay Component Catalog",
            "build-packages": "Build Packages",
            "build-packages-desc": "Bundle components by scope",
            "bulk-assign": "Bulk Assign",
            "bulk-assign-desc": "By department + grade",
            "record-event": "Record Event",
            "record-event-desc": "Salary · bonus · allowance change"
          },
          "top-depts": {
            "title": "Top Departments by Monthly Comp",
            "view-report": "View full report →",
            "empty": "No data."
          },
          "recent-events": {
            "title": "Recent Events",
            "view-ledger": "Open full ledger →",
            "empty": "No Compensation Events recorded yet."
          },
          "stub": {
            "lede": "This panel ships with the Phase B compensation backend (components, packages, assignments, events ledger, reports). For now use Overview to land on the workforce-wide picture.",
            "back": "Back to Overview"
          },
          "phase2": "PHASE 2",
          "filters": {
            "category": "Category",
            "status": "Status",
            "dept": "Department",
            "grade": "Job Grade",
            "contract": "Contract",
            "all": "All",
            "all-depts": "All depts",
            "all-grades": "All grades",
            "all-contracts": "All contracts"
          },
          "components": {
            "title": "Pay Component Catalog",
            "subtitle": "Master list of components used across packages and per-employee assignments. Edits cascade to all employees on next save.",
            "new": "New Component",
            "search-placeholder": "Search by code or name…",
            "empty": "No matching components.",
            "status-active": "Active",
            "status-inactive": "Inactive",
            "cat": {
              "all": "All categories",
              "base": "Base Pay",
              "allowance": "Allowance",
              "var": "Variable Pay"
            },
            "status": {
              "active": "Active only",
              "all": "All",
              "inactive": "Inactive only"
            },
            "cols": {
              "code": "Code",
              "name": "Name",
              "category": "Category",
              "recurring": "Recurring",
              "tax": "Tax Treatment",
              "nssf": "NSSF Base",
              "funded": "Funded",
              "status": "Status"
            },
            "legend": {
              "none": "Excluded from tax",
              "tos": "Progressive tier per salary band (Cambodia LL)",
              "fringe": "20% flat-rate Fringe Benefit Tax"
            }
          },
          "packages": {
            "title": "Allowance & Benefits Packages",
            "subtitle": "Bundle components into reusable packages scoped by Workforce Type · Client · Project · Job Grade. Cascade: Project → Client → Tenant-generic. Used by Offer Letters and Add Person pre-fill.",
            "allowance-title": "Allowance Packages",
            "benefits-title": "Benefits Packages",
            "cols": {
              "name": "Package",
              "scope": "Scope",
              "components": "Components",
              "monthly": "Monthly",
              "enabled": "Enabled",
              "items": "Items",
              "contract": "Contract"
            },
            "kpi": {
              "active": "Active in section",
              "direct": "Direct templates",
              "outsourced": "Outsourced templates",
              "shown": "Shown after filters"
            },
            "filters": {
              "workforce": "Workforce",
              "client": "Client",
              "project": "Project",
              "all-clients": "All clients",
              "all-projects": "All projects"
            },
            "workforce-direct": "Direct only",
            "workforce-outsourced": "Outsourced only",
            "show-inactive": "Show inactive",
            "empty": "No packages match the current filters.",
            "footnote": "Templates are foundation only in this release — consumed by the Offer Letter flow and the Add Person pre-fill in upcoming slices. Per-offer override remains available regardless of template selection.",
            "on": "on",
            "off": "off",
            "detail": {
              "scope": "Scope",
              "notes": "Notes",
              "line-items": "Line Items",
              "allowance": "Allowance",
              "amount": "Monthly Amount",
              "total": "Total per month"
            }
          },
          "assignments": {
            "title": "Employee Compensation Assignments",
            "subtitle": "Who's on which package · base + allowance components per employee. Use Bulk Assign for group changes.",
            "bulk": "Bulk Assign by Group",
            "search-placeholder": "Search name, code, title…",
            "showing": "Showing {shown} of {total} employees",
            "empty": "No employees match.",
            "cols": {
              "employee": "Employee",
              "title": "Title",
              "base": "Base / mo",
              "allowances": "Allowance Components",
              "allowance-total": "Allowances / mo",
              "total": "Total / mo"
            },
            "open-profile": "Open {name} profile"
          },
          "events": {
            "title": "Compensation Events Ledger",
            "subtitle": "Every recorded Salary Adjustment, Bonus, Variable Pay change, and Allowance event across the workforce.",
            "export": "Export CSV",
            "export-soon": "Cross-employee export — coming soon",
            "record": "Record Event",
            "search-placeholder": "Search employee, event type, or reason…",
            "event-type": "Event type",
            "date-range": "Date range",
            "types": {
              "all": "All event types",
              "salary": "Salary Adjustment",
              "bonus": "Bonus Awarded",
              "varpay": "Variable Pay Eligibility",
              "allowance": "Allowance (Add / Change / End)"
            },
            "ranges": {
              "30": "Last 30 days",
              "90": "Last 90 days",
              "180": "Last 6 months",
              "365": "Last 12 months",
              "all": "All time"
            },
            "ledger-title": "Compensation Events Ledger",
            "ledger-count": "{groups} entries · {filtered} of {total} events (bulk actions grouped)",
            "empty": "No Compensation Events match the current filters.",
            "cols": {
              "effective": "Effective",
              "employee": "Employee",
              "event": "Event",
              "detail": "Detail",
              "reason": "Reason",
              "status": "Status"
            },
            "effective": "Effective",
            "scheduled": "Scheduled",
            "employees": "employees",
            "bulk": "BULK",
            "same-to": "same amount to {count} employees",
            "show": "Show {count}",
            "hide": "Hide {count}",
            "open-profile": "Open employee profile"
          },
          "cost-alloc": {
            "title": "Cost Allocation Overview",
            "manage": "Manage (Phase 2)",
            "body": "Cross-employee project allocation editing comes in Phase 2. Per-employee read-only view available on each Profile → Compensation tab."
          },
          "reports": {
            "title": "Compensation Reports",
            "subtitle": "Lightweight analytics across the workforce.",
            "by-component": "By Component",
            "by-dept": "By Department",
            "by-grade": "By Job Grade",
            "top-earners": "Top Earners",
            "dept-total": "Total · {count} depts",
            "footnote": "Phase 1 reports use the current effective package. Charts, period comparisons, and CSV export land in Phase 2.",
            "cols": {
              "component": "Component",
              "assignments": "Assignments",
              "monthly-total": "Monthly Total",
              "distribution": "Distribution",
              "department": "Department",
              "headcount": "Headcount",
              "base-total": "Base Total",
              "allowances-total": "Allowances Total",
              "grade": "Job Grade",
              "avg-monthly": "Avg Monthly",
              "employee": "Employee",
              "title-dept": "Title · Dept",
              "base": "Base",
              "allowances": "Allowances",
              "total-monthly": "Total Monthly"
            }
          },
          "picker": {
            "title": "Record Compensation Event",
            "sub": "Pick the employee first · then choose the event type",
            "search": "Search",
            "search-placeholder": "Name, code, or title…",
            "helper": "Showing first 30 matches. Refine search to narrow.",
            "empty": "No matching employees.",
            "toast": "Opening Compensation for {name} — Phase 2 records the event."
          },
          "bulk": {
            "title": "Bulk Assign Compensation Component",
            "sub": "Phase 1 record-only · creates one Compensation Event per matched employee",
            "info-title": "Bulk Assign by Group.",
            "info-body": "Pick a Department + Grade combination, then a component and amount. One Compensation Event is recorded per matched employee. The Contract Base Salary is never overwritten.",
            "matched": "Matched Employees",
            "will-receive": "employees will receive this assignment",
            "component": "Component",
            "select-component": "Select an allowance component…",
            "component-helper": "Only allowance components are bulk-assignable in Phase 1. Salary adjustments must be recorded per-employee.",
            "amount": "Amount (USD)",
            "amount-helper": "Same amount applied to every matched employee.",
            "funded": "Funded by",
            "funded-optimal": "Optimal-funded",
            "funded-client": "Client-funded",
            "effective": "Effective Date",
            "reason": "Reason",
            "reason-placeholder": "e.g. Department-wide phone allowance roll-out",
            "submit": "Record {count} Events",
            "toast": "{count} Compensation Events recorded · see Events ledger"
          },
          "component": {
            "new-title": "New Component",
            "edit-title": "Edit Component — {name}",
            "sub": "Master Pay Component · cascades to all packages and assignments",
            "code": "Code",
            "code-helper": "Short uppercase identifier · cannot be changed later.",
            "code-immutable": "Code is immutable once created.",
            "name-en": "Name (English)",
            "name-km": "Name (Khmer)",
            "tax": "Tax Treatment",
            "flags": "Other Flags",
            "recurring": "Recurring (paid every period)",
            "nssf": "Counts toward NSSF base",
            "seniority": "Counts toward Seniority base",
            "funding": "Default Funding",
            "funded-optimal": "Optimal-funded",
            "funded-client": "Client-funded",
            "funded-policy": "Policy-driven (per assignment)",
            "save": "Save Changes",
            "create": "Create Component",
            "toast-created": "Component \"{name}\" created",
            "toast-updated": "Component \"{name}\" updated",
            "tax-help": {
              "none": "Excluded from both Tax on Salary (TOS) and Fringe Benefit Tax. E.g. transport, meal allowances within statutory limits.",
              "tos": "Tax on Salary · progressive tier per Cambodia LL. Applies to cash compensation paid directly to the employee (base, housing, position, etc.).",
              "fringe": "Fringe Benefit Tax · 20% flat-rate on benefit value. Applies to non-cash benefits (company car, employer-provided accommodation, in-kind allowances, etc.)."
            }
          }
        }
      },
      "sites": {
        "subtitle": "Workplace locations · company-owned and EOR client placements · single source of truth for where employees work",
        "add-site": "Add Site",
        "search-placeholder": "Site name, code, address…",
        "footnote": "{shown} of {total} sites shown · Click any row to view details · Edit, disable, or delete a site from the row actions",
        "banner": {
          "title": "Sites",
          "lead": "— manage workplace locations used as employee Base Locations.",
          "detail": "Sites unifies company-owned offices and EOR client placement sites under a single model. The Main Office is the primary base location; additional Sub Offices can be enabled or disabled as needed."
        },
        "type": {
          "main": "Main Office",
          "sub": "Sub Office",
          "unknown": "Unknown"
        },
        "filters": {
          "all": "All",
          "active": "Active",
          "inactive": "Inactive",
          "all-types": "All types",
          "label-type": "Type",
          "label-status": "Status",
          "label-search": "Search"
        },
        "table": {
          "code": "Site Code",
          "name": "Site Name",
          "type": "Type",
          "owner": "Site Owner",
          "status": "Status",
          "enabled": "Enabled",
          "actions": "Actions",
          "always-on": "Always on",
          "showing": "Showing {filtered} of {total}",
          "click-hint": "Click any row to open the site detail"
        },
        "actions": {
          "clear-filters": "Clear filters",
          "edit": "Edit {name}",
          "edit-short": "Edit",
          "delete": "Delete {name}",
          "delete-short": "Delete",
          "view-map": "View {name} on map",
          "view-map-short": "View on map",
          "toggle": "Enable or disable {name}"
        },
        "empty": {
          "title": "No sites match the current filters."
        },
        "error": {
          "title": "Couldn't load sites."
        },
        "drawer": {
          "close": "Close site detail",
          "section": {
            "address": "Address & GPS",
            "roster": "Details"
          },
          "fields": {
            "gps-lat": "GPS Lat",
            "gps-lon": "GPS Lon",
            "owner": "Site owner"
          },
          "no-value": "—"
        },
        "map": {
          "label": "Site location map",
          "coordinates": "Location coordinates",
          "coordinates-hint": "Click or drag the pin on the map, or type \"latitude, longitude\"."
        },
        "modal": {
          "title": "Create new site",
          "edit-title": "Edit site",
          "subtitle": "Workplace location used as an employee Base Location. Fields marked * are required.",
          "cancel": "Cancel",
          "submit": "Create site",
          "update": "Update site",
          "footnote": "A site needs a name and a map pin (coordinates). The Main Office can be enabled/disabled only as the Main Office.",
          "fields": {
            "name": "Site name",
            "name-placeholder": "e.g. Head Office",
            "code": "Site code",
            "code-placeholder": "Optional company code",
            "type": "Type",
            "location": "Location on map",
            "address": "Address details",
            "address-placeholder": "Street, sangkat, khan",
            "status": "Status"
          }
        },
        "delete": {
          "title": "Delete site?",
          "body": "Are you sure you want to delete \"{name}\"? This cannot be undone.",
          "confirm": "Delete"
        },
        "disable": {
          "title": "Disable site?",
          "body": "Are you sure you want to disable \"{name}\"? Employees can no longer use it as a base location until it is re-enabled.",
          "confirm": "Disable"
        },
        "toasts": {
          "created": "Site \"{name}\" created",
          "updated": "Site \"{name}\" updated",
          "deleted": "Site \"{name}\" deleted",
          "enabled": "Site \"{name}\" enabled",
          "disabled": "Site \"{name}\" disabled"
        }
      },
      "workZones": {
        "title": "Work Zones",
        "section-aria": "Sites and Work Zones",
        "add-zone": "Add Zone",
        "convert-all": "Convert all",
        "search-placeholder": "Search work zones by name, code, or address",
        "no-match": "No work zones match \"{q}\".",
        "status": {
          "active": "Active"
        },
        "table": {
          "location": "Location",
          "address": "Address",
          "employees": "Employees",
          "radius": "Radius",
          "status": "Status",
          "actions": "Actions",
          "no-value": "—"
        },
        "actions": {
          "edit": "Edit work zone {name}",
          "deactivate": "Deactivate work zone {name}",
          "view-employees": "View employees assigned to {name}"
        },
        "empty": {
          "title": "No work zones configured",
          "detail": "Convert an existing base location to a work zone to start enforcing clock in/out boundaries."
        },
        "error": {
          "title": "Couldn't load work zones."
        },
        "form": {
          "add-title": "Add Work Zone",
          "edit-title": "Edit Work Zone",
          "location": "Work location",
          "center-point": "Center point",
          "no-coords": "This location has no coordinates. Set them on the Sites tab before assigning a work zone.",
          "no-locations": "No base locations available.",
          "all-converted": "All base locations are already active work zones.",
          "radius": "Enforcement radius",
          "radius-meters": "Enforcement radius in meters",
          "meters": "meters",
          "cancel": "Cancel",
          "add": "Add zone",
          "save": "Save changes"
        },
        "employees": {
          "title": "Zone employees",
          "subtitle": "{name} · {count} assigned",
          "name": "Full name",
          "code": "Code",
          "position": "Job title",
          "orgUnit": "Org. unit",
          "empty": "No employees assigned to this zone.",
          "close": "Close"
        },
        "deactivate": {
          "title": "Deactivate Work Zone",
          "body": "Deactivate the work zone for \"{name}\"? Employees assigned to this location will no longer be geofence-restricted here. The base location itself stays intact.",
          "confirm": "Deactivate"
        },
        "batch": {
          "convert-all": "Convert all",
          "cancel": "Cancel",
          "dismiss": "Dismiss",
          "staleHint": "This batch hasn't reported progress in over 5 minutes — the worker likely failed before starting. Cancel it to clear the banner and submit a new one.",
          "processed": "{processed} of {total} processed",
          "succeeded": "{count} succeeded",
          "skipped": "{count} location(s) skipped due to missing coordinates.",
          "banner": {
            "title": "Batch conversion",
            "queued": "Batch conversion queued…",
            "processing": "Converting base locations to work zones…",
            "completed": "Batch conversion completed",
            "failed": "Batch conversion failed"
          },
          "error": {
            "invokeWorker": "Could not start the background worker. Try again in a moment.",
            "generic": "The operation failed before finishing. Check the logs."
          },
          "toast": {
            "completed": "{count} location(s) converted.",
            "conflict": "A batch is already in progress. Resuming the existing operation.",
            "cancelled": "Batch cancelled. You can submit a new batch operation now.",
            "submitFailed": "Could not start batch conversion."
          },
          "dialog": {
            "title": "Convert base locations to work zones",
            "lead": "Every active base location with valid coordinates that isn't already a work zone will be activated with the radius below. Locations missing coordinates are skipped automatically.",
            "willConvert": "Will be converted",
            "missingCoords": "Missing coordinates",
            "excluded": "Excluded",
            "exclude": "Exclude specific locations (optional)",
            "excludeHint": "Already-active work zones and locations missing coordinates are skipped automatically.",
            "start": "Start conversion"
          }
        }
      },
      "org-units": {
        "title": "Org Units",
        "subtitle": "Structural backbone of the company · organized by configurable layers",
        "add-unit": "Add Unit",
        "search-placeholder": "Search by name or head…",
        "kpi": {
          "total": "Total Org Units",
          "with-head": "With head assigned",
          "vacant-heads": "Vacant heads"
        },
        "filters": {
          "all-types": "All types",
          "all-parents": "All parents",
          "no-parent": "No parent (top-level)"
        },
        "view": {
          "tree": "Tree",
          "table": "Table"
        },
        "actions": {
          "clear-filters": "Clear filters",
          "define-levels": "Define Levels",
          "edit": "Edit",
          "delete": "Delete"
        },
        "table": {
          "name": "NAME",
          "parent": "PARENT",
          "layer": "LAYER",
          "type": "TYPE",
          "head": "POSITION IN-CHARGE",
          "roles": "LINKED ROLES",
          "vacant-head": "Vacant",
          "showing": "Showing {filtered} of {total} units",
          "sorted-by": "sorted by {col} {dir}",
          "click-hint": "Click any row to open the unit details"
        },
        "tree": {
          "showing": "Showing {n} units across {d} layers",
          "expand-all": "Expand all",
          "collapse-all": "Collapse all",
          "click-hint": "Click any node to open the unit · use the chevron to expand/collapse",
          "no-children": "Leaf"
        },
        "empty": {
          "title": "No matches",
          "lede": "No units match these filters. Try clearing one to widen the search."
        },
        "error": {
          "title": "Couldn't load org units",
          "desc": "Something went wrong while loading the org unit list. Try again."
        },
        "levels-empty": {
          "title": "No layers defined yet",
          "lede": "Define the company's hierarchy layers (e.g. Management, Department, Section) before adding org units.",
          "cta": "Define Levels"
        },
        "drawer": {
          "fields": {
            "name": "Name",
            "type": "Type",
            "parent": "Parent",
            "ancestor-path": "Ancestor path",
            "head": "Position In-Charge",
            "created": "Created",
            "leadership": "Leadership & roles",
            "roles": "Linked roles",
            "child-units": "Child units"
          },
          "no-value": "—",
          "no-children": "No child units yet.",
          "ancestor-root": "Top of company"
        },
        "edit-modal": {
          "subtitle-new": "A unit is a structural node in the company hierarchy.",
          "title-new": "Add Org Unit",
          "title-edit": "Edit {name}",
          "name-label": "Name",
          "name-placeholder": "e.g. Customer Success",
          "name-required": "Name is required",
          "type-label": "Type",
          "layer-required": "Select a layer",
          "parent-label": "Parent unit",
          "parent-note": "Choose a Layer {n} unit as the parent",
          "parent-required": "Parent unit is required",
          "no-levels-note": "No layers are defined yet. Use \"Define Levels\" first, then add units.",
          "head-label": "In-Charge Position",
          "head-placeholder": "Vacant — no position assigned",
          "info-note": "You can assign an In-Charge Position now or leave it vacant and fill it later.",
          "cancel": "Cancel",
          "create": "Create",
          "save": "Save",
          "error-save": "Couldn't save the org unit. Please try again.",
          "error-delete": "Couldn't delete the org unit. Please try again.",
          "delete": {
            "title": "Delete org unit",
            "warning": "This permanently deletes the org unit. This cannot be undone.",
            "cannot-children": "Cannot delete — {n} child unit(s) must be moved or deleted first.",
            "cannot-roles": "Cannot delete — {n} role(s) are still linked to this unit.",
            "reassign": "Resolve the blockers above, then try again.",
            "confirm": "Delete unit"
          }
        },
        "define-levels-modal": {
          "title": "Define Levels",
          "subtitle": "Set up the company's hierarchy layers.",
          "layers-question": "How many layers does your hierarchy have?",
          "layers-label": "Number of layers",
          "layers-range": "Choose between 1 and 5 layers",
          "names-question": "Name each layer (up to {max})",
          "layer-name-required": "Layer {n} name",
          "layer-name-optional": "Layer {n} name (optional)",
          "live-preview": "Live preview",
          "preview-note": "This preview updates as you type — nothing is saved until you click Save.",
          "cancel": "Cancel",
          "save": "Save",
          "error-save": "Couldn't save the layer configuration. Please try again."
        }
      },
      "org-chart": {
        "subtitle": "Visualisation of your Org. Unit structure with people assigned",
        "export": "Export",
        "export-toast": "Org-chart PDF export — coming in a subsequent slice",
        "edit-lines": "Edit Reporting Lines",
        "info-banner": "shows the people hierarchy built from Reports-to relationships. Click any node to focus that sub-tree. Vacant positions appear under their resolved manager.",
        "canvas-title": "Org. Chart of Optimal P",
        "layer-1": "Layer 1",
        "status": {
          "active": "Active",
          "pending": "Pending",
          "probation": "Probation",
          "on-leave": "On leave",
          "inactive-vacant": "Inactive / Vacant"
        },
        "nav": {
          "title": "Role Navigation",
          "hint": "Toggle to expand · click to focus",
          "hide": "Hide navigation",
          "show": "Show navigation",
          "short": "Nav",
          "empty": "No matches"
        },
        "toolbar": {
          "show-vacancies": "Show vacancies",
          "default-view": "Default view (Level 1+2 visible, Level 3+ collapsed)",
          "expand-all": "Expand all branches",
          "collapse-all": "Collapse all branches",
          "zoom-out": "Zoom out",
          "zoom-in": "Zoom in",
          "zoom-fit": "Fit to 100%",
          "export": "Export",
          "reset-focus": "Reset focus",
          "back-to-root": "Back to root"
        },
        "search-placeholder": "Search name or role…",
        "chart": {
          "focus-reset": "Show full chart",
          "showing-focused": "Focused on {name} — showing ancestors + descendants only",
          "vacancy-pill": "Vacancy"
        },
        "drawer": {
          "title": "Employee profile",
          "section-contact": "Contact",
          "section-reporting": "Reporting line",
          "section-directs": "Direct reports",
          "section-meta": "Org info",
          "field-code": "Employee code",
          "field-title": "Title",
          "field-dept": "Department",
          "field-manager": "Reports to",
          "field-email": "Email",
          "field-phone": "Phone",
          "field-join": "Joined",
          "field-type": "Employment type",
          "field-breadcrumb": "Org breadcrumb",
          "no-directs": "No direct reports",
          "no-manager": "Top of company — no manager",
          "directs-more": "+{count} more"
        },
        "edit-modal": {
          "title": "Edit Reporting Lines",
          "lede": "Reassign an employee's manager. Submitting toasts a confirmation — the real backend wires up in a subsequent slice.",
          "employee-label": "Employee",
          "manager-label": "New manager",
          "employee-placeholder": "Select an employee…",
          "manager-placeholder": "Select a manager…",
          "submit": "Save reporting line",
          "cancel": "Cancel",
          "toast": "Reporting line for {employee} updated to report to {manager}"
        },
        "empty": {
          "title": "No employees in the org chart yet"
        }
      },
      "workforce-plan": {
        "title": "Workforce Plan",
        "subtitle": "{open} open positions · click Fill to start the Add Person wizard pre-selected",
        "banner": "<b>Position-first hiring.</b> Each Position is a unique seat. Positions sharing the same Job Title are grouped — click any group to expand. Off-plan creations are audit-logged.",
        "kpi": {
          "open-positions": "Open positions",
          "high-priority": "High priority",
          "filled-total": "Filled total",
          "off-plan": "Off-plan exceptions"
        },
        "budget": {
          "summary": "Org Unit headcount budget ({count} units)",
          "table": {
            "org-unit": "Org Unit",
            "filled": "Filled",
            "open": "Open",
            "total": "Total",
            "hc-budget": "HC Budget",
            "status": "Status"
          },
          "status": {
            "over-by": "Over by {n}",
            "at-cap": "At cap",
            "headroom": "{n} headroom"
          }
        },
        "table": {
          "showing": "Showing <b>{groups}</b> Job Title {label} · <b>{open}</b> open positions total",
          "groups-one": "group",
          "groups-many": "groups",
          "hint": "Grouped by Job Title · click to expand"
        },
        "group": {
          "summary-filled": "{filled} filled",
          "summary-open": "{open} open",
          "summary-high": "{high} High",
          "summary-specifiers": "specifiers: {names}",
          "bulk-fill": "Bulk Fill",
          "bulk-fill-title": "Open Add Person wizard for the first vacancy in this group"
        },
        "row": {
          "off-plan": "Off-plan",
          "optimal-internal": "Optimal Internal",
          "days-suffix": "({days}d)",
          "fill": "Fill"
        },
        "priority": {
          "low": "Low",
          "medium": "Medium",
          "high": "High",
          "urgent": "Urgent"
        },
        "empty": {
          "title": "All positions filled",
          "lede": "No open seats right now. Use <b>New Position</b> above to plan ahead."
        },
        "recently-filled": {
          "summary": "Recently filled ({count})",
          "table": {
            "position": "Position",
            "job-title": "Job title",
            "filled-by": "Filled by",
            "filled-on": "Filled on"
          }
        },
        "actions": {
          "new-position": "New Position",
          "fill-toast": "Add Person wizard pre-selected for {code} — coming next",
          "bulk-fill-toast": "Bulk Fill {group} — coming next",
          "created-toast": "Vacancy created · {title}"
        },
        "drawer": {
          "title": "Vacancy details",
          "fields": {
            "code": "Vacancy code",
            "title": "Job title",
            "grade": "Grade",
            "dept": "Department",
            "org-unit": "Org Unit",
            "approver": "Approver",
            "hiring-manager": "Hiring manager",
            "created": "Created",
            "target-start": "Target start",
            "candidates": "Candidates",
            "timeline": "Status timeline",
            "budget": "Budget",
            "activity": "Activity",
            "project": "Project",
            "filled-by": "Filled by",
            "filled-on": "Filled on"
          },
          "no-value": "—",
          "budget-line": "{amount} USD",
          "close": "Close"
        },
        "modal": {
          "title": "Create vacancy",
          "lede": "A vacancy reserves an approved seat for a planned hire.",
          "fields": {
            "title": "Title",
            "grade": "Grade",
            "dept": "Department",
            "org-unit": "Org Unit",
            "headcount": "Headcount",
            "justification": "Justification",
            "budget": "Annual budget (USD)"
          },
          "placeholders": {
            "title": "e.g. Senior Backend Engineer",
            "dept": "e.g. Engineering",
            "org-unit": "e.g. OU-ENG-PLATFORM",
            "headcount": "1",
            "justification": "Why this seat now? Headcount plan reference…",
            "budget": "0"
          },
          "validation": {
            "title-required": "Title is required",
            "dept-required": "Department is required",
            "org-unit-required": "Org Unit is required",
            "headcount-positive": "Headcount must be a positive whole number",
            "budget-non-negative": "Budget cannot be negative"
          },
          "cancel": "Cancel",
          "submit": "Create"
        }
      },
      "positions": {
        "title": "Positions",
        "subtitle": "Master register of every approved seat — open, filled, frozen, off-plan",
        "add-position": "New Position",
        "banner": {
          "body": "{position} is one unique seat (e.g. P0150 = the 1st Plant Operator slot on Acme Line A). {jobTitle} is the role template that can be referenced by many Positions. One Job Title → many Positions; one Position → at most one Employee.",
          "position-term": "Position",
          "job-title-term": "Job Title"
        },
        "actions": {
          "new-position": "New Position",
          "clear-filters": "Clear filters",
          "edit-toast": "Edit Position {id} — coming in a follow-up slice"
        },
        "kpi": {
          "all-positions": "All positions",
          "open-vacant": "Open (vacant)",
          "filled": "Filled",
          "off-plan": "Off-plan"
        },
        "chips": {
          "all": "All",
          "open": "Open",
          "filled": "Filled",
          "frozen": "Frozen",
          "offplan": "Off-plan",
          "cancelled": "Cancelled"
        },
        "filters": {
          "all-job-titles": "All Job Titles",
          "all-org-units": "All Org Units",
          "all-projects": "All Projects",
          "optimal-internal": "Optimal Internal"
        },
        "toggles": {
          "group-by-job-title": "Group by Job Title",
          "show-cancelled": "Show cancelled"
        },
        "priority": {
          "high": "High",
          "medium": "Medium",
          "low": "Low"
        },
        "search-placeholder": "Search by P-ID, title, employee…",
        "row": {
          "off-plan": "Off-plan",
          "edit-action": "Edit Position"
        },
        "table": {
          "showing": "Showing {filtered} of {total} positions",
          "click-hint": "Click any row to open the position details",
          "group-summary": "{count} positions · {filled} filled · {open} open",
          "position-id": "POSITION ID",
          "job-title": "JOB TITLE",
          "org-unit": "ORG UNIT",
          "specifiers": "SPECIFIERS",
          "project": "PROJECT",
          "grade": "GRADE",
          "status": "STATUS",
          "filled-by": "FILLED BY",
          "open-since": "OPEN SINCE",
          "edit": "EDIT"
        },
        "empty": {
          "title": "No positions match these filters",
          "lede": "Try clearing one or more filters to widen the search."
        },
        "drawer": {
          "fields": {
            "job-title": "Job Title",
            "org-unit": "Org Unit",
            "project": "Project",
            "open-since": "Open since",
            "specifiers": "Specifiers",
            "filled-by": "Filled by"
          },
          "no-value": "—",
          "foot-note": "Edit, fill or freeze actions arrive in a follow-up slice — this drawer is the read-only view for now."
        },
        "modal": {
          "title": "New Position",
          "lede": "A Position is a unique seat — its name is derived from Job Title + Specifiers (no free-text name needed).",
          "fields": {
            "job-title": "Job Title",
            "org-unit": "Org Unit",
            "project": "Project",
            "priority": "Priority"
          },
          "placeholders": {
            "job-title": "Pick a Job Title…",
            "org-unit": "e.g. Operations"
          },
          "validation": {
            "job-title-required": "Job Title is required",
            "org-unit-required": "Org Unit is required"
          },
          "cancel": "Cancel",
          "submit": "Create position",
          "created-toast": "Position created · {id}"
        }
      },
      "onboarding": {
        "title": "Onboarding",
        "subtitle": "Track readiness from accepted offer to probation completion — physical · documents · system · payroll · manager · probation.",
        "add-person": "Add Person",
        "add-toast": "Add-Person wizard — coming in a subsequent slice",
        "actions": {
          "start-onboarding": "Start Onboarding",
          "clear-filters": "Clear filters",
          "view": "View"
        },
        "banner": {
          "title": "Phase 1 · Record-only.",
          "body": "Onboarding tracks readiness — approvals happen offline. Task execution, notifications and integrations run in the owner modules (see link chips). Phase 2 adds workflow automation."
        },
        "kpi": {
          "new-hires": "New hires (30d)",
          "pending-docs": "Pending docs",
          "in-probation": "In probation",
          "probation-due": "Probation due",
          "new-joiners": "New Joiners",
          "preboarding": "Preboarding",
          "day1": "Day 1 Ready",
          "probation-window": "Probation Window",
          "attention": "Attention Needed",
          "open-view": "open this view →"
        },
        "sub-tabs": {
          "dashboard": "Dashboard",
          "new-joiners": "New Joiners",
          "preboarding": "Preboarding",
          "day1": "Day 1 Readiness",
          "probation": "Probation",
          "templates": "Templates",
          "reports": "Reports"
        },
        "dispatch": {
          "title": "Start Onboarding",
          "lede": "Pick the joiner whose onboarding you want to start.",
          "form-title": "Onboarding setup",
          "form-lede": "Confirm template, owner and start date — readiness tracking begins immediately.",
          "empty": "No eligible joiners. Create the person first with Add Person.",
          "fields": {
            "template": "Template",
            "owner": "Assigned owner",
            "start-date": "Start date"
          },
          "placeholders": {
            "template": "Select a template…",
            "owner": "e.g. Sokunthea Pen"
          },
          "errors": {
            "no-joiner": "Pick a joiner first",
            "template-required": "Template is required",
            "owner-required": "Owner is required",
            "start-date-required": "Start date is required"
          },
          "cancel": "Cancel",
          "back": "Back",
          "submit": "Start onboarding",
          "created-toast": "Onboarding started · {employee}"
        },
        "dashboard": {
          "toolbar": {
            "title": "Readiness Dashboard",
            "lede": "Track readiness from accepted offer to probation completion — physical · documents · system access · payroll · manager/team · probation."
          },
          "kpi": {
            "open-view": "open this view →"
          },
          "stages": {
            "draft": "Offer Accepted",
            "preboarding": "Preboarding",
            "day1": "Day 1 Activation",
            "active": "Orientation",
            "probation": "Probation",
            "completed": "Completed"
          },
          "journey": {
            "title": "Onboarding Journey"
          },
          "current": {
            "title": "Current Onboardings",
            "empty": "No active onboardings. Add people from the New Joiners tab."
          },
          "card": {
            "ready": "{pct}% ready",
            "starts-in": "in {days}d",
            "starts-today": "today",
            "started-ago": "{days}d ago"
          },
          "attention": {
            "title": "Attention Needed",
            "empty": "All clear — no readiness blockers right now."
          },
          "flags": {
            "contract": "Contract not signed",
            "bank": "Missing bank account",
            "laptop": "Laptop not assigned",
            "ess": "ESS invite not sent",
            "payroll": "Payroll setup pending",
            "probation": "Probation review due"
          },
          "owners": {
            "title": "Module Ownership — Onboarding monitors readiness; execution lives in the owner module",
            "people": "source of truth",
            "contract": "employment agreement record",
            "work": "task execution",
            "docs": "document storage",
            "asset": "issued company property",
            "hrops": "schedule / attendance setup",
            "payroll": "payroll readiness",
            "perf": "probation review / check-in",
            "people-name": "People Profile",
            "contract-name": "Contract",
            "work-name": "Work Mgmt",
            "docs-name": "Documents",
            "asset-name": "Asset",
            "hrops-name": "HR Ops",
            "payroll-name": "Payroll",
            "perf-name": "Performance"
          }
        },
        "new-joiners": {
          "toolbar": {
            "title": "New Joiners",
            "lede": "Only this tab starts onboarding. Use <strong>+ Add Person</strong> when the employee profile does not exist yet."
          },
          "fresh": {
            "title": "Fresh Employees",
            "lede": "Contract signed · not yet started work · onboarding not started",
            "empty": "No one in this group right now."
          },
          "catchup": {
            "title": "Catch-up Onboarding",
            "lede": "Already active or migrated employee · still inside probation · onboarding missing",
            "empty": "No one in this group right now."
          },
          "start": "Start",
          "cols": {
            "joined": "Start / Joined",
            "probation-end": "Probation End",
            "contract": "Contract",
            "reason": "Reason"
          },
          "drawer": {
            "title": "Title",
            "dept": "Department",
            "joined": "Start date",
            "contract": "Contract type",
            "client": "Client / Project",
            "reason": "Reason"
          }
        },
        "preboarding": {
          "toolbar": {
            "title": "Preboarding",
            "lede": "Everything that must be ready <strong>before</strong> Day 1 — readiness matrix by group. Click a row to open the full checklist."
          },
          "cols": {
            "employee": "Employee",
            "start": "Start",
            "profile": "Profile",
            "contract": "Contract",
            "physical": "Physical",
            "system": "System",
            "payroll": "Payroll",
            "manager": "Manager",
            "probation": "Probation",
            "overall": "OVERALL"
          },
          "empty": {
            "title": "No one in preboarding."
          },
          "drawer": {
            "role": "Role",
            "dept": "Department",
            "start": "Start date",
            "progress": "Progress",
            "owner": "Assigned owner",
            "probation-end": "Probation end",
            "notes": "Notes"
          }
        },
        "day1": {
          "search-placeholder": "Search Day-1 records…",
          "chips": {
            "all": "All",
            "ready": "Ready",
            "not-ready": "Not Ready",
            "activated": "Activated"
          },
          "cols": {
            "employee": "Employee",
            "role": "Role",
            "start": "Start",
            "gates": "Gates",
            "owner": "Owner",
            "status": "Status"
          },
          "gates": {
            "contract": "Contract signed & stored",
            "physical": "Workspace · equipment · access card",
            "system": "ESS · email · attendance · schedule",
            "manager": "Manager · buddy · Day 1 plan"
          },
          "showing": "Showing {filtered} of {total} Day-1 records",
          "empty": {
            "title": "No Day 1 candidates yet — add joiners from the New Joiners tab.",
            "lede": "Clear the active filters or widen your search."
          },
          "drawer": {
            "gates-title": "Day-1 Gates",
            "start": "Start date",
            "owner": "Owner",
            "notes": "Notes"
          },
          "starts": "Starts",
          "toolbar": {
            "title": "Day 1 Readiness",
            "lede": "Candidates approaching Day 1 — each shows the four readiness gates plus the activation CTA."
          },
          "status": {
            "ready": "READY",
            "not-ready": "NOT READY"
          },
          "activate": "Activate · Day 1 Done"
        },
        "probation": {
          "search-placeholder": "Search probation records…",
          "chips": {
            "all": "All",
            "in-probation": "In Probation",
            "due-soon": "Due ≤14d",
            "confirmed": "Confirmed"
          },
          "cols": {
            "employee": "Employee",
            "role": "Role",
            "start": "Start",
            "probation-end": "Probation End",
            "days-left": "Days Left",
            "owner": "Owner",
            "status": "Status",
            "role-client": "Role · Client",
            "case": "Case",
            "days": "Days",
            "cycle-stage": "Cycle Stage",
            "lm-recommendation": "LM Recommendation",
            "lm-recommendation-tooltip": "The Line Manager's recommendation from their review — status only, not an action",
            "action": "Action"
          },
          "showing": "Showing {filtered} of {total} probation records",
          "empty": {
            "title": "No probation records",
            "lede": "Clear the active filters or widen your search."
          },
          "drawer": {
            "role": "Role",
            "dept": "Department",
            "start": "Start date",
            "probation-end": "Probation end",
            "owner": "Owner",
            "confirmed": "Confirmed",
            "yes": "Yes",
            "no": "No",
            "notes": "Notes",
            "client": "Client"
          },
          "toolbar": {
            "title": "Probation Review & Confirmation",
            "lede": "LM review → employee acknowledgement → HR confirmation. Pass auto-confirms; HR finalises the Contract Event (Case A new contract · Case B confirmation + optional salary change)."
          },
          "banner": {
            "title": "Cambodia probation rule (ER-1).",
            "body": "Case A (separate Probation Contract) → pass = Contract Conversion (new UDC/FDC). Case B (UDC/FDC with probation clause) → pass = Probation Confirmation milestone + Salary Adjustment if pay changes. Completion requires the review chain — never date alone."
          },
          "case-label": "Case {c}",
          "midway": "MID-WAY",
          "days": {
            "in": "{n} days",
            "today": "today",
            "overdue": "{n} overdue"
          },
          "stage": {
            "pending": "Pending",
            "lm-review": "LM Review",
            "employee-ack": "Employee Ack",
            "hr-confirm": "HR Confirm",
            "confirmed": "Confirmed"
          },
          "action": {
            "confirm": "Confirm & Record",
            "nudge": "Nudge LM",
            "await-employee": "Awaiting employee"
          }
        },
        "templates": {
          "search-placeholder": "Search templates…",
          "chips": {
            "all": "All",
            "active": "Active",
            "archived": "Archived"
          },
          "status": {
            "active": "Active",
            "archived": "Archived"
          },
          "cols": {
            "id": "Code",
            "name": "Template",
            "category": "Category",
            "tasks": "Tasks (req.)",
            "duration": "Duration",
            "updated": "Updated",
            "status": "Status"
          },
          "showing": "Showing {filtered} of {total} templates",
          "empty": {
            "title": "No templates match",
            "lede": "Clear the active filters or widen your search."
          },
          "drawer": {
            "tasks": "Tasks",
            "mandatory": "Mandatory",
            "duration": "Duration",
            "updated": "Last updated",
            "owner": "Owner role",
            "notes": "Notes"
          },
          "toolbar": {
            "title": "Onboarding Templates",
            "lede": "Readiness checklists by workforce type + role — applied by the Start Onboarding wizard."
          },
          "new": "New Template",
          "scope": {
            "direct": "Direct",
            "outsourced": "Outsourced"
          },
          "meta": {
            "tasks": "Tasks (req.)",
            "duration": "Duration",
            "owner": "Owner",
            "updated": "Updated",
            "days": "{n}d"
          },
          "using": "{n} records using this",
          "view-edit": "View / Edit"
        },
        "reports": {
          "search-placeholder": "Search reports…",
          "chips": {
            "all": "All",
            "on-track": "On Track",
            "at-risk": "At Risk",
            "behind": "Behind"
          },
          "cols": {
            "period": "Period",
            "dept": "Department",
            "joiners": "Joiners",
            "completed": "Completed",
            "avg-days": "Avg Days",
            "rate": "Confirm Rate",
            "owner": "Owner",
            "status": "Status"
          },
          "showing": "Showing {filtered} of {total} reports",
          "empty": {
            "title": "No reports match",
            "lede": "Clear the active filters or widen your search."
          },
          "drawer": {
            "joiners": "Joiners",
            "completed": "Completed",
            "avg-days": "Avg days to ready",
            "rate": "Probation confirm rate",
            "owner": "Owner"
          },
          "view": {
            "insights": "Insights",
            "completion": "Detail Report"
          },
          "toolbar": {
            "title": "Onboarding Insights",
            "lede": "Live HR analytics across all onboarding records."
          },
          "kpi": {
            "active": "Active Onboardings",
            "active-sub": "{midway} mid-way · {cancelled} cancelled",
            "soon": "Starting ≤ 7 days",
            "soon-sub": "need to be ready",
            "readiness": "Avg Readiness",
            "readiness-sub": "{done} of {total} items",
            "ttd": "Avg Time-to-Deploy",
            "ttd-sub": "record created → start",
            "attention": "Attention Needed",
            "attention-sub": "records with blockers"
          },
          "funnel": {
            "title": "Pipeline Funnel",
            "preboarding": "Preboarding",
            "day1": "Day 1 Ready",
            "active": "Active",
            "probation": "In Probation",
            "completed": "Completed"
          },
          "groups": {
            "title": "Readiness by Group",
            "lede": "Lowest completion shows where onboardings stall.",
            "contract": "Contract",
            "physical": "Physical / Workspace",
            "system": "System Access",
            "payroll": "Payroll",
            "probation": "Probation"
          },
          "blockers": {
            "title": "Top Blockers",
            "empty": "No blockers across active onboardings."
          },
          "dim": {
            "workforce": "Workforce",
            "client": "Client",
            "dept": "Department",
            "category": "Cohort",
            "midway-cohort": "Mid-way",
            "fresh-cohort": "Fresh"
          },
          "breakdown": {
            "title": "Distribution by {dim}"
          },
          "cycle": {
            "title": "Probation Review Cycle",
            "lm": "LM Review",
            "ack": "Employee Ack",
            "confirm": "HR Confirm",
            "overdue": "{n} past probation end — review overdue",
            "no-overdue": "No overdue probation reviews"
          },
          "outcomes": {
            "title": "Outcomes",
            "completed": "Completed (probation confirmed)",
            "pass-rate": "Probation pass rate",
            "midway": "Mid-way (partial) onboardings",
            "cancelled": "Cancelled (incl. probation fail)",
            "avg-ttd": "Avg time-to-deploy",
            "days": "{n} days"
          },
          "completion": {
            "title": "Detail Report",
            "lede": "Cohort breakdown by pipeline stage — anchor on start/join date."
          },
          "flags": {
            "contract": "Contract unsigned",
            "bank": "Bank not set up",
            "laptop": "Laptop not issued",
            "ess": "ESS not invited",
            "payroll": "Payroll not ready"
          }
        },
        "stub": {
          "title": "Onboarding",
          "lede": "Multi-view dashboard (Dashboard / New Hires / Probation) with per-stage checklist progress, document-pending flags, and probation-review reminders. Phase B wires to `recruitment/`."
        }
      },
      "offboarding": {
        "title": "Offboarding",
        "subtitle": "Resignation → Clearance → Final Pay → Exit interview — one control tower for every leaving event.",
        "actions": {
          "start": "Start Offboarding",
          "clear-filters": "Clear filters",
          "view": "View"
        },
        "banner": {
          "title": "Leaving Center is the control tower.",
          "body": "Every departure — from any source — arrives here first and moves through one status track: New → Under Review → Eligible → In Progress → Completed."
        },
        "kpi": {
          "leaving-30d": "Leaving (30d)",
          "asset-recovery": "Asset recovery pending",
          "exit-pending": "Exit interviews pending",
          "final-pay-queue": "Final settlement queue",
          "turnover": "Voluntary turnover %",
          "in-progress": "In progress",
          "final-pay": "Final pay pending",
          "exit-interviews": "Exit interviews",
          "completed": "Completed (YTD)"
        },
        "sub-tabs": {
          "overview": "Overview",
          "center": "Leaving Center",
          "eligible": "Leaver Eligibility",
          "process": "Offboarding Process",
          "templates": "Templates",
          "reports": "Reports"
        },
        "dispatch": {
          "title": "Start Offboarding",
          "lede": "Capture the leaving event — it lands in the Leaving Center for review.",
          "fields": {
            "employee": "Employee",
            "reason": "Reason",
            "last-day": "Last working day",
            "notice": "Notice handling",
            "source": "Source"
          },
          "placeholders": {
            "employee": "Pick an employee…",
            "reason": "e.g. Relocating, better offer, contract end…",
            "source": "Select source…"
          },
          "notice-options": {
            "served": "Serve full notice",
            "garden": "Garden leave",
            "buyout": "Buy out notice",
            "waived": "Notice waived"
          },
          "errors": {
            "employee-required": "Pick an employee",
            "reason-required": "Reason is required",
            "last-day-required": "Last working day is required",
            "source-required": "Source is required"
          },
          "cancel": "Cancel",
          "submit": "Create event",
          "created-toast": "Leaving event created · {employee} — landed in Leaving Center"
        },
        "overview": {
          "toolbar-btn": "Leaving Center",
          "kpi": {
            "intake": "New & Under Review",
            "intake-sub": "intake to assess",
            "eligible": "Eligible to Start",
            "eligible-sub": "ready to offboard",
            "in-progress": "Offboarding In Progress",
            "in-progress-sub": "executing",
            "overdue": "Overdue Actions",
            "overdue-sub": "cases need attention"
          },
          "upcoming": {
            "title": "Upcoming Last Day",
            "empty": "Nothing scheduled.",
            "cols": {
              "employee": "Employee",
              "leaving-reason": "Leaving Reason",
              "last-working-day": "Last Working Day",
              "current-stage": "Current Stage",
              "attention-required": "Attention Required"
            }
          },
          "recent": {
            "title": "Recent Activity",
            "empty": "No recent activity."
          }
        },
        "center": {
          "search-placeholder": "Search leavers…",
          "chips": {
            "all": "All",
            "new": "New",
            "under_review": "Under Review",
            "eligible": "Eligible",
            "in_progress": "In Progress",
            "completed": "Completed",
            "cancelled": "Cancelled"
          },
          "cols": {
            "employee": "Employee",
            "source": "Source",
            "reason": "Reason",
            "last-day": "Last Day",
            "progress": "Progress",
            "owner": "Owner",
            "status": "Status",
            "action": "Action"
          },
          "actions": {
            "review": "Review",
            "eligible": "Mark Eligible",
            "start": "Start",
            "open": "Open",
            "view": "View"
          },
          "action-toasts": {
            "review": "{employee} moved to Under Review",
            "eligible": "{employee} marked Eligible",
            "start": "Offboarding started · {employee}",
            "open": "Opening {employee}'s case",
            "view": "Viewing {employee}'s case"
          },
          "showing": "Showing {filtered} of {total} leaving events",
          "empty": {
            "title": "No leaving events match",
            "lede": "Clear the active filters or widen your search."
          },
          "drawer": {
            "role": "Role",
            "dept": "Department",
            "client": "Client",
            "source": "Source",
            "reason": "Reason",
            "notice-date": "Notice date",
            "last-day": "Last working day",
            "owner": "Owner",
            "progress": "Progress",
            "status": "Status",
            "notes": "Notes",
            "attention": "Attention"
          }
        },
        "eligible": {
          "search-placeholder": "Search eligible leavers…",
          "chips": {
            "all": "All",
            "voluntary": "Voluntary",
            "involuntary": "Involuntary",
            "due-soon": "Last day ≤ 14d"
          },
          "cols": {
            "employee": "Employee",
            "source": "Source",
            "reason": "Reason",
            "last-day": "Last working day",
            "eligible-since": "Eligible since",
            "action": "Action"
          },
          "showing": "Showing {filtered} of {total} eligible",
          "empty": {
            "title": "No one is eligible right now",
            "lede": "Events become Eligible after HR review in Leaving Center."
          },
          "drawer": {
            "role": "Role",
            "dept": "Department",
            "client": "Client",
            "reason": "Reason",
            "last-day": "Last working day",
            "eligible-since": "Eligible since",
            "owner": "Owner",
            "notes": "Notes"
          },
          "start-button": "Start",
          "started-toast": "Offboarding started · {employee} — moved to In Progress",
          "in-days": "in {n}d",
          "today": "today",
          "days-ago": "{n}d ago"
        },
        "process": {
          "search-placeholder": "Search in-progress cases…",
          "chips": {
            "all": "All",
            "active": "In Progress",
            "completed": "Completed",
            "needs-attention": "Needs Attention"
          },
          "cols": {
            "employee": "Employee",
            "source": "Source",
            "last-day": "Last Day",
            "progress": "Progress",
            "owner": "Owner",
            "attention": "Attention",
            "status": "Status"
          },
          "showing": "Showing {filtered} of {total} cases",
          "empty": {
            "title": "No cases in this view",
            "lede": "Start one from Leaver Eligibility."
          },
          "drawer": {
            "role": "Role",
            "dept": "Department",
            "client": "Client",
            "source": "Source",
            "reason": "Reason",
            "last-day": "Last working day",
            "owner": "Owner",
            "progress": "Progress",
            "status": "Status",
            "attention": "Attention",
            "notes": "Notes"
          }
        },
        "templates": {
          "search-placeholder": "Search templates…",
          "chips": {
            "all": "All",
            "active": "Active",
            "inactive": "Inactive",
            "direct": "Direct",
            "outsourced": "Outsourced"
          },
          "cols": {
            "name": "Template",
            "workforce": "Workforce",
            "role-type": "Role type",
            "handover": "Handover",
            "clearance": "Clearance",
            "lastday": "Last day",
            "exit": "Exit",
            "last-used": "Last used",
            "usage": "Usage",
            "status": "Status"
          },
          "showing": "Showing {filtered} of {total} templates",
          "empty": {
            "title": "No templates match",
            "lede": "Clear filters or widen your search."
          },
          "exit-required": "Required",
          "exit-optional": "Optional",
          "drawer": {
            "name": "Template name",
            "workforce": "Workforce",
            "role-type": "Role type",
            "handover": "Handover items",
            "clearance": "Clearance items",
            "lastday": "Last day items",
            "exit": "Exit interview",
            "last-used": "Last used",
            "usage": "Times used",
            "status": "Status"
          }
        },
        "assets": {
          "search-placeholder": "Search assets…",
          "title": "Asset Recovery",
          "lede": "Track laptops, phones, access cards and uniforms as leavers return them.",
          "chips": {
            "all": "All",
            "pending": "Pending",
            "received": "Received",
            "damaged": "Damaged",
            "lost": "Lost"
          },
          "cols": {
            "employee": "Employee",
            "item": "Item",
            "serial": "Serial",
            "condition": "Condition",
            "status": "Status",
            "due": "Due date",
            "received-by": "Received by"
          },
          "showing": "Showing {filtered} of {total} assets",
          "empty": {
            "title": "No assets match",
            "lede": "Clear filters or widen your search."
          },
          "drawer": {
            "employee": "Employee",
            "item": "Item",
            "serial": "Serial",
            "condition": "Condition",
            "status": "Status",
            "due": "Due date",
            "received-by": "Received by",
            "notes": "Notes"
          },
          "condition": {
            "new": "New",
            "good": "Good",
            "fair": "Fair",
            "damaged": "Damaged",
            "unknown": "Unknown"
          }
        },
        "settlement": {
          "search-placeholder": "Search settlements…",
          "title": "Final Settlement",
          "lede": "Snapshot of final pay calculation — base, accrued leave, unpaid days, severance, deductions.",
          "chips": {
            "all": "All",
            "not_created": "Not Created",
            "created": "Drafted",
            "processing": "Processing",
            "paid": "Paid",
            "disputed": "Disputed"
          },
          "cols": {
            "employee": "Employee",
            "last-day": "Last day",
            "base": "Base pay",
            "accrued": "Accrued leave",
            "unpaid": "Unpaid days",
            "severance": "Severance",
            "deductions": "Deductions",
            "total": "Total",
            "status": "Status"
          },
          "showing": "Showing {filtered} of {total} settlements",
          "empty": {
            "title": "No settlements match",
            "lede": "Clear filters or widen your search."
          },
          "drawer": {
            "employee": "Employee",
            "last-day": "Last working day",
            "base": "Base pay",
            "accrued": "Accrued leave",
            "unpaid": "Unpaid days",
            "severance": "Severance",
            "deductions": "Deductions",
            "total": "Total",
            "currency": "Currency",
            "prepared-by": "Prepared by",
            "status": "Status",
            "notes": "Notes"
          }
        },
        "source": {
          "ess_resignation": "ESS Resignation",
          "contract_end": "Contract end",
          "probation_fail": "Probation fail",
          "retirement": "Retirement",
          "termination": "Termination",
          "death": "In-service death"
        },
        "status": {
          "new": "New",
          "under_review": "Under Review",
          "eligible": "Eligible",
          "in_progress": "In Progress",
          "completed": "Completed",
          "cancelled": "Cancelled"
        },
        "final-pay": {
          "not_created": "Not created",
          "created": "Drafted",
          "processing": "Processing",
          "paid": "Paid",
          "disputed": "Disputed"
        },
        "reports": {
          "title": "Reports",
          "lede": "Turnover analytics — by reason, source, tenure, department, voluntary vs involuntary.",
          "kpi": {
            "total": "Total events",
            "voluntary": "Voluntary",
            "involuntary": "Involuntary",
            "turnover": "Turnover %",
            "rehire": "Rehire-eligible",
            "clearance-sla": "Clearance SLA",
            "final-pay-sla": "Final pay SLA"
          },
          "by-source": "By source",
          "by-reason": "By reason",
          "by-tenure": "By tenure",
          "by-dept": "By department",
          "voluntary-split": "Voluntary vs Involuntary"
        },
        "stub": {
          "title": "Offboarding",
          "lede": "Operational leaving execution with workstream tracking (Resignation · Clearance · Final Pay · Exit interview)."
        }
      },
      "compliance": {
        "title": "Compliance",
        "subtitle": "Cambodian statutory + operational compliance · tier-1 hard deadlines (MOL, NSSF, GDT) and tier-2 operational filings, with a per-category audit trail.",
        "info-banner": {
          "title": "Compliance scope",
          "body": "Tracks every employer obligation Cambodian law imposes — MOL declarations, NSSF + salary-tax filings, foreign-worker permits/visas, foreign-worker quota, health check-ups, IWR, labour book, fire-safety and workmen's-comp. Deadlines are tenant-configurable in Compliance Settings."
        },
        "scores": {
          "healthy": "Healthy",
          "attention": "Attention needed",
          "critical": "Critical"
        },
        "kpi": {
          "score": "Compliance Score",
          "score-sub": "Across {cats} categories · {items} tracked items",
          "overdue-expiring": "Overdue / Expiring",
          "overdue-expiring-sub": "{overdue} overdue · {expiring} expiring soon",
          "pending-action": "Pending Action",
          "pending-action-clear": "All clear",
          "pending-action-open": "Open declarations + filings"
        },
        "sidebar": {
          "overview": "Overview",
          "tier1": "Tier 1 — hard deadlines",
          "tier2": "Tier 2 — operational",
          "settings": "Settings"
        },
        "categories": {
          "mol-decl": {
            "label": "MOL Declarations",
            "description": "New-hire and separation declarations to Ministry of Labour. Default deadline 15 working days."
          },
          "nssf": {
            "label": "NSSF Contributions",
            "description": "Monthly social security contributions. Default due by day 15 of following month."
          },
          "tax": {
            "label": "Salary Tax (TOS)",
            "description": "Monthly Tax on Salary declaration to General Department of Taxation. Default due by day 20."
          },
          "work-permit": {
            "label": "Work Permits",
            "description": "Annual work permits for foreign employees. Renewal warning 60 days before expiry."
          },
          "visa": {
            "label": "Visa Renewals (Business E)",
            "description": "Annual Business E visa renewals for foreign employees."
          },
          "quota": {
            "label": "Foreign Worker Quota",
            "description": "Annual quota request for foreign workforce. Cap: foreigners ≤ 10% of total (configurable)."
          },
          "health": {
            "label": "Health Check-ups",
            "description": "Annual mandatory medical examinations. Tracked per employee."
          },
          "iwr": {
            "label": "Internal Work Regulations",
            "description": "Required for companies with ≥ 8 employees. Filed with MOL on policy change."
          },
          "labour-book": {
            "label": "Labour Book",
            "description": "Employee registry and hours log. Monthly export available for MOL inspection."
          },
          "fire-safety": {
            "label": "Fire Safety Certificate",
            "description": "Workplace fire safety inspection and certificate. Annual renewal."
          },
          "workmen-comp": {
            "label": "Workmen's Compensation",
            "description": "NSSF Occupational Risk Insurance registration."
          }
        },
        "filters": {
          "all": "All",
          "ok": "OK",
          "pending": "Pending",
          "submitted": "Submitted",
          "approved": "Approved",
          "overdue": "Overdue",
          "expiring-soon": "Expiring Soon"
        },
        "status": {
          "OK": "OK",
          "Pending": "Pending",
          "Submitted": "Submitted",
          "Approved": "Approved",
          "Overdue": "Overdue",
          "Expiring Soon": "Expiring Soon",
          "N/A": "N/A"
        },
        "actions": {
          "clear-filters": "Clear filters",
          "view": "View",
          "action": "Action →",
          "new-item": "New item"
        },
        "search-placeholder": "Search ID, subject, period, details…",
        "days": {
          "overdue": "{n}d overdue",
          "today": "today",
          "in": "in {n}d"
        },
        "action-items": {
          "title": "Action items",
          "lede": "Sorted by urgency. Click any row to open its category.",
          "count": "{n} items needing action",
          "empty": "No urgent items — you're all clear ✓"
        },
        "grid": {
          "all-categories": "All categories",
          "click-hint": "Click any card to drill in",
          "healthy": "{n}% healthy",
          "items": "{n} items",
          "overdue": "{n} overdue"
        },
        "detail": {
          "authority": "Authority",
          "cadence": "Cadence",
          "tier": "Tier",
          "tier-1": "1 (hard deadlines)",
          "tier-2": "2 (operational)",
          "score": "Score",
          "settings": "Settings",
          "config-footnote": "Defaults shown above are tenant-configurable in Compliance Settings — e.g., MOL declaration deadline {mol} working days (hire), NSSF day {nssf}, TOS day {tax}."
        },
        "table": {
          "tracked": "Tracked items ({n})",
          "overdue": "{n} overdue",
          "pending": "{n} pending",
          "expiring": "{n} expiring soon",
          "col": {
            "id": "ID",
            "subject": "Subject / Detail",
            "due": "Due",
            "days": "Days",
            "status": "Status",
            "action": "Action"
          }
        },
        "quota": {
          "title": "Current foreign workforce ratio",
          "within": "Within MOL {cap}% cap",
          "over": "OVER MOL {cap}% cap"
        },
        "foreign": {
          "title": "Foreign employees on record ({n})",
          "col": {
            "code": "Code",
            "name": "Name",
            "nationality": "Nationality",
            "position": "Position",
            "joined": "Joined"
          }
        },
        "empty": {
          "title": "No matches",
          "lede": "No items match these filters. Try clearing one to widen the search."
        },
        "drawer": {
          "fields": {
            "due": "Due",
            "days": "Days remaining",
            "employee": "Employee",
            "details": "Details",
            "audit": "Audit trail"
          },
          "no-audit": "No audit events recorded yet."
        },
        "settings-placeholder": "Compliance Settings — placeholder · editable defaults coming with Settings build"
      },
      "directory": {
        "subtitle": "No employees | {n} employee | {n} employees",
        "subtitle-empty": "No employees found",
        "add-person-cta": "Add Person",
        "add-person": {
          "wizard": {
            "title": {
              "employee": "Add direct employee",
              "outsourced": "Add outsourced employee",
              "vendor-lite": "Add vendor-lite record",
              "external": "Invite external approver"
            },
            "subtitle": {
              "employee": "Hire onto your own payroll — full HR record + contract.",
              "outsourced": "Staff you employ for client deployment — full payroll + statutory.",
              "vendor-lite": "Track a worker supplied by a vendor — no payroll on our side.",
              "external": "Limited access — approves requests for staff on one project only."
            },
            "kind": {
              "label": "Person kind",
              "employee": "Direct employee",
              "outsourced": "Outsourced (we run payroll)",
              "vendor-lite": "Vendor-lite (vendor runs payroll)",
              "external": "External approver"
            },
            "offer": {
              "title": "Start from an Offer Letter",
              "body": "Pull a signed offer's data straight in — fewer typos, no rekeying. The Offers surface is coming with the Recruiting module.",
              "cta": "Browse offers",
              "coming-soon": "Offer-letter picker — coming with Recruiting."
            },
            "stepper": {
              "aria": "Add Person wizard progress"
            },
            "steps": {
              "person": "Person",
              "schedule": "Schedule",
              "contract": "Contract",
              "leave": "Leave",
              "project-access": "Project access",
              "vendor": "Vendor",
              "review": "Review"
            },
            "person": {
              "heading": "Person details",
              "code": "Employee code",
              "code-hint": "Auto-generated. You can override before saving.",
              "code-hint-external": "Client-staff code — auto-generated for cross-tenant reference.",
              "name-latin": "Full name (Latin)",
              "name-latin-placeholder": "e.g. Sok Pisey",
              "name-khmer": "Full name (Khmer)",
              "gender": {
                "label": "Gender",
                "female": "Female",
                "male": "Male",
                "other": "Other"
              },
              "dob": "Date of birth",
              "nid": "National ID / Passport",
              "nid-placeholder": "e.g. 012345678",
              "title-at-client": "Title at client",
              "title-placeholder": "e.g. Site Supervisor",
              "email": "Work email",
              "email-placeholder": "you\\@company.com",
              "email-client": "Client email",
              "email-client-placeholder": "approver\\@client.com",
              "phone": "Work phone",
              "vendor-lite-badge": "Vendor-lite governance",
              "vendor-lite-help": "We will not store statutory IDs or salary for this person — the vendor owns those records.",
              "help-employee": "Direct employees show up everywhere — Directory, Payroll, Leave, Time & Attendance.",
              "help-outsourced": "Outsourced staff show up in the Directory and Outsourced tab. Payroll and statutory entitlements behave like Direct.",
              "help-external": "External approvers can only see + approve requests for staff on the project you assign on the next step."
            },
            "schedule": {
              "heading": "Schedule template",
              "template": "Template",
              "template-hint": "Drives clock-in window, weekly hours, and OT eligibility.",
              "placeholder": "Pick a schedule template",
              "details": "Schedule details",
              "type": "Type",
              "loading": "Loading schedules…",
              "error": "Couldn't load schedules.",
              "retry": "Retry",
              "empty": "No work schedules defined for this company yet."
            },
            "contract": {
              "heading": "Contract",
              "type": "Contract type",
              "vacancy": "Vacancy",
              "vacancy-hint": "Position-first hiring — pick from the open requisitions list. New roles must be opened via Workforce Plan.",
              "vacancy-placeholder": "Pick an open vacancy",
              "start-date": "Start date",
              "end-date": "End date",
              "with-probation": "Include probation period",
              "probation-end-date": "Probation end date",
              "vacancy-loading": "Loading open positions…",
              "vacancy-error": "Couldn't load open positions.",
              "vacancy-retry": "Retry",
              "vacancy-empty": "No open positions for this company. Open a role in Workforce Plan first."
            },
            "leave": {
              "heading": "Leave policy",
              "policy": "Leave policy",
              "policy-hint": "Sets the annual + sick entitlement and accrual cadence.",
              "placeholder": "Pick a leave policy",
              "vendor-title": "Vendor owns leave entitlement",
              "vendor-body": "Leave for vendor-lite records is governed by {vendor}. We only mirror operational time-off requests for site visibility.",
              "vendor-fallback": "the vendor",
              "company-title": "Company leave policy applies",
              "company-body": "This hire inherits the company's standard leave entitlement and accrual cadence. Use the override below only for an individually negotiated entitlement.",
              "override-toggle": "Override the standard entitlement for this hire",
              "override-annual": "Annual leave (days/year)",
              "override-sick": "Sick leave (days/year)",
              "override-justification": "Justification",
              "override-justification-placeholder": "Why this hire gets a non-standard entitlement"
            },
            "project": {
              "heading": "Project access",
              "project": "Project",
              "project-hint": "External approvers can only see requests for staff deployed on this project.",
              "placeholder": "Pick a project",
              "their-project": "their project",
              "can-do-title": "Can do",
              "can-do-1": "Approve / reject leave & expense requests for staff on {project}",
              "can-do-2": "View attendance summaries for the project",
              "can-do-3": "Receive notifications for pending approvals",
              "cannot-do-title": "Cannot do",
              "cannot-do-1": "View payroll, salary, or statutory data",
              "cannot-do-2": "Edit employee records",
              "cannot-do-3": "Access other projects or the Directory"
            },
            "vendor": {
              "heading": "Vendor / provider",
              "name": "Vendor name",
              "name-hint": "Used on attendance reports, vendor invoices, and the Outsourced tab.",
              "placeholder": "e.g. ManpowerKH Co. Ltd.",
              "governance-title": "Vendor-lite governance",
              "governance-body": "The vendor is responsible for salary, statutory contributions, and leave entitlement. We track this person operationally only — no payroll runs against them."
            },
            "review": {
              "heading": "Review and create",
              "heading-external": "Review and invite",
              "section-person": "Person",
              "section-schedule": "Schedule",
              "section-contract": "Contract",
              "section-leave": "Leave",
              "section-vendor": "Vendor",
              "section-project": "Project access",
              "code": "Code",
              "name": "Name",
              "gender": "Gender",
              "dob": "Date of birth",
              "nid": "National ID",
              "email": "Email",
              "phone": "Phone",
              "schedule": "Schedule",
              "contract-type": "Contract type",
              "vacancy": "Vacancy",
              "start-date": "Start date",
              "end-date": "End date",
              "leave-policy": "Leave policy",
              "vendor": "Vendor",
              "project": "Project",
              "edit": "Edit",
              "footer": "Pressing Create writes this person to the directory and generates onboarding tasks. You can edit details from the profile afterwards.",
              "footer-external": "Pressing Invite emails the approver a sign-in link. They never see payroll or other projects.",
              "leave-company-default": "Company default policy",
              "leave-annual": "Annual override (days)",
              "leave-sick": "Sick override (days)"
            },
            "footer": {
              "cancel": "Cancel",
              "back": "Back",
              "next": "Save & continue",
              "create-employee": "Create employee",
              "create-vendor": "Create record",
              "create-external": "Send invite",
              "step-of": "Step {n} of {total}"
            },
            "toast": {
              "created": "Person created. The directory will refresh shortly.",
              "endpoint-pending": "Create-person endpoint is still being wired on the backend. Your inputs are preserved — retry once the BE lands."
            }
          }
        },
        "filters": {
          "all": "All",
          "active": "Active",
          "direct": "Direct",
          "outsourced": "External Staff",
          "onboarding": "Onboarding",
          "probation": "On Probation",
          "pending": "Pending",
          "on_leave": "On leave",
          "resigning": "Resigning",
          "leaving": "Leaving",
          "inactive": "Inactive",
          "client_staff": "External Staff"
        },
        "emp-type": {
          "label": "Type: All",
          "all": "Type: All",
          "Full-time": "Full-time",
          "Part-time": "Part-time"
        },
        "contract": {
          "label": "Contract: All",
          "all": "Contract: All",
          "UDC": "UDC (Undetermined Duration)",
          "FDC": "FDC (Fixed Duration)"
        },
        "search-placeholder": "Search name, code, email…",
        "columns": "Columns",
        "export": "Export",
        "import": "Import",
        "sort-by": "Sort by {column}",
        "table": {
          "employee": "Employee",
          "empCode": "Employee Code",
          "nameLatin": "Full Name (Latin)",
          "nameKhmer": "Full Name (Khmer)",
          "gender": "Gender",
          "dob": "Date of Birth",
          "nid": "National ID / Passport",
          "familyNameLatin": "Family Name (Latin)",
          "middleNameLatin": "Middle Name (Latin)",
          "givenNameLatin": "Given Name (Latin)",
          "nicknameLatin": "Nickname (Latin)",
          "familyNameNative": "Family Name (Khmer)",
          "middleNameNative": "Middle Name (Khmer)",
          "givenNameNative": "Given Name (Khmer)",
          "nicknameNative": "Nickname (Khmer)",
          "countryOfBirth": "Country of Birth",
          "cityProvinceOfBirth": "City/Province of Birth",
          "maritalStatus": "Marital Status",
          "nationality": "Nationality",
          "spouseName": "Spouse's Name",
          "numChildren": "No. of Children",
          "personalPhone": "Personal Phone",
          "personalEmail": "Personal Email",
          "homeAddress": "Home Address",
          "email": "Work Email",
          "phone": "Work Phone",
          "status": "Employment Status",
          "type": "Workforce Type",
          "position": "Position / Job Title",
          "department": "Department",
          "empType": "Employment Type",
          "joined": "Hire Date",
          "contract": "Contract Type",
          "contractStartDate": "Contract Start Date",
          "contractEndDate": "Contract End Date",
          "onProbation": "On Probation",
          "probationEndDate": "Probation End Date",
          "schedule": "Work Schedule",
          "weeklyHours": "Weekly Hours",
          "availableAl": "Available Annual Leave",
          "project": "Project / Client",
          "salary": "Basic Salary",
          "costCenters": "Cost Center(s)",
          "bank": "Bank",
          "account": "Account No.",
          "bankAccountName": "Bank Account Name",
          "nssfId": "NSSF ID",
          "nssfScheme": "NSSF Scheme",
          "nssfEmployerType": "NSSF Employer Type",
          "nssfStatus": "NSSF Status",
          "privateInsuranceProvider": "Private Insurance Provider",
          "privateInsurancePolicyId": "Private Insurance Policy ID",
          "privateInsuranceScheme": "Private Insurance Scheme",
          "lifecycle": "Lifecycle",
          "jobTitle": "Job Title",
          "jobGrade": "Job Grade",
          "seniorityLevel": "Seniority Level",
          "reportsToRole": "Reports to Role",
          "reportsToPerson": "Reports to Person",
          "orgUnitType": "Org Unit Type",
          "orgUnitLayer": "Org Unit Layer",
          "locationName": "Location Name",
          "locationCode": "Location Code",
          "locationLatLong": "Location (Lat/Long)",
          "locationAddress": "Location Address",
          "resignationSubmittedDate": "Resignation Submitted Date",
          "resignationStatus": "Resignation Status",
          "requestedLastDay": "Requested Last Day",
          "resignationReason": "Resignation Reason",
          "agreedLastDay": "Agreed Last Day",
          "resignationDiscussedDate": "Resignation Discussed Date",
          "discussReason": "Discuss Reason",
          "forwardToHrDate": "Forward to HR Date",
          "leavingLastDate": "Leaving Last Date",
          "leavingType": "Leaving Type",
          "leavingReason": "Leaving Reason",
          "client": "Client",
          "externalManager": "External Manager",
          "workforceSource": "Workforce Source",
          "vendor": "Vendor / Provider",
          "providerEmpId": "Provider Employee ID"
        },
        "col-panel": {
          "title": "Customize table",
          "subtitle": "Choose which employee fields to show in the table and export. Required columns cannot be hidden.",
          "hint": "{count} columns selected · drag to reorder · check / uncheck to toggle",
          "close": "Close",
          "reset": "Reset to default",
          "apply": "Apply",
          "required": "Required",
          "locked": "Locked",
          "group": {
            "employee": "Employee",
            "basic-info": "Basic Employee Info",
            "contact-info": "Contact Info",
            "employment": "Employment & Job Details",
            "contract": "Contract Info",
            "schedule-leave": "Schedule & Leave",
            "payroll": "Payroll / Finance Visibility",
            "insurance": "Insurance",
            "offboarding": "Offboarding",
            "other": "Other",
            "assignment": "Assignment",
            "provider": "Provider Information"
          },
          "no-render": "Not yet available as a table column"
        },
        "loading": "Loading columns…",
        "showing": "Showing {shown} of {total} employees",
        "sorted-by": "sorted by {column} {dir}",
        "sort-dir-asc": "↑",
        "sort-dir-desc": "↓",
        "info-banner": {
          "title": "Directory",
          "body": "The single source of truth for everyone working at your company — Direct employees, Outsourced staff, and External Staff. Use status chips to filter, columns to customise the view, and click any row to open the profile.",
          "dismiss": "Dismiss",
          "dismiss-aria": "Dismiss Directory info banner"
        },
        "filter-active": "filter: {filter}",
        "type-active": "type: {type}",
        "contract-active": "contract: {contract}",
        "search-active": "search: \"{q}\"",
        "clear-all": "Clear all",
        "empty": {
          "title": "No matches",
          "with-search": "No employees match \"{q}\" in the {filter} filter.",
          "no-search": "No employees in the {filter} filter.",
          "clear": "Clear filters",
          "first-title": "Add your first employee",
          "first-body": "This workspace has no employees yet. Add one to start building your directory, or import a batch from Excel/CSV.",
          "first-cta-add": "Add employee",
          "first-cta-import": "Import from file"
        },
        "internal": "Optimal Internal",
        "error": "Failed to load employees. Please try refreshing.",
        "error-403": "You don't have permission to view employees.",
        "error-500": "Something went wrong on our end. Please try again.",
        "retry": "Try again",
        "filter-remove": "Remove {filter} filter",
        "sort-employee": "Sort by employee name",
        "sort-position": "Sort by position",
        "sort-department": "Sort by department",
        "sort-project": "Sort by project/client",
        "sort-type": "Sort by type",
        "sort-contract": "Sort by contract",
        "sort-status": "Sort by status",
        "delete": {
          "selected": "Delete {count} selected",
          "modal-title": "Delete employee?",
          "modal-body": "{name} ({code}) will be permanently removed. This action cannot be undone.",
          "modal-body-many": "{count} employees will be permanently removed. This action cannot be undone.",
          "confirm": "Delete",
          "cancel": "Cancel",
          "success": "{name} has been deleted.",
          "success-many": "{count} employees have been deleted.",
          "error": "Failed to delete employee. Please try again.",
          "error-partial": "{deleted} deleted, {failed} could not be removed. Please retry the remaining."
        },
        "bulkbar": {
          "count": "{n} selected",
          "in-view-all": "all of current view",
          "in-view-mixed": "{inView} in current view · {offView} off-view",
          "export-selected": "Export selected",
          "clear": "Clear"
        },
        "coming-soon": "Coming soon",
        "download-excel": "Download Excel",
        "export-loading": "Exporting…",
        "export-success": "{count} employees exported",
        "export-sheet": "Employees",
        "export-empty": "No employees to export",
        "export-error": "Export failed — please try again",
        "export-modal": {
          "title": "Export employees",
          "description": "Choose scope, format, and which fields to include",
          "scope": {
            "label": "SCOPE — WHICH EMPLOYEES TO EXPORT",
            "filtered": "Current filtered list",
            "filtered-hint": "{count} employees matching the filters you have applied right now",
            "selected": "Selected only",
            "selected-hint": "{count} employees selected on the table",
            "selected-empty": "You need to select rows on the table first",
            "full": "Full employee directory",
            "full-hint": "{count} employees — ignores filters"
          },
          "format": {
            "label": "FORMAT",
            "xlsx": "Excel (.xlsx)",
            "xlsx-hint": "Recommended for HR — opens in Excel & Google Sheets directly.",
            "csv": "CSV (.csv)",
            "csv-hint": "Plain text — best for re-importing into other systems"
          },
          "fields": {
            "label": "EXTRA FIELDS TO ADD (beyond your table columns)"
          },
          "sensitive-warning": "{count} employees will be exported. Compensation fields included — handle with care.",
          "count": "{count} employees will be exported",
          "cancel": "Cancel",
          "submit": "Export {count} employees"
        },
        "workforce": {
          "label": "Workforce: All",
          "all": "Workforce: All",
          "Direct": "Direct",
          "Outsourced": "External Staff"
        },
        "workforce-active": "Workforce: {workforce}",
        "colfilter-active": "{count} column filter(s)"
      },
      "outsourced": {
        "title": "Outsourced Workforce",
        "subtitle": "Staff owned by this tenant and assigned to client projects. Client approvers are invited by email and receive magic-link login — they do not have an Optimal HR account.",
        "banner": {
          "title": "Outsourced Workforce",
          "all": "all non-direct staff working at our sites — both staff we employ (UDC/FDC/Casual) and staff supplied by outsourcing providers (Service).",
          "provider": "Optimal P's staff deployed at client sites · we pay them · client LMs approve day-to-day.",
          "service": "staff supplied by outsourcing providers · they handle payroll, benefits, statutory · we approve attendance and leave operationally.",
          "detail-all": "This is the operational deep-dive for EOR engagements. The Directory shows the same staff alongside Direct employees; here we surface the EOR-specific columns.",
          "detail-provider": "This is the operational deep-dive for EOR engagements. The Directory shows the same staff alongside Direct employees; here we surface the EOR-specific columns.",
          "detail-service": "No payroll captured — vendor handles employment. We only see who supervises operationally."
        },
        "actions": {
          "invite-approver": "Invite Client Approver",
          "invite-toast": "Client-approver invite flow — coming in a follow-up slice",
          "add-employee": "Add Outsourced Employee",
          "add-toast": "Add-employee flow — coming in a follow-up slice",
          "columns": "Columns",
          "export": "Export",
          "export-toast": "Export to Excel · {count} rows",
          "clear-filters": "Clear filters",
          "add-vendor-lite": "Add Vendor Lite Record"
        },
        "col-groups": {
          "identification": "Identification",
          "job-details": "Job Details",
          "assignment": "Assignment",
          "contract": "Contract",
          "status": "Status"
        },
        "view-mode": {
          "label": "View",
          "all": "All",
          "provider": "Provider-employed",
          "provider-hint": "Staff we employ — UDC / FDC / Casual Workforce",
          "service": "Vendor Lite Records",
          "service-hint": "Staff supplied by vendors — no payroll on our side",
          "assigned": "Assigned by Providers",
          "assigned-hint": "Workers assigned to your projects by on-platform Providers — read-only, owned by the Provider"
        },
        "kpi": {
          "total-outsourced": "Total outsourced",
          "total-provider": "Total provider-employed",
          "total-service": "Total service staff",
          "active": "Active",
          "probation": "On Probation",
          "onboarding": "Onboarding",
          "vendors": "Vendors",
          "expiring-fdc": "FDC expiring ≤ 30d",
          "expiring-service": "Engagements expiring ≤ 30d"
        },
        "filters": {
          "all": "All",
          "active": "Active",
          "probation": "On Probation",
          "onboarding": "Onboarding",
          "onleave": "On leave",
          "resigning": "Resigning",
          "leaving": "Leaving",
          "expiring": "Expiring ≤30d",
          "all-projects": "All projects · {count}",
          "all-managers": "All client LMs"
        },
        "search-placeholder": "Search name, code, position…",
        "table": {
          "showing": "Showing {filtered} of {total} outsourced staff",
          "sorted-by": "sorted by {col} {dir}",
          "click-hint": "Click any row to open the profile",
          "code": "CODE",
          "person": "PERSON",
          "kh-name": "KH NAME",
          "position": "POSITION",
          "dept": "DEPT",
          "project": "PROJECT / CLIENT",
          "ext-mgr": "EXTERNAL MANAGER (LM)",
          "contract": "CONTRACT",
          "contract-end": "CONTRACT END",
          "vendor": "VENDOR",
          "joined": "JOINED DATE",
          "status": "STATUS",
          "actions": "ACTIONS",
          "row-actions": "Row actions",
          "open-profile": "Open profile",
          "open-profile-toast": "Profile drawer — opening {code}",
          "no-end": "—"
        },
        "drawer": {
          "tabs": {
            "overview": "Overview",
            "contract": "Contract"
          },
          "fields": {
            "code": "Employee code",
            "kh-name": "Khmer name",
            "position": "Position",
            "dept": "Department",
            "project": "Project",
            "client": "Client",
            "external-manager": "External Manager (LM)",
            "contract": "Contract type",
            "contract-end": "Contract end",
            "joined": "Joined",
            "base-location": "Base location",
            "phone": "Phone",
            "email": "Email",
            "vendor": "Vendor"
          },
          "no-value": "—"
        },
        "empty": {
          "title": "No matches",
          "lede": "No outsourced staff match these filters."
        },
        "mode-subtitle": {
          "provider-off": "Staff owned by this tenant and assigned to client projects. Client approvers are invited by email and receive magic-link login — they do not have an Optimal HR account.",
          "provider-on": "Staff owned by this tenant and assigned to client projects. When inviting a client approver, the system links to their existing Optimal HR account — no duplicate ESS.",
          "client-on": "Outsourced staff assigned to your projects by on-platform Providers. The Provider owns each worker's HR profile — you only see the assignment shadow and can approve operational requests.",
          "client-off": "Vendor lite records for workers supplied by providers NOT on Optimal HR. Operational tracking only — no payroll by this tenant.",
          "none": "Outsourcing is disabled for this tenant."
        },
        "mode": {
          "label": "Tenant outsourcing mode",
          "demo-tools": "Demo Tools",
          "dev-only": "Prototype only — not in production",
          "prod-note": "Production: configured in Admin → Modules",
          "close": "Close",
          "option": {
            "provider-off": "1 · Outsourcing Provider · Client NOT on Optimal HR",
            "provider-on": "2 · Outsourcing Provider · Client also on Optimal HR",
            "client-on": "3 · Outsourced Client · Provider on Optimal HR",
            "client-off": "4 · Outsourced Client · Provider NOT on Optimal HR",
            "none": "5 · General SMB (no outsourcing)"
          },
          "pill": {
            "role-provider": "Provider role",
            "role-client": "Client role",
            "role-none": "No outsourcing",
            "client-on": "Client on OHR",
            "client-off": "Client off-platform",
            "provider-on": "Provider on OHR",
            "provider-off": "Provider off-platform",
            "disabled": "Disabled"
          }
        },
        "assigned": {
          "banner-title": "Assigned by Providers",
          "banner-lead": "outsourced workers not owned by this tenant. The Provider tenant on Optimal HR owns the full HR profile (payroll, contract, ESS, leave entitlement). This tenant only receives the assignment shadow and can approve operational requests for the named approver.",
          "banner-detail": "Worker data is read-only here — to change personal details, contract terms, or salary, contact the Provider tenant. (Stub data — cross-tenant sync ships in a follow-up.)",
          "empty-title": "No incoming assignments",
          "empty-lede": "No on-platform Provider sends workers to this tenant in this scenario. Switch to Vendor Lite Records to add a manual record for off-platform providers.",
          "empty-cta": "Go to Vendor Lite Records",
          "showing": "Showing {count} incoming assignment(s) · owned by Provider tenant",
          "click-hint": "Worker profile lives in the Provider tenant",
          "accept": "Accept assignment",
          "decline": "Decline assignment",
          "view": "View scope (read-only)",
          "accept-toast": "Accept handshake — Provider will be notified; assignment shadow becomes Active",
          "decline-toast": "Decline handshake — Provider will be notified; assignment expires",
          "view-toast": "Read-only · worker profile lives in Provider tenant ({tenant})",
          "kpi": {
            "total": "Total incoming",
            "active": "Active",
            "pending": "Pending acceptance",
            "ended": "Ended (archive)"
          },
          "col": {
            "worker": "WORKER",
            "provider": "PROVIDER",
            "project": "PROJECT",
            "approver": "APPROVER",
            "scope": "SCOPE",
            "dates": "START–END",
            "status": "STATUS",
            "actions": "ACTIONS"
          }
        }
      },
      "configuration": {
        "sub-nav": {
          "grades": "Job Grades",
          "job-titles": "Job Titles",
          "job-profiles": "Job Profiles",
          "benefits": "Benefits"
        },
        "banner": {
          "lead": "Reference data.",
          "rest": "Job Grades, Job Titles, Job Profiles and the Benefits Catalog are the shared building blocks every Position, Offer Letter and per-employee record refers back to. Edits here propagate to every consumer — change with intent."
        },
        "benefits": {
          "title": "Benefits Catalog",
          "subtitle": "Company-wide master list of insurance · statutory · wellness · in-kind benefits. Defined once · referenced by every employee enrollment.",
          "add": "New Benefit",
          "add-toast": "New benefit · the create modal lands in the next slice once the catalog endpoint ships.",
          "search-placeholder": "Search by name, provider, scheme…",
          "clear-filters": "Clear filters",
          "showing": "Showing {filtered} of {total}",
          "renewal-soon": "SOON",
          "cost-family": "family USD {amt}",
          "auto-enroll": "Auto-enroll on hire",
          "footnote": "To enroll a specific employee, open their profile → Benefits. For bulk enrollment, use Employment Records → Benefits.",
          "kpi": {
            "active": "Active benefits",
            "enrollments": "Active enrollments",
            "monthly-cost": "Monthly cost (employer)",
            "renewing": "Renewing ≤90 days"
          },
          "chips": {
            "all": "All",
            "statutory": "Statutory",
            "insurance": "Insurance",
            "wellness": "Wellness",
            "allowance": "Allowance in-kind",
            "other": "Other"
          },
          "cols": {
            "benefit": "Benefit",
            "kind": "Kind",
            "eligibility": "Eligibility",
            "cost": "Cost / mo",
            "enrolled": "Enrolled",
            "renewal": "Renewal",
            "status": "Status"
          },
          "status": {
            "Active": "Active",
            "Renewing": "Renewing",
            "Ended": "Ended"
          },
          "empty": {
            "title": "No benefits match the current filters",
            "lede": "Try clearing the filters or search for a different keyword."
          },
          "drawer": {
            "scheme": "Scheme",
            "policy-pattern": "Policy ID pattern",
            "coverage": "Coverage",
            "eligibility": "Eligibility",
            "cost-emp": "Cost / employee / mo",
            "cost-fam": "Cost / family / mo",
            "cost-note": "Cost notes",
            "renewal": "Next renewal",
            "enrolled": "Active enrollments"
          }
        },
        "job-titles": {
          "banner-lead": "Job Titles",
          "banner-rest": " are role templates referenced by many Positions. Each title declares a family, a default grade, and 0–2 specifiers (Outlet, Line, Shift, etc.) that distinguish individual seats sharing the same title. e.g. one \"Plant Operator\" Job Title can be referenced by many Positions on different factory lines.",
          "kpi": {
            "active": "Active titles",
            "with-specifiers": "With specifiers",
            "orphan-main": "Orphan titles",
            "orphan-sub": "(0 Positions)",
            "broken-grade": "Broken grade link"
          },
          "families-label": "Families:",
          "toolbar-summary": "{active} active · {inactive} inactive",
          "show-inactive": "Show inactive",
          "add": "Add Job Title",
          "error": "Couldn't load job titles — {message}",
          "retry": "Try again",
          "footnote": "Click any row to edit. To see the Positions of a title, use the Positions page with the Job Title filter.",
          "cols": {
            "id": "ID",
            "title": "Title",
            "family": "Family",
            "grade": "Default grade",
            "specifiers": "Specifiers",
            "positions": "Positions",
            "filled": "Filled",
            "open": "Open",
            "status": "Status"
          },
          "status": {
            "active": "Active",
            "inactive": "Inactive"
          },
          "errors": {
            "conflict": "A job title with this name already exists. Use a different title or add a specifier.",
            "forbidden": "You don't have permission to manage job titles for this company.",
            "generic": "Couldn't save the job title. Please try again."
          },
          "empty": {
            "title": "No job titles yet",
            "subtitle": "Create your first role template to start building the Positions catalogue."
          },
          "modal": {
            "title": "New Job Title",
            "subtitle": "Create a role template for Positions to reference",
            "sections": {
              "identity": "Identity",
              "classification": "Classification",
              "specifiers": "Specifiers",
              "description": "Description"
            },
            "fields": {
              "id": {
                "label": "ID",
                "hint": "Will be assigned as a JT-0XX code on create.",
                "auto": "(auto)"
              },
              "title": {
                "label": "Title",
                "placeholder": "e.g. Senior Engineer"
              },
              "family": {
                "label": "Family",
                "placeholder": "Select family…"
              },
              "grade": {
                "label": "Default grade",
                "placeholder": "— select grade —"
              },
              "specifiers": {
                "placeholder": "Add a specifier…"
              },
              "description": {
                "placeholder": "Brief role summary. Detailed KSAs belong on the Job Profile instead."
              }
            },
            "specifier-add": "Add",
            "specifier-remove": "Remove specifier",
            "specifier-section-hint": "(max 2 — used to distinguish identical-title positions)",
            "specifier-empty": "No specifiers. Each Position is uniquely identified by its Position ID alone. Add one (e.g. Outlet, Line, Shift) when many Positions share the same title.",
            "specifier-fields": {
              "name": "Name",
              "name-placeholder": "Outlet / Line / Shift",
              "source": "Source",
              "location-type": "Location type",
              "location-type-placeholder": "— select type —",
              "free-text-hint": "Typed by HR when filling each Position",
              "projects-hint": "Uses the Outsourcing Projects list"
            },
            "note-before": "New titles start ",
            "note-active": "Active",
            "note-after": " and become available in the New Position picker immediately. Deactivate / Reactivate / History will be available here after the title is created.",
            "errors": {
              "employer-missing": "No active employer — reopen this page and try again.",
              "title-required": "Title is required.",
              "family-required": "Family is required.",
              "grade-required": "Default grade is required."
            },
            "cancel": "Cancel",
            "create": "Create title",
            "creating": "Creating…",
            "success": "Job title \"{title}\" created.",
            "specifier-empty-1": "No specifiers. Each Position is uniquely identified by its Position ID alone.",
            "specifier-empty-2": "Add a specifier (e.g. Outlet, Line, Shift) when many Positions share the same title."
          },
          "edit": {
            "title": "Edit Job Title · {code}",
            "success": "Job title \"{title}\" updated.",
            "history": "History",
            "history-soon": "History — coming soon",
            "id-locked": "Locked once created.",
            "usage-positions": "Position reference this title",
            "inactive-notice-lead": "This Job Title is Inactive",
            "inactive-notice-rest": ". It is hidden from New Position pickers but preserved for audit. Use the Reactivate button below to bring it back.",
            "inactive-notice-rest-dated": " (deactivated {date}). It is hidden from New Position pickers but preserved for audit. Use the Reactivate button below to bring it back.",
            "cancel": "Cancel",
            "save-changes": "Save changes",
            "saving": "Saving…",
            "deactivate": {
              "heading": "Deactivate Job Title",
              "explanation": "Deactivated titles hide from New Position pickers but are preserved for audit. Hard delete is not allowed — once defined, a Job Title always remains.",
              "cannot": "Cannot deactivate — this title is still used by {count} Position(s) ({filled} Filled, {open} Open).",
              "reassign-note": "Cancel or reassign those Positions first. Open Positions can be Cancelled; Filled Positions need their Job Title changed (or the title needs to keep living).",
              "action": "Deactivate this title",
              "cannot-lead": "Cannot deactivate",
              "cannot-rest": " — this title is still used by:",
              "usage-count": "{count} Position(s)",
              "usage-breakdown": " ({filled} Filled, {open} Open)"
            },
            "reactivate": {
              "heading": "Reactivate Job Title",
              "explanation": "Reactivating restores this title to Active. It will appear in the New Position picker again.",
              "action": "Reactivate this title"
            }
          },
          "banner-line1": "<strong>Job Titles</strong> are role templates referenced by many Positions. Each title declares a family, a default grade, and 0–2 specifiers (Outlet, Line, Shift, etc.) that distinguish individual seats sharing the same title.",
          "banner-line2": "e.g. one “Plant Operator” Job Title is referenced by 5 Positions on different factory lines.",
          "specifier": {
            "none": "none",
            "free-text": "free-text",
            "locations": "Locations",
            "projects": "Projects"
          },
          "footnote-pre": "Click any row to edit. To see Positions of a title, use ",
          "footnote-bold": "Positions",
          "footnote-post": " page with the Job Title filter."
        },
        "job-profiles": {
          "banner-lead": "Job Profile",
          "banner-rest": " is an optional deeper layer attached to a Job Title — KSAs (Knowledge, Skills, Abilities), required certifications, succession planning notes, learning paths, and critical-role flags. Most companies fill these out for senior or critical roles only. Profile is content (not structure), so the action is Update rather than Edit. Remove is reversible — content stays in the database for audit.",
          "kpi": {
            "active-titles": "Active titles",
            "attached": "Profiles attached",
            "critical": "Critical roles",
            "without-succession": "Without succession",
            "succession-unit": "critical roles"
          },
          "filters": {
            "label": "Filter profiles",
            "all": "All titles",
            "with": "With profile",
            "no": "No profile",
            "critical": "Critical only"
          },
          "show-removed": "Show removed profiles ({count})",
          "error": "Couldn't load job profiles — {message}",
          "retry": "Try again",
          "empty": {
            "title": "No job titles yet",
            "subtitle": "Create Job Titles first — profiles attach to them."
          },
          "cols": {
            "title": "Job title",
            "family": "Family",
            "grade": "Default grade",
            "profile": "Profile",
            "updated": "Last updated",
            "action": "Action"
          },
          "profile-attached": "Profile",
          "profile-critical": "Critical",
          "profile-none": "No profile",
          "action-add": "Add profile",
          "action-update": "Update",
          "action-restore": "Restore",
          "removed-heading": "Removed profiles ({count})",
          "removed-subtitle": "Content is preserved for audit. Restore brings a profile back to Active with no data loss.",
          "removed-cols": {
            "id": "Profile ID",
            "title": "Job title",
            "removed-on": "Removed on",
            "removed-by": "Removed by",
            "action": "Action"
          },
          "removed-toast": "Job profile removed. You can restore it from the removed list.",
          "status": {
            "removed": "Removed"
          },
          "errors": {
            "conflict": "A profile already exists for this job title.",
            "forbidden": "You don't have permission to manage job profiles for this company.",
            "generic": "Couldn't save the job profile. Please try again."
          },
          "modal": {
            "add-title": "Add Job Profile",
            "update-title": "Update Job Profile",
            "add-note": "Adding a new profile. All sections are optional — fill what's useful. Most companies start with senior/critical roles and expand over time.",
            "success": "Job profile created.",
            "sections": {
              "content": "Content",
              "certifications": "Required certifications",
              "strategic": "Strategic flags"
            },
            "fields": {
              "knowledge": {
                "label": "Knowledge",
                "hint": "what to know",
                "placeholder": "e.g. Cambodian Labour Law; NSSF filing procedures; double-entry bookkeeping…"
              },
              "skills": {
                "label": "Skills",
                "hint": "what to do",
                "placeholder": "e.g. Code review; mentoring; Khmer + English business writing…"
              },
              "abilities": {
                "label": "Abilities",
                "hint": "capacities",
                "placeholder": "e.g. Lift 25 kg; work overnight shifts; analyse trends from numerical data…"
              },
              "certification": {
                "placeholder": "e.g. SHRM-SCP or equivalent"
              },
              "critical": {
                "label": "Critical role",
                "hint": "high impact if unfilled; requires succession plan + continuity strategy"
              },
              "succession": {
                "label": "Succession notes",
                "placeholder": "Who is the named successor? Time horizon? Development gaps?",
                "hint": "recommended for critical roles"
              },
              "learning": {
                "label": "Learning paths",
                "placeholder": "Internal mentoring; external courses; rotations…"
              },
              "performance": {
                "label": "Performance dimensions",
                "placeholder": "Which metrics judge success in this role?"
              }
            },
            "cert-add": "Add",
            "cert-empty": "No certifications required.",
            "cert-remove": "Remove certification",
            "succession-warning": "Critical role with no succession notes — add a named successor or development plan.",
            "cancel": "Cancel",
            "create": "Create profile",
            "creating": "Creating…",
            "errors": {
              "employer-missing": "No active employer — reopen this page and try again.",
              "no-title": "No job title selected — reopen and try again."
            },
            "add-note-lead": "Adding a new profile.",
            "add-note-rest": " All sections are optional — fill what's useful. Most companies start with senior/critical roles and expand over time.",
            "confirm-critical": "Critical role flag is set but Succession notes are empty.\n\nIt is strongly recommended to document a successor for critical roles. Proceed anyway?"
          },
          "update": {
            "success": "Job profile updated.",
            "history": "History",
            "history-soon": "History — coming soon",
            "removed-notice": " on {date} by {by}. Content is preserved for audit. Use the Restore button at the bottom to bring it back.",
            "save-changes": "Update profile",
            "saving": "Saving…",
            "remove": {
              "heading": "Remove profile",
              "explanation": "Removes this profile from the Job Title. Content is preserved for audit — this is not a hard delete. You can restore it later from the removed list.",
              "action": "Remove this profile",
              "explanation-pre": "Remove detaches the profile from its Job Title. ",
              "explanation-bold": "Content is preserved",
              "explanation-post": " for audit — this is not a delete. You can restore from “Show removed profiles” later.",
              "confirm": "Remove the Job Profile for “{title}”?\n\nThe profile content is preserved in the database for audit. The Job Title will show as “No profile” but you can restore it later."
            },
            "restore": {
              "heading": "Restore profile",
              "explanation": "Restore brings this profile back to Active. Content was preserved during removal — no loss.",
              "action": "Restore this profile"
            },
            "removed-notice-lead": "This profile was removed"
          },
          "banner-line1": "<strong>Job Profile</strong> is an <em>optional</em> deeper layer attached to a Job Title — KSAs (Knowledge, Skills, Abilities), required certifications, succession planning notes, learning paths, and HiPo/critical-role flags. Most companies fill these out for senior or critical roles only.",
          "banner-line2": "Profile is <strong>content</strong> (not structural), so the action is <strong>Update</strong> rather than Edit. Remove is reversible — content stays in the database for audit.",
          "counts-active": "active",
          "counts-removed": "removed",
          "show-removed-label": "Show removed profiles",
          "guide": {
            "title": "What a Job Profile contains",
            "k": {
              "head": "K · KNOWLEDGE",
              "desc": "What the role must know. e.g.",
              "eg": "\"Cambodian Labour Law\", \"NSSF filing procedures\", \"double-entry bookkeeping\""
            },
            "s": {
              "head": "S · SKILLS",
              "desc": "What the role must do. e.g.",
              "eg": "\"Excel pivot tables\", \"TIG welding to ASME spec\", \"Khmer + English business writing\""
            },
            "a": {
              "head": "A · ABILITIES",
              "desc": "Capacities. e.g.",
              "eg": "\"Lift 25 kg repeatedly\", \"Work overnight shifts\", \"Analyse trends from numerical data\""
            },
            "other": {
              "head": "OTHER",
              "desc": "Required certifications · Learning paths · Critical-role flag · Succession candidates · Performance dimensions."
            }
          },
          "table-caption-lead": "Job Titles",
          "table-caption-rest": " with their profile status — click \"Update\" to refine, \"Add\" to start a new profile",
          "table-count": "{shown} of {total} title(s)",
          "profile-active": "Active",
          "action-review-restore": "Review & restore",
          "action-review": "Review",
          "removed-caption-rest": " — content preserved for audit. Restore from the table above (the row shows \"Removed\" status) or click below.",
          "profile-no-succession": "No succession"
        },
        "grades": {
          "banner-lead": "Job Grades",
          "banner-mid": " set salary bands and define the seniority ladder. Each Job Title declares a ",
          "banner-emphasis": "default grade",
          "banner-rest": ", and each Position inherits its grade from its Job Title. Salary outside the band on Add Person will trigger a soft warning.",
          "kpi": {
            "active": "Active grades",
            "lowest-min": "Lowest min salary",
            "highest-max": "Highest max salary",
            "orphan-main": "Orphan grades",
            "orphan-sub": "(no Job Title)",
            "primary-currency-caption": "({currency} · most grades)"
          },
          "currency-filter-label": "Currency",
          "currency-all": "All",
          "toolbar-summary-head": "{active} active · {inactive} inactive",
          "toolbar-summary-overlaps": "{overlaps} band overlaps",
          "show-inactive": "Show inactive",
          "add": "Add Grade",
          "cols": {
            "code": "Code",
            "grade": "Grade weight",
            "title": "Title",
            "min": "Min salary",
            "max": "Max salary",
            "currency": "Currency",
            "titles": "Job titles",
            "positions": "Filled positions",
            "description": "Description",
            "status": "Status"
          },
          "status": {
            "active": "Active",
            "inactive": "Inactive"
          },
          "loading": "Loading job grades…",
          "error": "Couldn't load job grades — {message}",
          "retry": "Try again",
          "errors": {
            "conflict": "A job grade with this code or grade weight already exists. Use a different code or weight.",
            "forbidden": "You don't have permission to manage job grades for this company.",
            "generic": "Couldn't save the job grade. Please try again."
          },
          "empty": {
            "title": "No job grades yet",
            "subtitle": "Create your first seniority band to start building the grade ladder."
          },
          "modal": {
            "title": "New Job Grade",
            "subtitle": "Define a new seniority band",
            "sections": {
              "identity": "Identity",
              "salary": "Salary band (gross, monthly)",
              "description": "Description"
            },
            "fields": {
              "code": {
                "label": "Code",
                "placeholder": "e.g. L5",
                "hint": "Short display code (e.g. L5)"
              },
              "grade": {
                "label": "Grade",
                "placeholder": "e.g. 5",
                "hint": "Numeric weight for ordering — higher = higher grade"
              },
              "title": {
                "label": "Title",
                "placeholder": "e.g. Senior Manager"
              },
              "min": {
                "label": "Min",
                "placeholder": "e.g. 5000"
              },
              "max": {
                "label": "Max",
                "placeholder": "e.g. 8000"
              },
              "currency": {
                "label": "Currency"
              },
              "description": {
                "placeholder": "Who fits this grade? Years of experience, scope, level of authority…"
              }
            },
            "note-before": "New grades start ",
            "note-active": "Active",
            "note-after": " and appear in grade pickers immediately. Deactivate / Reactivate / History will be available here after the grade is created.",
            "errors": {
              "grade-required": "Grade is required.",
              "grade-numeric": "Grade must be a valid number.",
              "grade-taken": "This grade is already taken.",
              "code-taken": "This code is already taken.",
              "code-required": "Code is required.",
              "title-required": "Title is required.",
              "salary-required": "Min and Max salary are required.",
              "numeric": "Min and Max must be valid numbers.",
              "max-below-min": "Max salary must be greater than or equal to Min salary.",
              "employer-missing": "No active employer — reopen this page and try again."
            },
            "cancel": "Cancel",
            "create": "Create grade",
            "creating": "Creating…",
            "success": "Job grade {code} created."
          },
          "edit": {
            "title": "Edit Job Grade · {code}",
            "history": "History",
            "history-soon": "History — coming soon",
            "save-changes": "Save changes",
            "saving": "Saving…",
            "cancel": "Cancel",
            "success": "Job grade {code} updated.",
            "code-locked": "Code is locked once created (referenced by Job Titles).",
            "code-editable": "No code yet — add one (referenced by Job Titles, then locked).",
            "inactive-notice-lead": "This Job Grade is Inactive",
            "inactive-notice-rest": ". Edit history is preserved. Use the Reactivate button below to bring it back.",
            "inactive-notice-rest-dated": " (deactivated {date}). Edit history is preserved. Use the Reactivate button below to bring it back.",
            "overlap-lead": "Band overlap",
            "overlap-detail": "with: {code} ({min}–{max}). This is allowed (soft warning) but typically grades should not overlap.",
            "usage": {
              "titles-suffix": "Job Titles reference this grade",
              "positions-suffix": "filled position at this grade"
            },
            "deactivate": {
              "heading": "Deactivate Job Grade",
              "explanation": "Deactivated grades hide from pickers but are preserved for audit. Hard delete is not allowed — once defined, a Job Grade always remains in the database.",
              "cannot": "Cannot deactivate — this grade is still in use:",
              "reason-titles": "{count} Job Title(s) reference it as default grade",
              "reason-positions": "{count} filled Position(s) at this grade",
              "reassign-note": "Reassign those to a different grade first, then return here.",
              "action": "Deactivate this grade",
              "cannot-lead": "Cannot deactivate",
              "cannot-rest": " — this grade is still in use:",
              "reason-titles-count": "{count} Job Title(s)",
              "reason-titles-rest": " reference it as default grade",
              "reason-positions-count": "{count} filled Position(s)",
              "reason-positions-rest": " at this grade"
            },
            "reactivate": {
              "heading": "Reactivate Job Grade",
              "explanation": "Reactivating restores this grade to Active. It will appear in grade pickers again. Edit history continues unchanged.",
              "action": "Reactivate this grade"
            }
          }
        }
      },
      "salaryBatch": {
        "button": "Salary Batch",
        "modal": {
          "title": "Batch Salary Update",
          "subtitle": "Update employee salaries in bulk from Excel with real-time validation."
        },
        "steps": {
          "upload": "Upload file",
          "validation": "Validation",
          "confirm": "Confirm"
        },
        "tabs": {
          "batch": "New Batch",
          "history": "Batch History"
        },
        "footer": {
          "cancel": "Cancel",
          "validate": "Validate",
          "confirmApply": "Confirm & Apply",
          "nextValidation": "Next: Validation",
          "nextConfirm": "Next: Confirm",
          "back": "Back"
        },
        "confirm": {
          "summaryTitle": "Apply summary",
          "rowsToApply": "Rows to apply",
          "warningsOverridden": "Warnings overridden",
          "noRowsToApply": "No valid rows to apply. Please go back and review the validation results.",
          "note": "Salary changes are permanent and cannot be undone. Please review the validation results before confirming."
        },
        "instructions": {
          "title": "Instructions & Requirements",
          "step1Title": "Step 1 — Generate Template",
          "step1Bullet1": "Optionally select scope filters (department, branch/base location), then click Generate Template.",
          "step1Bullet2": "Without filters, the template includes all active employees. With filters, only matching employees are included.",
          "step1Bullet3": "Download the file and fill in: New Basic Salary (positive number), Effective Date (YYYY-MM-DD), Reason (required).",
          "step1Bullet4": "Read-only columns — Employee Code, Full Name, Current Basic Salary — do not edit these.",
          "step2Title": "Step 2 — Upload & Validate",
          "step2Bullet1": "Only .xlsx files accepted. Maximum file size: 5 MB.",
          "step2Bullet2": "Do not modify the hidden metadata sheet — it is used to verify template authenticity.",
          "step2Bullet3": "Clicking Validate is a dry run — no salary records are created.",
          "step2Bullet4": "Rows with errors cannot be applied. Rows with warnings can be overridden."
        },
        "scopeFilters": {
          "title": "Scope & Template",
          "optional": "(optional)",
          "orgUnit": "Org Unit",
          "orgUnitPlaceholder": "All org units",
          "baseLocation": "Base Location",
          "baseLocationPlaceholder": "All base locations",
          "downloadBtn": "Download Template",
          "downloading": "Downloading…",
          "descriptionAll": "All active employees",
          "descriptionFiltered": "Filtered employees only"
        },
        "upload": {
          "title": "Upload Filled Template",
          "dropHint": "Drop file here or click to browse",
          "fileTypeHint": ".xlsx files only",
          "fileSizeLimit": "Max {size} MB",
          "removeFile": "Remove file"
        },
        "preview": {
          "title": "Validation Preview",
          "statTotal": "Total:",
          "statValid": "Valid:",
          "statInvalid": "Errors:",
          "statWarnings": "Warnings:",
          "statPending": "Pending validation",
          "colNum": "#",
          "colStatus": "Status",
          "colEmployeeCode": "Employee Code",
          "colFullName": "Full Name",
          "colCurrentSalary": "Current Salary",
          "colNewSalary": "New Salary",
          "colEffectiveDate": "Effective Date",
          "colReason": "Reason",
          "colRemark": "Remarks",
          "colOverride": "Override",
          "statusValid": "Valid",
          "statusError": "Error",
          "statusWarning": "Warning",
          "statusPending": "Pending",
          "statusUnknown": "Unknown",
          "exportErrors": "Export errors",
          "warningOverrideBanner": "Some rows have warnings. Check the Override box to include them in the apply.",
          "csvColRow": "Row",
          "csvColErrors": "Errors / Warnings"
        },
        "result": {
          "successTitle": "Salary update applied",
          "successSub": "{succeeded} record(s) updated successfully.",
          "successSubFailed": " {failed} failed.",
          "downloadResult": "Download Result File",
          "downloadOriginal": "Download Original File"
        },
        "history": {
          "description": "Previous batch salary updates for this employer.",
          "loading": "Loading history…",
          "empty": "No batch history yet.",
          "unknown": "Unknown",
          "batchId": "Batch ID",
          "validated": "Validated",
          "applied": "Applied",
          "validateSummaryValue": "{valid} valid / {total} total",
          "applySummaryValue": "{succeeded} ok, {failed} failed / {total} total",
          "importedOf": "{succeeded} / {total} applied",
          "rowsCount": "{count} rows",
          "downloadResult": "Download Result",
          "downloadOriginal": "Download Original"
        },
        "errors": {
          "filterLoadFailed": "Could not load filter options. Please retry.",
          "generateFailed": "Could not generate template. Please retry.",
          "invalidTemplateResponse": "Invalid template response from server.",
          "onlyXlsx": "Only .xlsx files are accepted.",
          "fileTooLarge": "File exceeds {size} MB limit.",
          "noDataRows": "The file has no data rows.",
          "parseError": "Could not read the file. Make sure it is a valid .xlsx file.",
          "readError": "Could not read the file from disk.",
          "validateFailed": "Validation failed. Please retry.",
          "applyFailed": "Apply failed. Please retry.",
          "historyLoadFailed": "Could not load batch history.",
          "resultDownloadFailed": "Could not download result file.",
          "originalDownloadFailed": "Could not download original file."
        }
      },
      "profile": {
        "joined": "Joined",
        "message": "Message",
        "edit": "Edit",
        "coming-soon": "Coming in a follow-up slice",
        "photo": {
          "upload-tooltip": "Change profile photo",
          "upload-success": "Profile photo updated.",
          "upload-error": "Failed to update profile photo. Please try again.",
          "remove": "Remove photo"
        },
        "error": "Failed to load employee profile.",
        "retry": "Retry",
        "nav-label": "Profile sections",
        "tabs": {
          "overview": "Overview",
          "job": "Job & Organization",
          "contract": "Contract",
          "employment-actions": "Employment Actions",
          "compensation": "Compensation",
          "benefits": "Benefits",
          "payroll": "Payroll",
          "attendance": "Attendance",
          "documents": "Documents",
          "personal": "Personal Information",
          "journey": "Employment Journey"
        },
        "contract": {
          "current-contract": "Current Contract",
          "readonly-label": "Read-only",
          "readonly-structural": "structural changes are Contract Events",
          "readonly-pay": "pay changes are Salary Adjustments",
          "contract-type": "Contract Type",
          "status": "Status",
          "start-date": "Start Date",
          "end-date": "End Date",
          "ongoing": "ongoing",
          "end-date-ongoing": "— ongoing",
          "probation-end": "Probation End",
          "base-salary-monthly": "Contract Base Salary",
          "base-salary-hint": "/ month — at signing",
          "base-salary-no-adj": "No salary adjustments since signing — contract base = current effective pay.",
          "all-contracts": "All Contracts",
          "all-contracts-desc": "Each row is a distinct signed contract. New contracts come from Contract Events (Renewal · Extension · Conversion · Amendment). Salary adjustments do not create a new contract row.",
          "col-start": "Start",
          "col-end": "End",
          "col-type": "Type",
          "col-base-salary": "Contract Base",
          "col-status": "Status",
          "col-actions": "Actions",
          "no-contracts": "No contracts found",
          "add": "New Contract",
          "edit": "Edit contract",
          "delete": "Delete contract",
          "confirm-delete": "Delete this contract? This cannot be undone.",
          "confirm-delete-yes": "Yes, delete",
          "confirm-delete-no": "Cancel",
          "events-title": "Contract Events",
          "events-subtitle": "Record contract lifecycle changes: renewal · extension · conversion · amendment · probation · termination. Phase 1 — recording only.",
          "events-add": "Add Contract Event",
          "events-empty-title": "No contract events recorded yet",
          "events-empty-hint": "Use this surface when HR receives a signed contract / renewal / amendment / probation memo offline and needs to record it.",
          "events-col-effective": "Effective",
          "events-col-event": "Event",
          "events-col-detail": "Detail",
          "events-col-status": "Status",
          "salary-adj-title": "Salary Adjustments History",
          "salary-adj-subtitle": "Compensation Events that change the effective pay without amending the signed contract.",
          "salary-adj-count": "{n} adjustment | {n} adjustments",
          "salary-adj-col-effective-date": "Effective Date",
          "salary-adj-col-from": "From",
          "salary-adj-col-to": "To",
          "salary-adj-col-reason": "Reason",
          "salary-adj-col-status": "Status",
          "salary-adj-note": "The signed Contract Base Salary above is locked. Amending the contract itself requires a Contract Event (Amendment / Renewal / Conversion). Salary adjustments are recorded via Compensation tab → Record Compensation Event → Salary Adjustment."
        },
        "more-menu": {
          "label": "More actions",
          "section-contract": "Contract Actions",
          "section-other": "Other",
          "new-contract": "New Contract",
          "new-contract-sub": "Create a fresh contract for this employee",
          "renew-contract": "Renew Contract",
          "renew-contract-sub": "Extend the current contract term",
          "rehire": "Rehire Employee",
          "rehire-sub": "Re-engage a previously terminated employee",
          "download-pdf": "Download Contract PDF",
          "download-pdf-unavailable": "Contract PDF export is not yet available.",
          "delete-employee": "Delete Employee Record",
          "delete-employee-confirm-title": "Delete Employee Record",
          "delete-employee-confirm-body": "This action is permanent and cannot be undone. Are you sure you want to permanently delete",
          "delete-employee-confirm-yes": "Yes, Delete",
          "delete-employee-confirm-no": "Cancel",
          "delete-employee-error": "Failed to delete employee. Please try again."
        },
        "contract-drawer": {
          "title": {
            "new": "New Contract",
            "renew": "Renew Contract",
            "rehire": "Rehire Employee"
          },
          "subtitle": {
            "new": "Create a new employment contract",
            "renew": "Extend the current contract with a new term",
            "rehire": "Re-engage this employee under a new contract"
          },
          "rehire-note": "This will create a new contract and mark the employee as rehired. Ensure all required paperwork has been completed before proceeding.",
          "field-type": "Contract Type",
          "field-type-placeholder": "Select contract type",
          "field-employment-type": "Employment Type",
          "field-start-date": "Start Date",
          "field-end-date": "End Date",
          "field-salary": "Basic Salary",
          "field-salary-placeholder": "e.g. 1200",
          "field-position": "Position (Org Chart)",
          "field-position-placeholder": "Select a vacant position",
          "field-position-hint": "Optional — links this contract to a vacant position in the org chart.",
          "position-loading": "Loading positions…",
          "position-empty": "No vacant positions available.",
          "field-reason": "Reason",
          "field-reason-placeholder": "Reason for this contract action",
          "error-start-required": "Start date is required.",
          "error-end-required": "End date is required for this contract type.",
          "error-end-after-start": "End date must be after the start date.",
          "error-reason-required": "Reason is required.",
          "error-save-failed": "Failed to save. Please try again.",
          "cancel": "Cancel",
          "save": "Save Contract",
          "saving": "Saving…"
        },
        "employment-actions": {
          "title": "Employment Actions",
          "subtitle": "Position-aligned EA records · 3-action v1 catalog · §9.6 firewall preserved · derived label persisted at submit.",
          "frozen-chip": "CI Rev 3.2.1 · FROZEN BASELINE",
          "new-action": "+ New Employment Action",
          "error": "Failed to load employment actions.",
          "retry": "Retry",
          "phase1-bold": "Phase 1 · Recording only.",
          "phase1-notice": "HR records what's been agreed offline (memo / letter / LM sign-off). Status is derived from the effective date — Scheduled (future) or Effective (today/past). Approval workflow comes in Phase 2.",
          "empty-title": "No employment actions yet for {name}",
          "empty-hint": "Click New Employment Action above to create the first one.",
          "confirm-cancel": "Cancel this employment action? This cannot be undone.",
          "confirm-cancel-yes": "Yes, cancel",
          "confirm-cancel-no": "Keep",
          "cancel-action": "Cancel",
          "view-detail": "View detail",
          "kpi": {
            "current-position": "CURRENT POSITION",
            "reports-to": "REPORTS TO",
            "eas-employee": "EAs (THIS EMPLOYEE)",
            "eas-tenant": "EAs (TENANT-WIDE)",
            "scheduled": "scheduled",
            "effective": "effective",
            "cancelled": "cancelled",
            "scheduled-future": "scheduled (future-dated)"
          },
          "col": {
            "date": "Date",
            "type": "Action Type",
            "detail": "Detail",
            "label": "Detected Label",
            "status": "Status"
          },
          "info": {
            "current-position": "Current Position",
            "reports-to": "Reports To",
            "eas-employee": "EAs (This Employee)",
            "eas-tenant": "EAs (Tenant-Wide)",
            "scheduled": "scheduled",
            "effective": "effective",
            "cancelled": "cancelled"
          },
          "status": {
            "scheduled": "Scheduled",
            "effective": "Effective",
            "cancelled": "Cancelled",
            "unknown": "Unknown"
          },
          "field": {
            "effective-date": "Effective Date",
            "created-by": "By",
            "reason": "Reason"
          },
          "detail": {
            "col-from": "From",
            "col-to": "To",
            "job-profile": "Job Profile",
            "job-grade": "Job Grade",
            "org-unit": "Org Unit",
            "basic-salary": "Basic Salary",
            "employment-type": "Employment Type",
            "no-changes": "No detail fields recorded for this change."
          },
          "change-type": {
            "PROMOTE": "Promotion",
            "TRANSFER": "Transfer",
            "REDESIGNATION": "Re-Designation",
            "INVOLUNTARY_TERMINATION": "Involuntary Termination",
            "VOLUNTARY_TERMINATION": "Voluntary Termination",
            "SALARY_CHANGE": "Salary Change",
            "SALARY_INCREASE": "Salary Increase",
            "CHANGE_EMPLOYMENT_TYPE": "Employment Type Change",
            "RENEW": "Contract Renewal",
            "SUSPEND": "Suspension",
            "DEMOTE": "Demotion",
            "Unknown": "Unknown"
          },
          "modal": {
            "title-step1": "New Employment Action · {name}",
            "title-step2": "New Employment Action · {name}",
            "step1-desc": "Step 1 of 2 – choose the Employment Event Classification",
            "step2-desc": "Step 2 of 2 – {type} details",
            "for-label": "For:",
            "locked-from-profile": "Locked from Profile (cached)",
            "incoming-feature": "Incoming Feature",
            "upcoming-feature": "⏸ UPCOMING FEATURE",
            "not-actionable-banner": "This employee's status is Pending or Inactive — Employment Actions require an active contract. Use Rehire (Contract → New Contract Event) if they need to return.",
            "not-actionable-badge": "EMPLOYEE NOT ACTIVE",
            "field-effective-date": "Effective Date",
            "field-reason": "Reason",
            "field-reason-placeholder": "Provide a reason for this change",
            "field-org-unit": "Target Department / Org Unit",
            "field-org-unit-placeholder": "e.g. Sales, Finance",
            "field-salary": "New Basic Salary",
            "field-salary-placeholder": "e.g. 1200",
            "field-doc-ref": "Document Reference",
            "field-doc-ref-placeholder": "e.g. MEMO-2026-001, Letter ref",
            "file-upload-phase2": "File attachment — coming in Phase 2",
            "field-offline-approval": "Offline Approval",
            "offline-approval-label": "Offline approval completed (memo / letter / LM sign-off received)",
            "field-offline-notes": "Offline Approval Notes",
            "field-offline-notes-placeholder": "Notes about the offline approval process",
            "cancel": "Cancel",
            "back": "← Back",
            "submit": "Save Record",
            "saving": "Saving…",
            "error-type-required": "Please select an action type.",
            "error-date-required": "Effective date is required.",
            "error-reason-required": "Reason is required.",
            "error-no-contract": "No active contract found for this employee.",
            "error-salary-numeric": "Salary must be a valid number.",
            "error-save-failed": "Failed to save. Please try again.",
            "field-effective-date-hint": "Future date → Scheduled · Today or past → Effective",
            "promotion": {
              "info-banner": "Promotion = career progression in 2 modes. If only salary changes (no Grade · no Position · no Title) use Compensation tab → Salary Adjustment instead. If only title changes with no Grade/Salary increase use Re-Designation.",
              "mode-a-label": "Mode A",
              "mode-a-sub": "New seat in Org Chart",
              "mode-a-desc": "Move to a different Position that exists in the catalog",
              "mode-b-label": "Mode B",
              "mode-b-sub": "Same seat · better Grade or Level",
              "mode-b-desc": "No Position move · Grade must go up · Title change is optional",
              "mode-b-hint": "Mode B: No position move required. Ensure the new grade is higher than the current grade before saving.",
              "target-position": "Target Position",
              "target-position-placeholder": "Pick a target Position…",
              "target-position-hint": "Excludes the employee's current Position. Shows assignable seats only.",
              "companion-label": "Include Salary Adjustment in the same transaction",
              "companion-desc": "Uncheck to record promotion without a salary change.",
              "base-salary-label": "Base Salary",
              "base-salary-source-of-truth": "SOURCE OF TRUTH",
              "new-base-salary-label": "New Base Salary",
              "delta": "Change: USD {from} → USD {to} · {sign}USD {delta} · {sign}{pct}%",
              "error-target-required": "Target Position is required for Mode A.",
              "loading-positions": "Loading positions…",
              "no-positions-promote": "No vacant positions available at this grade.",
              "no-positions-transfer": "No positions available at the same grade."
            },
            "classification": {
              "PROMOTE": {
                "title": "Promotion",
                "desc": "Career progression · Mode A: new seat · Mode B: same seat better Grade"
              },
              "TRANSFER": {
                "title": "Transfer",
                "desc": "Operational movement · Department / Site / Branch · usually no grade change"
              },
              "REDESIGNATION": {
                "title": "Re-Designation",
                "desc": "Title change without career progression · no salary or grade increase (use Promotion if salary changes)"
              },
              "SALARY_CHANGE": {
                "title": "Salary Change",
                "desc": "Adjust base salary or allowances · effective from date · full audit trail"
              },
              "INVOLUNTARY_TERMINATION": {
                "title": "Involuntary Termination",
                "desc": "Dismissal, redundancy, or misconduct · permanently ends employment"
              },
              "VOLUNTARY_TERMINATION": {
                "title": "Voluntary Termination",
                "desc": "Employee resignation · permanently ends employment"
              }
            },
            "salary-change": {
              "info-banner": "Salary change updates the employee's base salary. A full audit trail is recorded with the effective date.",
              "current-label": "Current Base Salary",
              "new-label": "New Base Salary"
            },
            "termination": {
              "warning-title": "This action permanently ends employment",
              "warning-desc": "Ensure all offboarding steps are completed before saving. This cannot be undone from this screen.",
              "voluntary-note": "Voluntary termination — employee-initiated resignation.",
              "involuntary-note": "Involuntary termination — dismissal, redundancy, or misconduct.",
              "confirm-label": "I confirm this action and understand it permanently ends employment."
            }
          }
        },
        "personal": {
          "not-set": "—",
          "edit": "Edit",
          "history": {
            "title": "Change History",
            "empty": "No changes recorded yet."
          },
          "identity": {
            "title": "Identity",
            "first-name": "First Name",
            "last-name": "Last Name",
            "preferred-name": "Preferred Name",
            "gender": "Gender",
            "dob": "Date of Birth",
            "nationality": "Nationality",
            "marital-status": "Marital Status",
            "national-id": "National ID",
            "blood-type": "Blood Type"
          },
          "gov-ids": {
            "title": "Government IDs",
            "national-id": "National ID",
            "nssf": "NSSF",
            "tax-id": "Tax ID",
            "number": "Number",
            "issued": "Issued",
            "expires": "Expires",
            "authority": "Authority",
            "never": "Never"
          },
          "contact": {
            "title": "Contact & Address",
            "section-contact": "Contact",
            "section-address": "Address",
            "email": "Personal Email",
            "mobile": "Mobile Phone",
            "alt-phone": "Alternative Phone",
            "telegram": "Telegram",
            "whatsapp": "WhatsApp",
            "linkedin": "LinkedIn",
            "current-address": "Current Address",
            "modal": {
              "title": "Edit Contact & Address",
              "subtitle": "Changes are applied immediately",
              "cancel": "Cancel",
              "save": "Save",
              "saving": "Saving…",
              "error-save-failed": "Failed to save contact info. Please try again."
            }
          },
          "family": {
            "title": "Family & Dependents",
            "col-name": "Name",
            "col-relationship": "Relationship",
            "col-dob": "DOB",
            "col-national-id": "National ID",
            "col-tax-dependent": "Tax Dependent",
            "col-status": "Status",
            "col-actions": "Actions",
            "tax-note": "Tax dependents feed the Cambodia Tax on Salary (ToS) relief calculation in Payroll.",
            "yes": "Yes",
            "no": "No",
            "empty": "No family members recorded.",
            "btn-add": "Add Member",
            "delete-confirm": "Remove this family member?",
            "modal": {
              "add-title": "Add Family Member",
              "edit-title": "Edit Family Member",
              "subtitle": "Changes are logged immediately · no approval routing",
              "field-fullname": "Full Name",
              "field-relationship": "Relationship",
              "field-dob": "Date of Birth",
              "field-phone": "Phone",
              "field-email": "Email",
              "field-dependent": "Dependent (Tax Exemption)",
              "field-emergency": "Emergency contact",
              "field-occupation": "Occupation",
              "field-note": "Note",
              "cancel": "Cancel",
              "save": "Save",
              "saving": "Saving…",
              "error-name-required": "Full name is required.",
              "error-save-failed": "Failed to save. Please try again."
            }
          },
          "emergency": {
            "title": "Emergency Contacts",
            "primary": "Primary",
            "relationship": "Relationship",
            "phone": "Phone",
            "empty": "No emergency contacts recorded.",
            "btn-add": "Add Contact",
            "delete-confirm": "Remove this emergency contact?"
          },
          "bank": {
            "title": "Bank Account Reference",
            "managed-note": "Managed by Payroll Setup — view only here.",
            "bank": "Bank",
            "account-name": "Account Name",
            "account-number": "Account Number",
            "status": "Status",
            "empty": "No bank account on record.",
            "cash-no-bank": "Cash (no bank)"
          },
          "btn-history": "History",
          "active": "Active"
        },
        "benefits": {
          "banner-intro": "Insurance, entitlements, and non-cash employee programs.",
          "banner": "Cash compensation (salary, allowances) is managed under",
          "banner-link": "Compensation",
          "insurance-title": "Insurance & Statutory Benefits",
          "add": "Add",
          "no-benefits": "No insurance or statutory benefits on record.",
          "policy-id": "Policy ID",
          "scheme": "Scheme",
          "type": "Type",
          "enrolled": "Enrolled",
          "status-active": "Active",
          "status-enrolled": "Enrolled",
          "nssf-title": "NSSF (National Social Security Fund)",
          "nssf-subtitle": "Mandatory · Health + Pension",
          "nssf-id": "NSSF ID",
          "nssf-employment-type": "Employment Type",
          "nssf-employment-status": "Employment Status",
          "nssf-in-scheme": "In-scheme",
          "dependents-title": "Dependents",
          "no-dependents": "No dependents registered.",
          "add-dependent": "Add dependent",
          "delete-insurance": "Delete insurance"
        },
        "documents": {
          "title": "Documents",
          "upload": "Upload",
          "empty": "No documents on record.",
          "options": "Document options",
          "delete": "Delete document",
          "confirm-delete": "Delete",
          "confirm-delete-warning": "This cannot be undone.",
          "confirm-delete-yes": "Yes, delete",
          "confirm-delete-no": "Cancel"
        },
        "attendance": {
          "days-worked": "Days worked (Apr)",
          "overtime": "Overtime",
          "late-missed": "Late / Missed",
          "on-leave": "On leave",
          "leave-balances": "Leave Balances",
          "annual-leave": "Annual Leave",
          "sick-leave": "Sick Leave",
          "special-leave": "Special Leave",
          "maternity": "Maternity",
          "days": "days",
          "recent-attendance": "Recent Attendance",
          "col-day": "Day",
          "col-in": "In",
          "col-out": "Out",
          "col-hours": "Hours",
          "col-notes": "Notes"
        },
        "job": {
          "current-job": "Current Job",
          "modify": "Open Employment Action",
          "position": "Position",
          "department": "Department",
          "employment-type": "Employment Type",
          "contract-type": "Contract Type",
          "reports-to": "Reports To",
          "org-unit": "Org. Unit",
          "project-client": "Project / Client",
          "hire-date": "Hire Date",
          "subordinates": "Subordinates",
          "work-location": "Work Location",
          "working-hours": "Working Hours",
          "employment-change-note": "Position, department and contract changes are governed by {term} — every modification creates an auditable event with effective date, reason, and approval trail.",
          "employment-change-term": "Employment Change",
          "start-one": "Start one →",
          "gov-menu-title": "Choose Employment Change type",
          "gov-transfer": "Transfer",
          "gov-transfer-sub": "Change department / line manager / location",
          "gov-promotion": "Promotion",
          "gov-promotion-sub": "Move to higher position / grade",
          "gov-change-type": "Change Employment Type",
          "gov-change-type-sub": "e.g. Full-time ↔ Part-time / Outsourced",
          "gov-salary": "Salary Change",
          "gov-salary-sub": "Adjust base salary or allowances",
          "gov-renew": "Renew Contract",
          "gov-renew-sub": "Extend current contract end date",
          "gov-menu-title-danger": "Offboarding",
          "gov-suspend": "Suspend",
          "gov-suspend-sub": "Temporarily pause the employment",
          "gov-terminate-involuntary": "Involuntary Termination",
          "gov-terminate-involuntary-sub": "Dismissal, redundancy, or misconduct",
          "gov-terminate-voluntary": "Voluntary Termination",
          "gov-terminate-voluntary-sub": "Employee resignation",
          "emp-change-drawer": {
            "title": "Employment Change",
            "subtitle": "Record a formal employment change for this employee",
            "field-type": "Change Type",
            "field-type-placeholder": "Select change type",
            "field-effective-date": "Effective Date",
            "field-reason": "Reason",
            "field-reason-placeholder": "Describe the reason for this change",
            "field-to-org-unit": "New Department / Position",
            "field-to-org-unit-placeholder": "e.g. Finance – Senior Accountant",
            "field-to-salary": "New Basic Salary",
            "field-to-salary-placeholder": "e.g. 1200",
            "field-new-employment-type": "New Employment Type",
            "field-new-employment-type-placeholder": "Select type",
            "field-suspend-until": "Suspended Until",
            "field-new-contract-end-date": "New Contract End Date",
            "warning-destructive-title": "This action affects employment status",
            "warning-destructive-body": "Please review carefully before saving. This change will be recorded in the employee's employment history.",
            "confirm-destructive": "I confirm this action is approved and correctly recorded",
            "error-type-required": "Please select a change type",
            "error-date-required": "Effective date is required",
            "error-reason-required": "Please provide a reason",
            "error-confirm-required": "Please confirm this action before saving",
            "error-no-contract": "No active contract found — please create a contract first",
            "error-salary-numeric": "Salary must be a valid number",
            "error-save-failed": "Failed to save. Please try again.",
            "cancel": "Cancel",
            "save": "Save Change",
            "saving": "Saving…",
            "type": {
              "TRANSFER": "Transfer",
              "PROMOTE": "Promotion",
              "SALARY_CHANGE": "Salary Change",
              "SALARY_INCREASE": "Salary Increase",
              "CHANGE_EMPLOYMENT_TYPE": "Change Employment Type",
              "INVOLUNTARY_TERMINATION": "Involuntary Termination",
              "VOLUNTARY_TERMINATION": "Voluntary Termination",
              "DEMOTE": "Demotion",
              "REDESIGNATION": "Redesignation",
              "SUSPEND": "Suspend",
              "RENEW": "Renew Contract",
              "Unknown": "Unknown Change"
            }
          }
        },
        "overview": {
          "tenure": "Tenure",
          "status": "Status",
          "current-package": "Current package",
          "recurring-month": "Recurring / month",
          "reports-to": "Reports To",
          "no-manager": "No line manager assigned",
          "compliance": "Compliance",
          "nssf-enrolled": "NSSF enrolled",
          "not-enrolled": "Not enrolled",
          "tax-declaration": "Tax (ToSI) declaration filed",
          "contract-signed": "Contract signed",
          "health-check-due": "Annual health check due",
          "quick-facts": "Quick Facts",
          "working-hours": "Working Hours",
          "workspace": "Workspace",
          "time-zone": "Time Zone",
          "language": "Language",
          "personal-info": "Personal Information",
          "view-full-personal": "View Full Personal Information →",
          "nationality": "Nationality",
          "personal-phone": "Personal Phone",
          "personal-email": "Personal Email",
          "emergency-contact": "Emergency Contact"
        },
        "external": {
          "chip": "External Staff",
          "personal-info": "Personal Information",
          "latin-name": "Latin Name",
          "native-name": "Native Name",
          "gender": "Gender",
          "status": "Status",
          "reporting-structure": "Reporting & Team Structure",
          "org-unit": "Organizational Unit",
          "role": "Role",
          "report-to-role": "Report To Role",
          "subordinates": "Subordinates",
          "line-manager": "Line Manager",
          "no-manager": "No line manager assigned",
          "view-subordinates": "View"
        },
        "subordinates-modal": {
          "title": "Subordinates",
          "search-placeholder": "Search by keyword…",
          "col-name": "Full Name",
          "col-code": "Employee ID",
          "col-status": "Status",
          "col-org-unit": "Org. Unit",
          "col-position": "Position",
          "empty": "No subordinates found.",
          "no-match": "No subordinates match \"{query}\".",
          "loading": "Loading subordinates…",
          "error": "Failed to load subordinates.",
          "retry": "Retry",
          "showing-range": "Showing {from}–{to} of {total}",
          "rows-per-page": "Rows per page",
          "prev": "Previous page",
          "next": "Next page"
        },
        "journey": {
          "title": "Employment Journey",
          "subtitle": "Lifecycle timeline of every Employment Change event · system of record for audit",
          "empty": "No employment change events on record.",
          "reason-label": "Reason",
          "doc-label": {
            "promote": "View promotion letter",
            "transfer": "View transfer letter",
            "salary": "View salary amendment letter",
            "change-employment-type": "View employment type change letter",
            "termination": "View termination letter",
            "joined": "View employment contract",
            "probation-passed": "View probation confirmation",
            "default": "View supporting letter"
          },
          "kpi": {
            "total": "total events",
            "years": "years",
            "pending": "pending"
          },
          "state": {
            "applied": "applied",
            "pending": "pending"
          },
          "event-type": {
            "joined": "Joined Company",
            "probation-passed": "Probation Passed"
          },
          "event": {
            "hired-summary": "Initial hire",
            "hired-reason": "Initial recruitment",
            "probation-summary": "Probation period completed · confirmed in role",
            "probation-reason": "Successful probation review"
          }
        },
        "identity-modal": {
          "title": "Edit Identity",
          "subtitle": "Update name, gender, and work contact details",
          "section-latin": "Latin Name",
          "section-native": "Native Name",
          "section-work-contacts": "Work Contacts",
          "field-latin-first": "First Name",
          "field-latin-last": "Last Name",
          "field-nickname": "Nickname",
          "field-gender": "Gender",
          "field-native-first": "First Name (Native)",
          "field-native-last": "Last Name (Native)",
          "field-work-email": "Work Email",
          "field-work-phone": "Work Phone",
          "section-personal": "Personal Details",
          "field-dob": "Date of Birth",
          "field-nationality": "Nationality",
          "field-marital-status": "Marital Status",
          "field-national-id": "National ID",
          "field-national-id-placeholder": "e.g. 012345678",
          "field-blood-type": "Blood Type",
          "loading": "Loading…",
          "no-results": "No results",
          "pim-note": "",
          "audit-note": "Changes are logged for audit.",
          "save": "Save",
          "cancel": "Cancel",
          "saving": "Saving…",
          "error-name-required": "First name and last name are required.",
          "error-save-failed": "Failed to save. Please try again."
        },
        "document-modal": {
          "title": "Upload Document",
          "drop-zone-label": "Click or drag a file here to upload",
          "drop-zone-cta": "Drag & drop a file here",
          "drop-zone-hint": "or click to browse · PDF, DOC, JPG, PNG accepted",
          "field-name": "Filename",
          "field-name-placeholder": "e.g. Performance review 2026.pdf",
          "field-group": "Document Group",
          "field-group-placeholder": "Select group",
          "group-personal": "Personal",
          "group-spouse": "Spouse",
          "group-children": "Children",
          "field-description": "Description",
          "field-description-placeholder": "Brief note about this document",
          "info-banner": "Filename and document group are required so HR can find and categorise it later.",
          "upload": "Upload",
          "cancel": "Cancel",
          "uploading": "Uploading…",
          "field-type": "Document Type",
          "field-type-placeholder": "Select document type",
          "field-fam-member": "Family Member",
          "field-fam-member-placeholder": "Select child",
          "no-spouse": "No spouse on record for this employee.",
          "no-children": "No children on record for this employee.",
          "error-file-required": "Please select a file to upload.",
          "error-name-required": "Filename is required.",
          "error-group-required": "Please select a document group.",
          "error-type-required": "Please select a document type.",
          "error-fam-required": "Please select a family member.",
          "error-upload-failed": "Upload failed. Please try again."
        },
        "contract-modal": {
          "title-create": "New Contract",
          "title-edit": "Edit Contract",
          "subtitle": "Define contract type, dates, and compensation",
          "section-type": "Contract Type",
          "section-dates": "Dates",
          "section-compensation": "Compensation",
          "field-type": "Contract Type",
          "field-type-placeholder": "Select contract type",
          "field-employment-type": "Employment Type",
          "field-employment-type-placeholder": "Select employment type",
          "field-start": "Start Date",
          "field-end": "End Date (leave blank for open-ended)",
          "field-probation-start": "Probation Start",
          "field-probation-end": "Probation End",
          "field-salary": "Basic Salary",
          "field-salary-placeholder": "Monthly amount",
          "save": "Save",
          "cancel": "Cancel",
          "saving": "Saving…",
          "error-type-required": "Contract type is required.",
          "error-start-required": "Start date is required.",
          "error-salary-numeric": "Salary must be a number.",
          "error-save-failed": "Failed to save. Please try again."
        },
        "insurance-modal": {
          "title-add": "Add Insurance",
          "title-edit": "Edit Insurance",
          "subtitle": "Private health, life, and supplementary insurance plans",
          "field-type": "Insurance Type",
          "field-type-placeholder": "Select type",
          "field-policy-id": "Policy ID",
          "field-policy-id-placeholder": "Policy reference number",
          "field-insurer": "Insurer Name",
          "field-insurer-placeholder": "e.g. Prudential",
          "field-scheme": "Scheme",
          "field-scheme-placeholder": "e.g. Premium Plan",
          "loading": "Loading…",
          "no-results": "No results",
          "field-employment-type": "Employment Type",
          "field-employment-type-placeholder": "Select employment type",
          "field-employment-type-formal": "Formal (ក្នុងប្រព័ន្ធ)",
          "field-employment-type-informal": "Informal (ក្រៅប្រព័ន្ធ)",
          "field-employment-status": "Employment Status",
          "field-employment-status-placeholder": "Select employment status",
          "field-employment-status-active": "Active (កំពុងធ្វើការ)",
          "field-employment-status-maternity": "Maternity Leave (លំហែរមាតុភាព)",
          "field-employment-status-sickness": "Sickness Treatment (កំពុងព្យាបាលជំងឺ)",
          "save": "Save",
          "cancel": "Cancel",
          "saving": "Saving…",
          "confirm-delete": "Delete this insurance record? This cannot be undone.",
          "confirm-delete-yes": "Yes, delete",
          "confirm-delete-no": "Cancel",
          "error-type-required": "Insurance type is required.",
          "error-policy-required": "Policy ID is required.",
          "error-save-failed": "Failed to save. Please try again."
        },
        "employment-action-modal": {
          "title": "Employment Change",
          "subtitle": "All changes create an auditable event in the Employment Journey",
          "field-type": "Change Type",
          "field-type-placeholder": "Select change type",
          "field-effective-date": "Effective Date",
          "field-reason": "Reason",
          "field-reason-placeholder": "Describe the reason for this change",
          "field-to-salary": "New Basic Salary",
          "field-to-salary-placeholder": "Monthly amount",
          "field-to-org-unit": "To Org. Unit / Department",
          "field-to-org-unit-placeholder": "e.g. Engineering",
          "field-new-employment-type": "New Employment Type",
          "type": {
            "PROMOTE": "Promotion",
            "TRANSFER": "Transfer",
            "SALARY_CHANGE": "Salary Change",
            "CHANGE_EMPLOYMENT_TYPE": "Change Employment Type",
            "INVOLUNTARY_TERMINATION": "Involuntary Termination",
            "VOLUNTARY_TERMINATION": "Voluntary Termination"
          },
          "save": "Submit",
          "cancel": "Cancel",
          "saving": "Submitting…",
          "warning-destructive-title": "This action affects employment status",
          "confirm-destructive": "I confirm this action is approved and correctly recorded",
          "error-type-required": "Please select a change type.",
          "error-date-required": "Effective date is required.",
          "error-reason-required": "Reason is required.",
          "error-confirm-required": "Please confirm this action before saving.",
          "error-no-contract": "No active contract found for this employee.",
          "error-salary-numeric": "Salary must be a number.",
          "error-save-failed": "Failed to submit. Please try again."
        },
        "renew-contract-modal": {
          "title": "Renew Contract",
          "subtitle": "{name} · Current contract: {type}",
          "banner": "This will create a new contract record. The previous contract will remain in All Contracts history.",
          "field-type": "New Contract Type",
          "field-type-placeholder": "Select contract type",
          "field-employment-type": "Employment Type",
          "field-start-date": "Start Date",
          "field-start-date-hint": "Automatically set to the day after the current contract ends.",
          "field-end-date": "End Date",
          "field-salary": "Basic Salary",
          "field-salary-placeholder": "e.g. 1200",
          "field-position": "Position (Org Chart)",
          "field-position-placeholder": "Select a vacant position",
          "field-position-hint": "Optional — links this contract to a vacant position in the org chart.",
          "position-loading": "Loading positions…",
          "position-empty": "No vacant positions available.",
          "field-reason": "Reason",
          "field-reason-placeholder": "Reason for renewal",
          "error-start-required": "Start date is required.",
          "error-end-required": "End date is required for this contract type.",
          "error-end-after-start": "End date must be after the start date.",
          "error-reason-required": "Reason is required.",
          "error-save-failed": "Failed to save. Please try again.",
          "cancel": "Cancel",
          "back": "Back",
          "next": "Next",
          "confirm": "Confirm & Renew",
          "confirming": "Renewing…",
          "save": "Renew Contract",
          "saving": "Saving…",
          "step-1": "Contract",
          "step-2": "Annual Leave",
          "step-3": "Review",
          "al-heading": "Annual Leave Setup",
          "al-description": "Specify how to handle the remaining leave balance from the previous contract.",
          "al-current-balance": "Current AL Balance",
          "al-current-taken": "AL Taken",
          "al-entitlement-preview-heading": "AL Entitlement Preview",
          "al-entitled-this-contract": "AL Entitled Under This Contract",
          "al-seniority-bonus": "Seniority Bonus",
          "al-entitlement-as-of": "As of {date}, based on the company's Leave policy",
          "al-days": "days",
          "al-carry-forward-label": "Carry forward remaining AL balance?",
          "al-carry-forward-yes": "Yes, carry forward",
          "al-carry-forward-no": "No, reset to zero",
          "al-prev-amount": "AL Balance to Carry Forward",
          "al-prev-amount-hint": "Days of annual leave balance to carry into the new contract.",
          "al-taken": "AL Taken This Period",
          "al-taken-hint": "Days of annual leave already taken during the current contract period.",
          "review-heading": "Review & Confirm",
          "review-description": "Please review the renewal details before confirming.",
          "review-contract": "Contract Details",
          "review-al": "Annual Leave Setup",
          "review-type": "Contract Type",
          "review-employment-type": "Employment Type",
          "review-start-date": "Start Date",
          "review-end-date": "End Date",
          "review-salary": "Basic Salary",
          "review-position": "Position",
          "review-position-none": "Not specified",
          "review-reason": "Reason",
          "review-carry-forward": "Carry Forward AL",
          "review-carry-amount": "Carry Forward Amount",
          "review-al-taken": "AL Taken",
          "error-al-setup-failed": "Contract created. Annual leave setup could not be completed — please configure it manually in the Compensation tab."
        },
        "new-contract-modal": {
          "title": "New Contract",
          "subtitle": "{name} · First contract setup",
          "confirm": "Confirm & Create"
        },
        "rehire-contract-modal": {
          "title": "Rehire Employee",
          "subtitle": "{name} · Former contract: {type}",
          "banner": "This will create a new contract for a returning employee. Their prior contract remains in All Contracts history.",
          "error-start-overlaps": "Start date must be after the employee's previous contract ended.",
          "error-start-no-gap": "This start date immediately follows the previous contract's end date — that's a Renewal, not a Rehire. Use Renew Contract, or pick a later start date if there was an actual employment gap.",
          "confirm": "Confirm & Rehire"
        },
        "contract-event-modal": {
          "title": "New Contract Event",
          "subtitle": "{name} · Current contract: {type} · Phase 1 · recording only",
          "policy-banner-prefix": "is currently on a",
          "policy-banner-suffix": "contract.",
          "badge-not-terminated": "Available after termination",
          "badge-pending-contract": "Pending contract already exists",
          "cancel": "Cancel",
          "back": "Back",
          "save": "Save Record",
          "saving": "Saving…",
          "policy-note": {
            "UDC": "UDC is open-ended · no renewal/extension applies. Amendment for mid-term changes; Termination to end the contract.",
            "FDC": "FDC term-based · can be renewed, extended, converted to UDC, amended mid-term, or terminated. Cambodia Labour Law caps total FDC duration at 2 years.",
            "Probation": "During probation · confirm (pass), extend (need more time), convert to FDC/UDC after passing, or terminate.",
            "Internship": "Internship · convert to FDC/UDC if hiring, otherwise terminate at end of internship.",
            "Outsourcing Service": "Outsourcing Service contract · amend scope/terms or terminate engagement. Renewal handled by vendor SOW.",
            "none": "No current contract on file · only New Contract applies. Use this for first contract on hire."
          },
          "type": {
            "new_contract": {
              "label": "New Contract",
              "desc": "First contract on hire (or contract restart after gap)",
              "date-label": "Contract Start Date"
            },
            "contract_renewal": {
              "label": "Contract Renewal",
              "desc": "FDC or UDC renewed for a new term",
              "date-label": "Renewal Effective Date"
            },
            "rehire": {
              "label": "Rehire Employee",
              "desc": "Bring a former employee back under a new contract",
              "date-label": "Rehire Start Date"
            },
            "contract_extension": {
              "label": "Contract Extension",
              "desc": "Existing contract extended within current term",
              "date-label": "Extension Start Date"
            },
            "contract_conversion": {
              "label": "Contract Conversion",
              "desc": "Change contract type (e.g. FDC → UDC)",
              "date-label": "Conversion Effective Date"
            },
            "contract_amendment": {
              "label": "Contract Amendment",
              "desc": "Mid-term amendment (hours, location terms, clauses)",
              "date-label": "Amendment Effective Date"
            },
            "probation_confirmation": {
              "label": "Probation Confirmation",
              "desc": "Probation passed · employee confirmed",
              "date-label": "Confirmation Date"
            },
            "probation_extension": {
              "label": "Probation Extension",
              "desc": "Probation extended for additional period",
              "date-label": "New Probation End Date"
            },
            "termination_record": {
              "label": "Termination Record",
              "desc": "Administrative termination record",
              "date-label": "Effective Termination Date"
            }
          },
          "form": {
            "subtitle": "Record this contract change · Phase 1",
            "phase1-label": "Phase 1 · Recording only.",
            "phase1-desc": "Record the offline contract change (signed memo / letter). Approval workflow comes in Phase 2.",
            "field-new-contract-type": "New Contract Type",
            "field-new-end-date": "New End Date",
            "field-new-end-date-hint": "Required for FDC contracts.",
            "field-new-probation-end-date": "New Probation End Date",
            "field-probation-originally-ended": "Probation Originally Ended",
            "field-reason": "Reason / Notes",
            "field-reason-placeholder": "Why this contract change?",
            "field-doc-ref": "Document Reference",
            "field-doc-ref-placeholder": "Filename / reference (e.g., ContractRenewal-2026-007.pdf)",
            "file-upload-phase2": "File attachment — Phase 2",
            "field-offline-approval": "Offline Approval",
            "offline-approval-label": "Offline approval completed — signed offline by LM / HR / Employee",
            "field-offline-notes": "Offline Approval Notes",
            "field-offline-notes-placeholder": "Notes — e.g., Signed by employee 2026-06-28, filed in personnel file",
            "error-date-required": "Effective date is required.",
            "error-reason-required": "Reason / Notes is required.",
            "error-save-failed": "Failed to save. Please try again.",
            "validation-summary-invalid": "✗ Effective date and reason are required",
            "validation-summary-ok": "✓ Ready to save · status will be {status}",
            "status-scheduled": "Scheduled",
            "status-effective": "Effective"
          }
        }
      },
      "batch-import": {
        "title": "Import Employees",
        "subtitle": "Batch import employees from Excel with validation and duplicate detection.",
        "tab": {
          "new-import": "New Import",
          "history": "Import History"
        },
        "steps": {
          "upload": "Upload file",
          "validation": "Validation",
          "confirm": "Confirm"
        },
        "mode": {
          "label": "Import Mode",
          "add-label": "Add new only",
          "add-desc": "Create new employee records. Employee Code is optional (auto-generated if blank).",
          "update-label": "Update existing",
          "update-desc": "Update existing records by Employee Code. Rows without a valid Employee Code cannot be updated.",
          "note": "For updates, Employee Code is the unique matching key. The system will not match by name, email, or phone to avoid incorrect updates."
        },
        "upload": {
          "tip": "New here? Download the template first to see required columns, then fill in your employees and drop the file back here.",
          "tip-link": "Download the template",
          "download-template": "Download template",
          "export-existing": "Export existing employees",
          "drop-label": "Drop your file here, or click to browse",
          "drop-hint": "Excel (.xlsx) · up to 5 MB · max 5,000 rows · preview shows first 500",
          "remove": "Remove file",
          "preview-truncated": "Preview limited to {cap} of {total} rows — the full file will be validated server-side."
        },
        "validation": {
          "col-errors": "Column Errors",
          "total": "Total: {n}",
          "valid": "Valid: {n}",
          "invalid": "Invalid: {n}",
          "warnings": "Warnings: {n}",
          "status": "Status",
          "issues": "Issues",
          "export-result": "Export result",
          "required": "required",
          "issues-expand": "{n} issues — click to expand",
          "show-less": "Show less"
        },
        "confirm": {
          "summary": "Ready to import",
          "mode": "Mode",
          "rows": "Total rows",
          "valid": "Valid",
          "invalid": "Invalid (will be skipped)",
          "dl-results": "Import Results",
          "dl-credentials": "User Credentials",
          "dl-original": "Original File",
          "errors-label": "Import Errors ({n})"
        },
        "progress": {
          "completed": "Import complete",
          "completed-errors": "Import completed with errors",
          "failed": "Import failed",
          "in-progress": "Importing employees…",
          "detail": "{succeeded} of {total} imported successfully",
          "error-msg": "Import encountered an error.",
          "processing": "Processing {done} of {total}…",
          "detail-failed-suffix": ", {failed} failed"
        },
        "row": {
          "pending": "Pending",
          "valid": "Valid",
          "invalid": "Invalid",
          "warning": "Warning"
        },
        "history": {
          "loading": "Loading import history…",
          "empty": "No import history yet.",
          "completed": "Completed",
          "completed-errors": "Completed with errors",
          "failed": "Failed",
          "imported": "imported",
          "failed-rows": "failed",
          "batch-id": "Batch ID",
          "results": "Results",
          "dl-original": "Original Upload",
          "dl-results": "Import Results",
          "dl-credentials": "User Credentials",
          "processing": "Processing",
          "processing-note": "Import in progress — files will be available once complete.",
          "results-detail": "{succeeded} succeeded, {failed} failed / {total} total"
        },
        "btn": {
          "back": "Back",
          "done": "Done"
        },
        "next": {
          "validation": "Next: Validation",
          "confirm": "Next: Confirm",
          "import": "Import"
        },
        "error": {
          "invalid-format": "Please select a valid .xlsx file.",
          "file-too-large": "File exceeds 5 MB limit. Please choose a smaller file.",
          "empty-file": "The uploaded file has the correct format but contains no employee records.",
          "template-mismatch": "The uploaded file does not match the expected template format.",
          "missing-columns": "Missing columns",
          "unexpected-columns": "Unexpected columns",
          "read-failed": "Could not read the file. Please check the file format.",
          "validation-failed": "Validation failed. Please try again.",
          "import-failed": "Import failed. Please try again.",
          "download-failed": "Failed to download file. The file may not be available yet.",
          "template-failed": "Failed to download template. Please try again.",
          "export-failed": "Failed to export employees. Please try again.",
          "import-timeout": "Import is taking longer than expected. Check Import History for the final result."
        },
        "instructions": {
          "title": "Instructions & Requirements",
          "general": "General",
          "no-delete-headers": "Do not delete rows at the top or edit any column headers — the system may not understand the format of your uploaded file.",
          "required-cols": "Columns marked with an asterisk (*) are required. Validation will check for completeness, data types, and formatting.",
          "max-size": "Maximum file size: 5 MB.",
          "unique-note": "Unique values (e.g., National_id) are validated only within the uploaded file, not against existing employees in the system.",
          "dates": "Date Columns",
          "date-format": "Enter all dates in ISO format: YYYY-MM-DD (e.g., 2022-10-25).",
          "key-cols": "Key Column Notes",
          "employee-code": "Employee_code — Optional. If filled, refers to an existing employee for updating. If left empty in \"Add new only\" mode, the system assigns a code automatically.",
          "contract-type": "Contract_type — Enter FDC, UDC, or PROBATION.",
          "contract-end-date": "Contract_end_date — Required if the contract type is not UDC (Undetermined Duration Contract).",
          "report-to": "Report_to — Must be the Employee_code of an existing employee or of a new employee in the same file. Leave empty for the top-level employee.",
          "username": "Username / User_email — Creating an employee profile includes creating a linked user account. A sign-in email will be sent automatically.",
          "repeatable": "Repeatable Column Sets",
          "repeatable-note": "Some columns work as grouped sets. You can add more sets by duplicating the column headers:",
          "repeatable-complete": "Each set must be complete — partial sets will fail validation."
        }
      }
    },
    "common": {
      "cancel": "Cancel",
      "save": "Save",
      "edit": "Edit",
      "retry": "Retry",
      "confirm": "Confirm",
      "yes": "Yes",
      "no": "No",
      "remove": "Remove",
      "create": "Create",
      "clear": "Clear",
      "clear-all": "Clear all",
      "previous": "Previous",
      "next": "Next"
    },
    "organization": {
      "title": "Organization",
      "tabs": {
        "profile": "Profile",
        "structure": "Structure",
        "sites": "Sites",
        "outsourcing": "Outsourcing"
      },
      "kind": {
        "company": "Company",
        "os_client": "Client",
        "os_vendor": "Vendor",
        "os_project": "Project",
        "unknown": "Unknown"
      },
      "structure": {
        "org-units": "Org Units",
        "org-chart": "Org Chart",
        "positions": "Positions",
        "workforce-plan": "Workforce Plan",
        "grades": "Job Grades",
        "job-titles": "Job Titles",
        "job-profiles": "Job Profiles"
      },
      "profile": {
        "edit": "Edit",
        "edit-title": "Edit company",
        "industry": "Industry",
        "employee-id-format": "Employee ID format",
        "website": "Website",
        "address": "Address",
        "primary-contact": "Primary contact"
      },
      "form": {
        "company-full-name": "Company full name",
        "company-short-name": "Company short name",
        "project-full-name": "Project full name",
        "project-short-name": "Project short name",
        "short-name-hint": "Used as a compact label and as the employee ID prefix.",
        "client": "Client",
        "client-none": "No parent client",
        "employee-id-format": "Employee ID format",
        "employee-id-format-hint": "Defaults to <short name>-000000. Editable.",
        "industry": "Industry",
        "website": "Website",
        "address": "Address",
        "primary-contact": "Primary contact",
        "contact-name": "Name",
        "contact-email": "Email",
        "contact-phone": "Phone",
        "notes": "Notes",
        "create": "Create",
        "errors": {
          "full-name": "Name is required.",
          "email": "Enter a valid email address."
        },
        "outsourcing-client-flag": "Is this an outsourcing client?",
        "outsourcing-client-hint": "Mark this company as an outsourcing client. You manage their projects, staff, and external approvers.",
        "outsourcing-vendor-flag": "Is this an outsourcing vendor?",
        "outsourcing-vendor-hint": "Mark this company as an outsourcing vendor. You track their workers operationally; the vendor runs payroll."
      },
      "outsourcing": {
        "shell-title": "Outsourcing",
        "shell-desc": "Manage outsourcing clients or vendors, their projects, and external approvers from here.",
        "shell-note": "Coming soon.",
        "clients-title": "Clients",
        "clients-section-desc": "Outsourcing customers you provide staff to. Add a client when you take on a new outsourcing engagement.",
        "vendors-title": "Vendors",
        "vendors-section-desc": "Outsourcing providers who supply staff to you. Add a vendor when you start sourcing staff from a new provider.",
        "add-client": "Add Client",
        "add-vendor": "Add Vendor",
        "create-subtitle": "Outsourcing details auto-provision a full, independent config set.",
        "search-label": "Search",
        "search-placeholder": "Search by name, contact, industry…",
        "showing-clients": "Showing {filtered} of {total} clients",
        "showing-vendors": "Showing {filtered} of {total} vendors",
        "empty-clients": "No clients yet. Add your first outsourcing client.",
        "empty-vendors": "No vendors yet. Add your first outsourcing vendor.",
        "empty-filtered": "No counterparties match the current search.",
        "error": "Failed to load this list.",
        "error-403": "You don't have access to this list.",
        "back-clients": "Back to Clients",
        "back-vendors": "Back to Vendors",
        "projects-title": "Projects",
        "approvers-title": "Approvers",
        "projects-empty": "No projects under this counterparty yet.",
        "projects-error": "Failed to load projects.",
        "back-to-projects": "Back to projects",
        "project-under": "Under {parent}",
        "positions-title": "Positions",
        "positions-count": "{filled} filled · {vacant} vacant · {total} total",
        "positions-empty": "This project's org chart has no positions yet.",
        "positions-error-title": "Couldn't load positions",
        "positions-error-desc": "Something went wrong loading this project's org chart.",
        "position-vacant": "Vacant",
        "position-untitled": "Untitled position",
        "add-project": "Add Project",
        "edit-project": "Edit project",
        "detail-error-title": "Couldn't load this counterparty",
        "detail-error-desc": "Something went wrong fetching the details. Try again.",
        "toasts": {
          "created": "\"{name}\" created.",
          "create-failed": "Could not create. Try again.",
          "saved": "Changes saved.",
          "save-failed": "Could not save. Try again.",
          "project-created": "Project \"{name}\" created.",
          "project-saved": "Project saved.",
          "project-failed": "Could not save the project. Try again."
        },
        "oversight-title": "Executive Oversight"
      },
      "approvers": {
        "title": "External Approvers",
        "invite": "Invite approver",
        "explainer": "An external approver is a client-side line manager placed into a vacant role in this project's org chart. They approve leave and attendance for the project's staff. Inviting one emails them an Accept link; accepting provisions an ESS sign-in scoped to this project.",
        "counterparty-explainer": "External approvers are client-side line managers placed into vacant roles in your projects' org charts. They approve leave and attendance for project staff. The same person can oversee several projects; each placement is set up per project. Inviting one emails an Accept link that provisions an ESS sign-in scoped to that project.",
        "oversees": "Oversees {n} project(s)",
        "edit-in-project": "Edit placement in {project}",
        "target-project": "Project",
        "target-project-placeholder": "Choose which project to place the approver in",
        "empty-no-projects": "Add a project first, then invite approvers to oversee it.",
        "search-placeholder": "Search by name, code, email, phone…",
        "showing": "{n} approver(s)",
        "empty": "No external approvers yet. Invite one to approve requests for this counterparty's projects.",
        "empty-filtered": "No approvers match your filters.",
        "error": "Couldn't load approvers.",
        "filters": {
          "all": "All"
        },
        "status": {
          "active": "Active",
          "invited": "Invited",
          "inactive": "Inactive",
          "unknown": "Unknown"
        },
        "invite-modal": {
          "title": "Invite external approver"
        },
        "edit": {
          "title": "Edit external approver",
          "status": "Status"
        },
        "form": {
          "latin-name": "Latin name",
          "latin-name-placeholder": "e.g. Sok Somnang",
          "native-name": "Native name",
          "native-name-placeholder": "e.g. សុខ សំណាង",
          "gender": "Gender",
          "gender-male": "Male",
          "gender-female": "Female",
          "email": "Work email",
          "email-placeholder": "e.g. name\\@client.com",
          "phone": "Phone number",
          "phone-placeholder": "e.g. 012 345 678",
          "placement-heading": "Org-chart placement",
          "org-unit": "Organizational unit",
          "org-unit-placeholder": "Select an org unit",
          "report-to": "Report to role",
          "report-to-placeholder": "Select who they report to",
          "report-to-none": "(Report to no one)",
          "position": "Role",
          "position-placeholder": "Select a vacant role",
          "position-hint": "These are unfilled roles in this project's org chart. If a role isn't listed, create it first in the org-chart screen.",
          "create": "Create"
        },
        "toasts": {
          "invite-sent": "External approver created — an invite was emailed.",
          "invite-failed": "Could not create the approver. Try again.",
          "saved": "Saved changes.",
          "save-failed": "Could not save. Try again."
        }
      },
      "error": {
        "title": "Couldn't load this company",
        "desc": "Something went wrong fetching the company details. Try again."
      },
      "no-company": {
        "title": "No company selected",
        "desc": "Pick a company from the switcher to view its profile, policies, and structure."
      },
      "company-form": {
        "drawer-title": "Create new company",
        "drawer-subtitle": "Add a new company under your tenant. It will appear in the scope switcher once created.",
        "emails": "Email addresses",
        "email-n": "Email #{n}",
        "add-email": "Add another email",
        "phones": "Phone numbers",
        "phone-n": "Phone #{n}",
        "add-phone": "Add another phone",
        "representatives": "Representatives",
        "representative-n": "Representative #{n}",
        "add-representative": "Add another representative",
        "toasts": {
          "created": "\"{name}\" created.",
          "create-failed": "Could not create the company. Try again."
        },
        "base-location": {
          "legend": "Primary base location",
          "name": "Location name",
          "name-placeholder": "e.g. Head Office",
          "address": "Address",
          "address-placeholder": "Street, building, district…",
          "coordinates": "Coordinates (latitude, longitude)",
          "coordinates-hint": "Set by clicking or dragging the pin on the map, or type them directly.",
          "map-label": "Map — click or drag the pin to set the location",
          "error": "A location name and a valid coordinate are required."
        }
      },
      "org-chart-editor": {
        "title": "Org Chart",
        "subtitle": "Build and edit positions and reporting lines for this company.",
        "canvas-title": "Org Chart",
        "layer-1": "Layer 1",
        "info-banner": "shows every position and its reporting line. Use a position’s menu to add, edit, move, swap, disable, or delete it. Pan by dragging the canvas; zoom with the wheel or toolbar.",
        "vacant": "Vacant",
        "untitled": "Untitled position",
        "actions-menu": "Position actions",
        "actions-for": "Position actions",
        "expand": "Expand",
        "collapse": "Collapse",
        "search-ph": "Search position, unit, or person…",
        "error-header": "Org chart",
        "status": {
          "active": "Active",
          "pending": "Pending",
          "probation": "Probation",
          "on-leave": "On leave",
          "inactive-vacant": "Inactive / Vacant"
        },
        "counter": {
          "vacant": "Vacant {n}",
          "disabled": "Disabled {n}"
        },
        "nav": {
          "title": "Position Navigation",
          "hint": "Click to focus a sub-tree",
          "hide": "Hide navigation",
          "show": "Show navigation",
          "short": "Nav",
          "empty": "No positions match your search."
        },
        "toolbar": {
          "show-vacancies": "Show vacancies",
          "default-view": "Default view",
          "expand-all": "Expand all",
          "collapse-all": "Collapse all",
          "zoom-out": "Zoom out",
          "zoom-in": "Zoom in",
          "zoom-100": "Reset to 100%",
          "zoom-fit": "Fit to screen",
          "reset-zoom": "Reset pan & zoom",
          "reset-focus": "Back to full chart"
        },
        "chart": {
          "showing-focused": "Showing the sub-tree under {name}. Use “Back to full chart” to exit focus."
        },
        "action": {
          "edit": "Edit position",
          "add-child": "Add child position",
          "move": "Move position",
          "delete": "Delete position",
          "disable": "Disable position",
          "enable": "Enable position",
          "swap": "Swap role",
          "manage-roles": "Manage additional roles",
          "temp-oversight-on": "Enable temporary oversight",
          "temp-oversight-off": "Disable temporary oversight"
        },
        "form": {
          "add-title": "Add child position",
          "edit-title": "Edit position",
          "org-unit": "Organizational unit",
          "org-unit-ph": "e.g. Department of Marketing",
          "reports-to": "Reports to",
          "top-most": "Top-most position",
          "job-title": "Job title",
          "job-title-ph": "e.g. Software Engineer",
          "base-location": "Base location",
          "base-location-ph": "Select a base location",
          "base-location-loading": "Loading locations…",
          "base-location-empty": "No base locations defined",
          "advanced": "Advanced update options",
          "cascade-org-unit": "Also apply this org unit to all child positions.",
          "cascade-title": "Also update other positions using the same job title.",
          "required": "Required",
          "create": "Create"
        },
        "move": {
          "title": "Move position",
          "current": "Current reporting line",
          "new": "New reporting line",
          "new-ph": "Select a new manager",
          "warning": "Changing the reporting line updates the hierarchy immediately."
        },
        "swap": {
          "title": "Swap role",
          "current": "Current occupant",
          "with": "Swap with",
          "with-ph": "Select a position",
          "reason": "Reason",
          "reason-ph": "Why are these roles being swapped?",
          "submit": "Swap"
        },
        "manage-roles": {
          "title": "Manage additional roles",
          "lede": "Managing concurrent role assignments for {name}.",
          "primary": "Primary position",
          "additional": "Additional positions",
          "no-candidates": "No eligible vacant positions to oversee.",
          "vacant-only": "Vacant positions only",
          "reason": "Reason / justification"
        },
        "vacant-drawer": {
          "open": "Vacant",
          "title": "Vacant positions",
          "reports-to": "Reports to"
        },
        "disabled-drawer": {
          "open": "Disabled",
          "title": "Disabled positions"
        },
        "drawer": {
          "count": "{count} positions",
          "empty": "Nothing here yet."
        },
        "export": "Export",
        "toast": {
          "added": "Position added.",
          "updated": "Position updated.",
          "moved": "Reporting line updated.",
          "swapped": "Roles swapped.",
          "deleted": "Position deleted.",
          "disabled": "Position disabled.",
          "enabled": "Position enabled.",
          "oversight-disabled": "Temporary oversight disabled.",
          "oversight-soon": "Enabling temporary oversight is coming in a follow-up.",
          "save-failed": "Could not save. Please try again."
        },
        "confirm": {
          "delete-title": "Delete this position?",
          "delete-body": "This permanently removes the position from the org chart. Only vacant leaf positions can be deleted.",
          "disable-title": "Disable this position?",
          "disable-body": "The position is hidden from the chart and every position dropdown. You can re-enable it later.",
          "enable-title": "Enable this position?",
          "enable-body": "The position becomes visible in the chart and selectable again."
        },
        "error": {
          "title": "Could not load the org chart",
          "desc": "Something went wrong fetching positions. Try again."
        },
        "empty": {
          "title": "No org chart yet",
          "desc": "This company has no positions. Add the top position to get started."
        }
      },
      "oversight": {
        "showing": "Showing {filtered} of {total} assignments",
        "confirm-remove": "Remove {name} as an overseer?",
        "error": "Could not load oversight assignments.",
        "toasts": {
          "overseer-removed": "Overseer removed.",
          "remove-failed": "Could not remove overseer. Try again.",
          "assigned": "Oversight assignment saved.",
          "assign-failed": "Could not save assignment. Try again."
        }
      }
    },
    "tenant-settings": {
      "title": "Workspace & Tenant Settings",
      "subtitle": "Manage your organization’s business type, billing, and platform settings",
      "back": "Back to Admin",
      "live": "Live",
      "coming-soon": "Coming soon",
      "coming-soon-tag": "Soon",
      "stub-toast": "{name} is coming soon",
      "denied": {
        "title": "Top-admin access required",
        "body": "Only tenant-wide administrators can manage workspace settings."
      },
      "business-type": {
        "title": "Business Type",
        "desc": "Promote your workspace to an EOR / outsourcing service provider, or revert to a standard organization. Provider tenants manage clients and projects; standard tenants manage vendors.",
        "provider-label": "Outsourcing service provider",
        "status-provider": "Provider",
        "status-standard": "Standard",
        "hint-provider": "Your workspace is set up for staff outsourcing — you manage clients, projects, and external approvers.",
        "hint-standard": "Standard organization. Enable to run a staff-outsourcing business (manage clients and projects).",
        "toggle-aria": "Toggle outsourcing service provider",
        "promoted": "Workspace promoted to outsourcing service provider.",
        "demoted": "Workspace reverted to a standard organization.",
        "error": "Could not update the business type. Please try again.",
        "demote-confirm-title": "Turn off outsourcing provider?",
        "demote-confirm-desc": "This reverts your workspace to a standard organization.",
        "demote-confirm-body": "Existing clients, projects, and their staff are kept — they’re just no longer surfaced as outsourcing until you re-enable this. You can turn it back on at any time.",
        "demote-confirm-cta": "Turn off"
      },
      "sections": {
        "billing": {
          "title": "Billing",
          "desc": "Payment method, invoices, and billing history."
        },
        "address": {
          "title": "Address & Company Info",
          "desc": "Registered address and legal details."
        },
        "subscription": {
          "title": "Subscription & Plan",
          "desc": "Current plan, seats, and renewal."
        },
        "contacts": {
          "title": "Contacts",
          "desc": "Primary and billing contacts."
        }
      }
    },
    "errors": {
      "dialog": {
        "close": "Close",
        "badRequest": {
          "header": "Request couldn't be completed",
          "message": "We couldn't complete that request. Please review and try again."
        },
        "forbidden": {
          "header": "You don't have access",
          "message": "Your account isn't allowed to do that. If you think this is a mistake, contact your administrator."
        },
        "notFound": {
          "header": "Not found",
          "message": "We couldn't find what you were looking for. It may have moved or been removed."
        },
        "server": {
          "header": "Something went wrong on our end",
          "message": "This is on us, not you. Please try again in a moment — if it keeps happening, let us know."
        },
        "network": {
          "header": "Can't reach the server",
          "message": "We couldn't connect right now. Check your internet connection and try again."
        }
      }
    },
    "admin": {
      "users": {
        "title": "Users & Roles",
        "subtitle": "Manage user accounts, employee links, and company-admin access.",
        "add": "Add User",
        "search-placeholder": "Search username, name, or email",
        "result-count": "{count} users",
        "clear-filter": "Clear {name} filter",
        "clear-search": "Clear search",
        "clear-all": "Clear all",
        "select-all": "Select all users",
        "select-row": "Select {name}",
        "row-actions": "Actions for {name}",
        "retry": "Retry",
        "error": "Couldn't load users. Please try again.",
        "error-403": "You don't have permission to view users for this company.",
        "kpi": {
          "enabled": "Enabled",
          "disabled": "Disabled",
          "admin": "Company Admin",
          "temporary": "Temp Passwords"
        },
        "cols": {
          "username": "Username",
          "employee": "Employee",
          "email": "Email",
          "admin-companies": "Administered Companies",
          "access": "Access Status",
          "password": "Password Status",
          "actions": "Actions"
        },
        "access": {
          "enabled": "Enabled",
          "disabled": "Disabled"
        },
        "password": {
          "temporary": "Temporary",
          "confirmed": "Confirmed",
          "unknown": "Unknown"
        },
        "actions": {
          "edit-email": "Edit email",
          "admin-company": "Company admin access",
          "enable": "Enable access",
          "disable": "Disable access",
          "delete": "Delete user"
        },
        "empty": {
          "title": "No users yet",
          "subtitle": "Add a user to link a sign-in account to an employee."
        },
        "empty-filtered": {
          "title": "No matching users",
          "subtitle": "Try a different search or clear the filters."
        },
        "form": {
          "create-title": "Create User",
          "create-subtitle": "Link a sign-in account to an existing employee.",
          "edit-email-title": "Edit User Email",
          "edit-email-subtitle": "Change the email on this user's account.",
          "admin-company-title": "Company Admin Access",
          "admin-company-subtitle": "Choose which companies this user can administer.",
          "employee": "Employee",
          "employee-placeholder": "Select an employee to link to this user",
          "employee-required": "Select an employee to link.",
          "loading-employees": "Loading employees…",
          "username": "Username",
          "first-name": "First Name",
          "last-name": "Last Name",
          "email": "Email",
          "phone": "Phone Number",
          "invalid-email": "Invalid email address.",
          "new-email": "New Email",
          "new-email-placeholder": "Enter new email",
          "selected-user": "Selected User Information",
          "managed-companies": "Companies Currently Managed",
          "managed-companies-desc": "These are the companies this user currently manages. Remove access using the button on each row.",
          "grant-more": "Grant Admin Access to Additional Companies",
          "grant-more-desc": "Select one or more companies to grant admin access. The user can then manage employees, settings, and attendance for them.",
          "remove-company": "Remove {name}",
          "no-companies": "No companies assigned",
          "no-more-companies": "No additional companies available",
          "add": "Add",
          "new": "new",
          "create": "Create",
          "update": "Update",
          "cancel": "Cancel"
        },
        "confirm": {
          "enable-title": "Enable user?",
          "enable-message": "This user will be able to sign in again.",
          "enable": "Enable",
          "disable-title": "Disable user?",
          "disable-message": "This user will no longer be able to sign in.",
          "disable": "Disable",
          "delete-title": "Delete user?",
          "delete-message": "This permanently removes the user's sign-in account. This can't be undone.",
          "delete": "Delete",
          "cancel": "Cancel"
        },
        "toast": {
          "created": "User {name} created.",
          "create-error": "Couldn't create the user.",
          "updated": "User updated.",
          "update-error": "Couldn't update the user.",
          "enabled": "Enabled {name}.",
          "disabled": "Disabled {name}.",
          "deleted": "Deleted {name}.",
          "action-error": "The action failed. Please try again."
        }
      }
    },
    "scope": {
      "all-scopes": "All Scopes",
      "all-companies": "All Companies",
      "this-company": "this company",
      "tenant-fallback": "Tenant",
      "hint": "ownership context",
      "breadcrumb-label": "Active scope",
      "kind": {
        "oversight": "All Scopes · oversight",
        "company": "Company",
        "client": "Client",
        "vendor": "Vendor",
        "project": "Project"
      },
      "empty-notice": "No {label} records for {company}. These are recorded per operating company — this company has none in the sample data. Switch to an operating company or All Scopes."
    },
    "legal": {
      "back-to-sign-in": "Back to sign in",
      "terms": {
        "title": "Terms of Service",
        "updated": "Last updated: 16 June 2026",
        "contact": "Questions about these terms? Contact us at {email}.",
        "sections": [
          {
            "heading": "1. Introduction",
            "body": "These Terms of Service govern your access to and use of the OptimalHR platform, a multi-tenant Human Capital Management service operated by Optimal P HR Strategic Partner Co., Ltd. By signing in or using the service, you agree to these terms on behalf of your organization."
          },
          {
            "heading": "2. Accounts and access",
            "body": "Access is provisioned by your organization’s HR administrator. You are responsible for keeping your credentials confidential and for all activity under your account. Notify your administrator immediately if you suspect unauthorized access."
          },
          {
            "heading": "3. Acceptable use",
            "body": "You agree not to misuse the service, attempt to access data belonging to other tenants, interfere with normal operation, or use the platform in violation of applicable Cambodian law or the labour regulations governing your organization."
          },
          {
            "heading": "4. Customer data",
            "body": "Your organization owns the employee and payroll data it submits. We process that data only to provide the service, under the data-isolation controls described in our Privacy Policy. We do not sell customer data."
          },
          {
            "heading": "5. Service availability",
            "body": "We aim for high availability but do not guarantee uninterrupted service. Scheduled maintenance and updates may temporarily affect access. Critical incidents are communicated to tenant administrators."
          },
          {
            "heading": "6. Changes to these terms",
            "body": "We may update these terms from time to time. Material changes will be communicated to tenant administrators before they take effect. Continued use after changes constitutes acceptance."
          }
        ]
      },
      "privacy": {
        "title": "Privacy Policy",
        "updated": "Last updated: 16 June 2026",
        "contact": "For privacy requests or questions, contact us at {email}.",
        "sections": [
          {
            "heading": "Introduction",
            "body": "This Privacy Policy explains how OptimalHR collects, uses, retains and protects personal information processed through the platform. It applies to all environments (Dev, Staging, Prod) operated for your organization."
          },
          {
            "heading": "Data we collect",
            "body": "We process employee profile data, contact details, employment and contract records, attendance, leave, overtime, and payroll information that your organization enters or uploads. Authentication data is handled by Amazon Cognito."
          },
          {
            "heading": "How we use data",
            "body": "Personal data is used solely to deliver the HR services your organization has configured — processing payroll, tracking attendance and leave, routing approvals, and producing reports. We do not use it for advertising."
          },
          {
            "heading": "Data isolation and security",
            "body": "OptimalHR uses a multi-tenant architecture with isolation enforced at the database (IAM policy) level. Each tenant’s data is partitioned and access-controlled so it cannot be read by another tenant. Sensitive identifiers are never written to operational logs."
          },
          {
            "heading": "Data retention",
            "body": "We retain personal data for as long as your organization maintains its subscription and as required by Cambodian labour and tax law. On termination, data is deleted or returned according to your organization’s instructions."
          },
          {
            "heading": "Your rights",
            "body": "Employees may request access to or correction of their personal data through their HR administrator. Administrators can action these requests within the platform or by contacting our support team."
          },
          {
            "heading": "Contact",
            "body": "Privacy enquiries are handled by our data protection contact below. We respond to verified requests within a reasonable period."
          }
        ]
      }
    }
  }
}
